export default {
  locale: 'pt',
  messages: {
    accountMy: 'A minha conta',
    actions: 'Ações',
    add: 'Adicionar',
    addressAddNew: 'Adicionar um novo endereço',
    addressCity: 'Cidade',
    addressCountries: 'Países',
    addressCountry: 'País',
    addressDeleteConfirmTitle: 'Eliminar um endereço',
    addressDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar este endereço?',
    addressDeleteSuccess: 'Endereço eliminado com sucesso!',
    addressEdit: 'Modificar endereço',
    addressFlags: 'Bandeiras',
    addressInvoice: 'Endereço de faturação',
    addressInvoiceDifferentAsShippingLabel: 'Os dados de faturação são diferentes do endereço de entrega?',
    addressInvoiceSelectionTitle: 'Selecione o seu endereço de faturação',
    addressInvoiceUsedFor: 'Utilizado para a fatura',
    addressInvoiceUse: 'Utilizar para a fatura',
    addressLabel: 'Nome do endereço (ex: Casa, Trabalho)',
    addressLegalInformation: 'Informações legais',
    addressMy: 'Os meus endereços',
    addressName: 'Nome e apelido do destinatário',
    addressNoItems: 'Ainda não guardou nenhum endereço!',
    addressPhone: 'Telefone (necessário para a entrega)',
    addressPostalCode: 'Código postal',
    addressRegion: 'Estado / província',
    addressShipping: 'Endereço de entrega',
    addressShippingSelectionTitle: 'Selecione o seu endereço de entrega',
    addressStreet1: 'Morada',
    addressStreetNumberHint: 'Não se esqueça do número da porta: sem ele a transportadora muitas vezes não encontra a morada.',
    addressPostalCodeInvalid: 'Este código postal não corresponde ao país selecionado.',
    addressPhoneInvalid: 'Este número parece incorreto. A transportadora usa-o para o contactar.',
    addressPhoneMobileHint: 'Recomendamos um telemóvel: a transportadora envia o aviso de entrega por SMS.',
    addressIssueTitle: 'Esta morada tem de ser completada antes do envio',
    addressIssueIncomplete: 'Faltam campos obrigatórios.',
    addressIssuePostalCode: 'Verifique o código postal para o país selecionado.',
    addressIssuePhone: 'É necessário um telefone contactável: a transportadora liga-lhe ou envia o aviso de entrega.',
    addressIssueRegion: 'Selecione o estado ou a província exigida pela transportadora.',
    addressIssueTaxId: 'A alfândega exige um número fiscal para este destino.',
    addressIssueComplete: 'Completar esta morada',
    addressStreet2: 'Complemento de morada (apartamento, andar, código...)',
    administrationTitle: 'Administração',
    affiliationComment: 'Comentário',
    affiliationCommission: 'Comissão',
    affiliationCommissionMultiplePendingAlert: 'Esta lista é uma estimativa: As encomendas e comissões ainda não estão consolidadas!',
    affiliationCommissionPendingAlert: 'Esta encomenda aguarda validação',
    affiliationDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar esta afiliação?',
    affiliationInvoiceTotalTitle: 'Total a receber (IVA incl.)',
    affiliationKey: 'Chave de afiliado',
    affiliationLegalApplyVAT: 'Aplicar IVA?',
    affiliationLegalInformations: 'Informações legais (faturação, NIF...)',
    affiliationMy: 'As minhas afiliações',
    affiliationOptionValidityDays: 'Validade do link de afiliado (dias)',
    affiliationSince: 'Membro desde',
    affiliationViewResultsMy: 'Ver receitas de afiliação',
    affiliations: 'Afiliações',
    alertContactError: 'Não foi possível enviar a sua mensagem! Por favor, tente novamente...',
    alertContactSuccess: 'Recebido com sucesso!',
    alertConversationNoExists: 'Esta conversa não existe!',
    alertFetchApiError: 'O servidor está indisponível de momento...',
    alertFormRequiredFieldsError: 'Por favor, preencha todos os campos obrigatórios!',
    alertGenericError: 'Ocorreu um erro! Por favor, tente mais tarde...',
    alertInstitutionAlreadyExists: 'Esta instituição já existe!',
    alertJsonParseError: 'O servidor devolveu uma resposta inválida...',
    alertOrderValid: 'A sua encomenda está pronta para ser preparada!',
    alertUnauthorized: 'A sua sessão expirou! Por favor, inicie sessão novamente.',
    alertUserAlreadyExists: 'Já existe uma conta com este endereço de e-mail!',
    alertUserRegisterSuccess: 'Damos-lhe as boas-vindas!',
    app404ErrorText: 'Não encontramos o que procura! Volte à página inicial ou à sua conta.',
    app404ErrorTitle: 'Caminho errado...',
    appAccessButton: 'Aceder a {app}',
    appAgreementAcceptButton: 'Ler os termos e condições de uso',
    appAgreementAcceptHelp: 'Pode ler as condições clicando neste link',
    appAgreementAcceptClickHint: 'Clique aqui para marcar e aceitar',
    appAgreementAcceptLabel: 'Li e aceito os termos e condições gerais',
    appApplication: 'Aplicação',
    appBackHomeButton: 'Voltar ao início',
    appBackHomeTitle: 'Perdeu-se...',
    appBugErrorText: 'Ocorreu um problema... PEDIMOS DESCULPA! Por favor, clique no link abaixo para recarregar esta página...',
    appConditionsAcceptTitle: 'Termos e condições de uso',
    appConditionsCheckError: 'Por favor, assinale a caixa confirmando que leu os termos e condições de uso!',
    appConditionsCheckLabel: 'Li e aceito os termos e condições de uso',
    appConditionsCheckSuccess: 'Entendido!',
    appConditionsUpdateDate: 'Atualizado a {date}',
    appConfig: 'Config',
    appConfiguration: 'Configuração',
    appCookieConsentPrivacyLink: 'Consulte a nossa política de privacidade',
    appCookieConsentText: 'Ao continuar a navegar neste site, aceita a utilização de cookies para o bom funcionamento do serviço e para fins estatísticos. Não partilharemos nenhum dado pessoal sem o seu consentimento prévio.',
    appCreateIndexButton: 'Criar índice da base de dados',
    appDataPrivacyCheckButton: 'Leia a nossa política de proteção de dados',
    appDatabase: 'Base de dados',
    appErrorAlertText: 'Algo inesperado aconteceu... Não entre em pânico! Contacte-nos e resolveremos o seu problema o mais rapidamente possível.',
    appErrorAlertTitle: 'Ocorreu um erro!',
    appForceUpdateApp: 'Forçar atualização da App',
    appForceUpdateAppWeb: 'Forçar atualização da Web App',
    appHome: 'Início',
    appMaintenanceModeText: 'Por favor, aguarde um momento e volte a tentar dentro de instantes...',
    appMaintenanceModeTitle: 'Estamos em manutenção',
    appProcessLaunch: 'Processo de lançamento',
    appQuestionLink: 'Tem dúvidas?',
    appRewiewsHeaderText: 'Fabricado em França 🇫🇷 com Amor ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 avaliações no Trustpilot',
    appShopOrderHistory: 'Seguimento da encomenda',
    appStart: 'Crie o seu livro',
    appVersion: 'Versão',
    appVersionCurrent: 'Versão atual da aplicação: {version}',
    appWebsiteAboutUs: 'A nossa história',
    appWebsiteBlog: 'Blog',
    appWebsiteBook: 'O livro',
    appWebsiteConversationAndroid: 'Imprimir SMS de Android',
    appWebsiteConversationInstagram: 'Imprimir mensagens do Instagram',
    appWebsiteConversationIos: 'Imprimir iMessages/SMS de iPhone',
    appWebsiteConversationMessenger: 'Imprimir mensagens do Messenger',
    appWebsiteConversationWhatsapp: 'Imprimir mensagens do WhatsApp',
    appWebsiteConversations: 'Escolha a sua plataforma',
    appWebsiteFaq: 'Perguntas Frequentes',
    appFooterQuestion: 'Tem uma pergunta?',
    appFooterTerms: 'Condições de utilização',
    appWebsitePrices: 'Preços',
    appWelcomeTitle: 'Bem-vindo a {name}',
    apply: 'Aplicar',
    back: 'Voltar',
    by: 'por',
    cancel: 'Cancelar',
    cartAddTo: 'Adicionar ao carrinho',
    cartAuthInfo: 'Por favor, introduza o seu e-mail para continuar...',
    cartContinuePurchase: 'Continuar a comprar',
    cartEmptyError: 'O seu carrinho está vazio...',
    cartItemsRemoveAll: 'Remover tudo',
    cartMy: 'O meu carrinho',
    cartMyEdit: 'Modificar o meu carrinho',
    cartNextStepButton: 'Passar ao passo seguinte',
    cartNoItems: 'Não há nenhum artigo no seu carrinho.',
    cartNote: 'Nota',
    cartProgression: 'Progresso do carrinho',
    cartSalesConditionsAccept: 'Ao confirmar a sua encomenda, aceita as nossas condições de venda.',
    cartSee: 'Ver o meu carrinho',
    cartShipping: 'Entrega',
    cartShippingFeeError: 'Não podemos efetuar entregas nesta morada! Por favor, introduza uma morada diferente.',
    cartStepConfirmationTitle: 'Confirmação',
    cartStepInvoiceTitle: 'Faturação',
    cartStepPaymentTitle: 'Pagamento',
    cartStepPreviewTitle: 'Carrinho',
    cartStepShippingTitle: 'Envio',
    cartTotalShipping: 'Portes de envio',
    cartTotalSubTotal: 'Subtotal',
    cartTotalTax: 'IVA',
    cartTotalTotal: 'Total',
    cartValidButton: 'Confirmar a minha encomenda',
    checkoutEyebrow: 'A sua encomenda',
    checkoutStepUpsellTitle: 'Um exemplar, ou dois?',
    checkoutStepUpsellTitleGroup: 'Um exemplar, dois? Ou mais?',
    checkoutStepUpsellHint: 'Guarde um para si, ofereça outro a alguém, ou ambos.',
    checkoutStepUpsellHintGroup: 'Um para cada: desconto a partir do segundo exemplar.',
    checkoutStepShippingTitle: 'Onde receber o seu livro?',
    checkoutStepShippingHint: 'Imprimimo-lo com cuidado e enviamo-lo para todo o mundo.',
    checkoutStepInvoiceTitle: 'Os seus dados',
    checkoutStepInvoiceHint: 'Para a sua fatura e o acompanhamento da encomenda.',
    checkoutStepPaymentTitle: 'Pagar em total segurança',
    checkoutStepPaymentHint: 'Cartão, Apple Pay, Google Pay: pagamento encriptado.',
    checkoutPdfReadyTitle: 'O seu eBook está pronto',
    checkoutPdfReadyHint: 'Sem envio necessário, finalize a sua encomenda.',
    checkoutSummaryEyebrow: 'Resumo',
    cartReassuranceSecure: 'Pagamento seguro',
    cartReassuranceReturn: 'Satisfação garantida',
    cartReassuranceSupport: 'Apoio ao cliente',
    checkoutPromoEyebrow: 'Código promocional',
    checkoutGiftEyebrow: 'Cartão oferta',
    checkoutGiftCodeLabel: 'Código oferta',
    checkoutGiftCodePlaceholder: 'Introduza o seu código oferta',
    checkoutGiftCodeHint: 'Recebeu um cartão oferta? Introduza o seu código aqui.',
    checkoutGiftToggle: 'Tem um cartão oferta?',
    checkoutAddCopy: 'Adicionar um exemplar',
    checkoutSecondCopyKicker: 'Para si, ou para oferecer',
    checkoutSecondCopyKickerGroup: 'Um para cada um',
    checkoutSecondCopyTitle: 'O exemplar a mais, a metade do preço',
    checkoutSecondCopyTitlePercent: 'O exemplar a mais',
    checkoutSecondCopyFor: 'este exemplar',
    checkoutSecondCopyForGroup: 'o 2.º',
    checkoutSecondCopyChip: '2.º a metade do preço',
    checkoutSecondCopyChipPercent: '2.º com −{percent} %',
    checkoutSecondCopySet: 'Os {count} volumes, juntos',
    checkoutSecondCopyPerBook: 'cada livro',
    checkoutSecondCopySetPrice: '{price} pelos {count} volumes',
    checkoutExtraBooksChip: 'livros a mais a metade do preço',
    checkoutExtraBooksChipPercent: 'livros a mais a −{percent} %',
    checkoutGroupQtyHint: 'O terceiro também: cada livro a mais, a −{percent} %.',
    productExtraCopyRate: 'Livros a mais, em % do preço de um livro',
    productExtraCopyRateHelp: 'Cada livro depois do primeiro exemplar fica a esta percentagem do preço de um livro. Vazio: 50 %. 0: escalões de quantidade.',
    checkoutGroupPicksLabel: 'Exemplares',
    checkoutGroupAddSecond: '2.º',
    checkoutGroupAddThird: '3',
    checkoutGroupAddSecondAria: 'Adicionar o segundo exemplar a metade do preço',
    checkoutGroupAddThirdAria: 'Passar a três exemplares',
    checkoutQtyGroupHint: 'Um para cada um: o desconto começa no segundo exemplar.',
    checkoutQtyPdfSingle: '1 eBook',
    checkoutQtyMoreAriaLabel: 'Outra quantidade',
    checkoutQtyVolumeBreakdown: '{copies} exemplares × {volumes} volumes = {total} livros',
    checkoutOfferBookCount: '{count, plural, one {# livro} other {# livros}}',
    checkoutUpsellTwoHint: 'Ideal para oferecer: adicione um segundo exemplar, o desconto é aplicado automaticamente.',
    checkoutEmptyTitle: 'Nenhuma encomenda em curso',
    checkoutEmptyHint: 'Volte ao seu livro para escolher a sua edição.',
    checkoutEmptyCta: 'Ver as minhas conversas',
    checkoutBookAsideEyebrow: 'O seu livro',
    checkoutBookAsideEyebrowPlural: 'Os seus livros',
    checkoutBookAsideVolume: 'volume',
    checkoutBookAsideVolumes: 'volumes',
    checkoutBookAsideShelfLabel: 'Os {count} volumes da sua encomenda',
    checkoutBookAsideEbook: 'eBook',
    checkoutBookAsidePaper: 'Livro impresso',
    checkToggler: 'Selecionar/Desmarcar tudo',
    choose: 'Escolher',
    close: 'Fechar',
    cmsDeleteConfirmTitle: 'Eliminar o conteúdo',
    cmsDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar este conteúdo?',
    companyShippingEdit: 'Modificar transporte',
    conditions: 'Condições',
    configMissingKeyAlert: 'Falta a chave de configuração!',
    configuration: 'Configuração',
    confirm: 'Confirmar',
    confirmMessage: 'Por favor, confirme a sua ação.',
    confirmTitle: 'Tem a certeza?',
    contactButton: 'Contacte-nos',
    contactMessage: 'Mensagem',
    contactPageButton: 'Enviar',
    contactPageText1: 'Precisa de ajuda? Informações? Estamos aqui para si!',
    contactPageTitle: 'Contacte-nos',
    contactSend: 'Enviar',
    continue: 'Continuar',
    conversationActionContinue: 'Continuar',
    conversationActionRestart: 'Começar de novo',
    conversationAddTitle: 'Adicionar uma conversa',
    conversationAdminDeleteConfirmTitle: 'Eliminar a conversa',
    conversationAdminDeleteConfirmMessage: 'Esta conversa e todos os seus ficheiros multimédia serão eliminados definitivamente. Esta ação é irreversível.',
    conversationArchiveError: 'Não conseguimos ler o seu ficheiro! Por favor, contacte-nos para resolver o problema...',
    conversationBookOrderTypeBook: 'Livro em papel + eBook(s) de oferta',
    conversationBookOrderTypePdf: 'Apenas eBook(s)',
    conversationBookPreview: 'Pré-visualização',
    conversationBookPreviewSelected: 'Pré-visualização do livro n°{number}',
    conversationBookSelector: 'Selecione o livro a modificar',
    conversationBookTypeLabelBook: 'Papel + Ebook',
    conversationBookTypeLabelPdf: 'Apenas Ebook',
    conversationBooks: 'Livros',
    conversationCollectorArchiveSelectButton: 'Carregar um ficheiro',
    conversationCollectorInitWaiting: 'Estamos a preparar os seus dados... Por favor, aguarde',
    conversationCollectorUseArchive: 'Carregar uma cópia de segurança (ficheiro .zip)',
        conversationCoverBookEdit: 'Personalizar a capa',
    conversationCoverBookReset: 'Repor a capa deste livro',
    conversationCoverApplyToAllBooks: 'Aplicar esta capa a todos os tomos',
    conversationCoverAutoAppliedToAllBooks: 'Capa aplicada aos outros tomos.',
    conversationCoverApplyToAllBooksTitle: 'Aplicar esta capa a todos os tomos?',
    conversationCoverApplyToAllBooksMessage: 'Escolha os elementos a aplicar a todos os outros tomos.',
    conversationCoverApplyOptionColor: 'Cor',
    conversationCoverApplyOptionPhoto: 'Foto',
    conversationCoverApplyOptionTitle: 'Título',
    conversationCoverApplyOptionSubtitle: 'Subtítulo',
    conversationCoverBookSwitchAlertMessage: 'Apenas serão guardadas as informações da capa para este livro específico.',
    conversationCoverBookSwitchAlertTitle: 'Deseja guardar a capa para este livro?',
    conversationCoverColorEditTitle: 'Escolha a sua capa',
    conversationCoverLuxEyebrow: 'A sua capa',
    conversationCoverLuxHint: 'Escolha o modelo e a cor, depois personalize a capa.',
    conversationParticipantsLuxEyebrow: 'A sua conversa',
    conversationParticipantsLuxHint: 'Edite nomes, cores das bolhas e posição esquerda/direita de cada participante.',
    conversationParticipantsLuxSavePreview: 'Guardar · voltar à pré-visualização',
    conversationParticipantsLuxSaved: 'Guardado',
    conversationParticipantsSameSideHint: 'Vários participantes estão do mesmo lado. Verifique a posição esquerda/direita.',
    conversationParticipantColorBlushClair: 'Blush claro',
    conversationParticipantColorCielClair: 'Céu claro',
    conversationParticipantColorLavandeClaire: 'Lavanda clara',
    conversationParticipantColorPruneClaire: 'Ameixa clara',
    conversationParticipantColorPecheClaire: 'Pêssego claro',
    conversationParticipantColorSaugeClair: 'Sálvia clara',
    conversationParticipantColorMiel: 'Mel',
    conversationParticipantColorPerle: 'Pérola',
    conversationParticipantNameError: 'O nome é demasiado longo (máx. {max} caracteres)',
    conversationParticipantPositionLeft: 'Esquerda',
    conversationParticipantPositionRight: 'Direita',
    conversationDatesLuxEyebrow: 'A sua história',
    conversationDatesLuxHint: 'Escolha a data de início e de fim do livro. Clique numa mensagem para afinar a seleção.',
    conversationDatesLuxNextEnd: 'Data de fim',
    conversationDatesLuxBackStart: 'Data de início',
    conversationDatesLuxSavePreview: 'Guardar · voltar à pré-visualização',
    conversationDatesPresetsLabel: 'Seleção rápida de período',
    conversationDatesPreset_all: 'Conversa inteira',
    conversationDatesPreset_year: 'Último ano',
    conversationDatesPreset_sixMonths: 'Últimos 6 meses',
    conversationDatesSelectionCount: '{count, number} {count, plural, one {mensagem} other {mensagens}}',
    conversationDatesSelectionPeriod: 'de {start} a {end}',
    conversationDatesStoryDuration: 'Esta seleção cobre {duration}',
    conversationDatesStartCaption: 'A sua primeira mensagem',
    conversationDatesEndCaption: 'A sua última mensagem',
    conversationDatesBookMessages: '{messages, number} {messages, plural, one {mensagem} other {mensagens}}, {photos, number} {photos, plural, one {foto} other {fotos}} e {medias, number} {medias, plural, one {média} other {médias}} na sua seleção',
    conversationDateSelectionEmpty: 'Nenhuma mensagem neste período. Amplie a seleção.',
    conversationMessagesLuxEyebrow: 'O seu livro',
    conversationMessagesLuxHint: 'Pesquise, oculte ou edite mensagens. As suas alterações aplicam-se à sua seleção.',
    conversationMessagesLuxSavePreview: 'Guardar · voltar à pré-visualização',
    conversationMessagesLuxBackPreview: 'Ver a pré-visualização',
    conversationMessagesLuxCount: '{messages, number} {messages, plural, one {mensagem} other {mensagens}}, {photos, number} {photos, plural, one {foto} other {fotos}} e {medias, number} {medias, plural, one {média} other {médias}} na sua seleção',
    conversationMessagesFilterResults: '{count, number} {count, plural, one {resultado} other {resultados}}',
    conversationMessagesOnlyHidden: 'Apenas ocultas',
    conversationMessagesResetFilters: 'Repor os filtros',
    conversationMessagesShowHidden: 'Mostrar as mensagens ocultas',
    conversationMessagesResetChanges: 'Anular todas as alterações',
    conversationMessagesResetChangesButton: 'Anular tudo',
    conversationMessagesResetChangesConfirm: 'A conversa será restaurada ao seu estado importado original. Todas as suas alterações (mensagens ocultas, editadas ou adicionadas) serão perdidas definitivamente. Continuar?',
    conversationMediaTypePhotos: 'Fotos',
    conversationMediaTypeVideos: 'Vídeos',
    conversationMediaTypeAudios: 'Áudios',
    conversationMediaTypeLinks: 'Ligações',
    conversationMediaTypeOther: 'Outros',
    conversationMessagesToolSearch: 'Pesquisar',
    conversationMessagesToolMedias: 'Média',
    conversationMessagesToolDates: 'Datas',
    conversationMessagesToolHidePeriod: 'Ocultar um período',
    conversationMessagesToolHidden: 'Apresentação',
    conversationMessagesToolReset: 'Alterações',
    conversationMessagesToolResetNone: 'Nenhuma',
    conversationMessagesToolResetCount: '{count, number} {count, plural, one {alteração} other {alterações}}',
    conversationMessagesHiddenViewHint: 'Escolha quais mensagens aparecem na lista abaixo.',
    conversationMessagesHiddenViewAll: 'Todas',
    conversationMessagesHiddenViewVisible: 'Apenas visíveis',
    conversationMessagesHiddenViewHidden: 'Apenas ocultas',
    conversationMessagesResetChangesHint: 'Restaura a conversa ao seu estado original importado. Todas as suas alterações (mensagens ocultas, editadas ou adicionadas) serão perdidas.',
    conversationMessagesToolSearchNone: 'Nenhuma',
    conversationMessagesToolMediasAll: 'Todas as mensagens',
    conversationMessagesToolDatesAll: 'Todo o período',
    conversationMessagesToolHidePeriodNone: 'Sem período',
    conversationMessagesToolHiddenShown: 'Apresentadas',
    conversationMessagesToolHiddenMasked: 'Ocultas',
    conversationMessagesBestofCuratedHint: 'O seu Best Of já está montado: está preenchido até ao número máximo de páginas. Pode ocultar mensagens e voltar a mostrar outras, desde que o livro não fique mais longo.',
    conversationMessagesBestofFullError: 'O seu Best Of já está completo. Para mostrar estas mensagens, oculte primeiro cerca de {pages, number} {pages, plural, one {página} other {páginas}} noutro sítio.',
    conversationMessagesHidePeriodHint: 'Oculte (ou volte a mostrar) todas as mensagens entre duas datas de uma só vez.',
    conversationMessagesHidePeriodFrom: 'De',
    conversationMessagesHidePeriodTo: 'Até',
    conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {mensagem} other {mensagens}} neste período ({visible} visíveis, {hidden} ocultas)',
    conversationMessagesHidePeriodConfirmHide: 'Ocultar {count, number} {count, plural, one {mensagem} other {mensagens}} deste período?',
    conversationMessagesHidePeriodConfirmShow: 'Voltar a mostrar {count, number} {count, plural, one {mensagem} other {mensagens}} deste período?',
    conversationMessagesHidePeriodHide: 'Ocultar este período',
    conversationMessagesHidePeriodShow: 'Voltar a mostrar este período',
    conversationMessagesHidePeriodItem: 'Período {index}',
    conversationMessagesHidePeriodAdd: 'Adicionar um período',
    conversationMessagesHidePeriodInvalid: 'A data de fim deve ser posterior à data de início.',
    conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {período} other {períodos}}',
    conversationMessagesSearchPlaceholder: 'Pesquisar uma palavra, um nome…',
    conversationCoverResumeLuxEyebrow: 'Prefácio',
    conversationCoverResumeLuxHint: 'Opcional: este texto é impresso na contracapa.',
    conversationCoverBookNumber: 'Volume {number}',
    conversationCoverFooterPrefaceGuide: 'Volte à pré-visualização para ignorar o prefácio, ou continue para o redigir (opcional, na contracapa).',
    conversationCoverFooterNextPreface: 'Prefácio (opcional)',
    conversationCoverFooterSkipPreface: 'Ignorar prefácio · voltar à pré-visualização',
    conversationCoverFooterBackToCover: 'Voltar à capa',
    conversationCoverFooterFinishPreview: 'Concluir · voltar à pré-visualização',
    conversationCoverFooterGoPreview: 'Voltar à pré-visualização',
    conversationCoverEditionTypeTitle: 'Tipo de edição do livro',
    conversationCoverEditionTypeBookHelp: 'Na coleção completa, personalize a capa de cada volume.',
    conversationCoverColorSelectorHelp: 'Selecione a cor da capa',
    conversationCoverStyleSelectorHelp: 'Escolha o modelo da capa',
    conversationCoverStylePhoto: 'Polaroid',
    conversationCoverStyleIncipit: 'Primeira mensagem',
    conversationCoverPickMessageTitle: 'Escolher uma mensagem',
    conversationCoverEditQuote: 'Alterar a frase',
    conversationCoverPickMessageHint: 'Fica em grande na capa.',
    conversationCoverPickMessageSearch: 'Procurar uma mensagem',
    conversationCoverPickMessageEmpty: 'Nenhuma mensagem corresponde.',
    conversationCoverAddQuote: 'Adicionar uma frase',
    conversationCoverHourLabel: 'Hora',
    conversationCoverDateLabel: 'Data',
    conversationCoverGroupNameLabel: 'Nome do grupo',
    conversationCoverSpanLabel: 'Datas da primeira e da última mensagem',
    conversationCoverApplyOptionStyle: 'Modelo',
    conversationCoverApplyOptionQuote: 'Frase',
    conversationCoverDragNDropFiles: 'Arraste e solte uma imagem aqui',
    conversationCoverTapToSelectPhoto: 'Toque para escolher uma foto',
    conversationCoverOpenFinder: 'Selecione uma imagem',
    conversationCoverPhotoSelectorTitle: 'Escolha uma foto',
    conversationCoverPhotoEditHint: 'Clique para alterar a foto',
    conversationCoverPhotoChoose: 'Clique para escolher uma fotografia',
    conversationPreviewSwipeHint: 'Deslize para virar as páginas',
    conversationPreviewOpenBookHint: 'Deslize a capa para abrir o livro',
    conversationPreviewDiscoverBook: 'Descubra o meu livro',
    conversationPreviewVolumesLabel: 'A sua coleção: {count} livros',
    conversationPreviewVolumesHint: 'Toque numa capa para abrir esse volume.',
    conversationCoverResumeEditTitle: 'Escreva uma dedicatória ou prefácio (opcional)',
    conversationCoverResumeError: 'Prefácio demasiado longo para uma página: encurte o texto ou reduza as quebras de linha.',
    conversationCoverResumeNearLimit: 'Limite de uma página quase atingido ({lines}/{max} linhas).',
    conversationCoverResumeHelp: 'Este prefácio será impresso na contracapa interior do seu livro.',
    conversationCoverResumePlaceholder: 'Escreva algumas palavras para introduzir a sua história',
    conversationCoverResumeReset: 'Repor o prefácio deste livro',
    conversationCoverTitleError: 'Título demasiado longo (máx: {max} caracteres)',
    conversationCoverTitleHelp: 'Clique para modificar o título do livro',
    conversationCoverTitlePlaceholder: 'Escreva um título...',
    conversationCoverDefaultTitleTwoNames: '{name1} e {name2}',
    conversationCoverDefaultTitleGroup: 'O nosso grupo',
    conversationCoverDefaultTitleSingle: 'As minhas mensagens',
	conversationCoverWaitingForCustomization: 'Poderá personalizar a capa do seu livro no próximo passo...',
    conversationCreateInfoText: 'Crie um novo livro de mensagens clicando nos ícones aqui',
    conversationCreateMyBookTitle: 'Criar o meu livro',
    conversationCreateTitle: 'Criar um livro',
    conversationDateCreation: 'Data de criação',
    conversationDateDownloadedInfo: 'O livro foi descarregado a {downloaded}',
    conversationDateEnd: 'Fim da conversa',
    conversationDateEndInfo: 'O livro termina a {end}',
    conversationDateEndLabel: 'Selecionar a data de fim',
    conversationDateEndMessageSelection: 'Terminar o livro aqui',
    conversationDateGeneratedInfo: 'O livro foi gerado a {generated}',
    conversationDateRange: 'De {start} a {end}',
    conversationDeleteConfirmation: 'A conversa foi eliminada!',
    conversationDateSelectionAlert: 'Parece que a sua conversa foi danificada durante a transferência. Por favor, tente novamente permanecendo na página durante a transferência e garantindo uma boa ligação à internet.',
    conversationDateSimulatedInfo: 'O livro foi pré-visualizado a {simulated}',
    conversationDateStart: 'Início da conversa',
    conversationDateStartInfo: 'O livro começa a {start}',
    conversationDateStartLabel: 'Selecionar a data de início',
    conversationDateStartMessageSelection: 'Começar o livro aqui',
    conversationDatesEditTitle: 'Seleção de datas',
    conversationPreviewPrefaceOptionalBadge: 'Opcional',
    conversationPreviewPrefaceEmptyTitle: 'Um prefácio, se quiser',
    conversationPreviewPrefaceEmptyText: 'Algumas palavras para abrir o livro. Pode saltar este passo e voltar quando quiser.',
    conversationPreviewPrefaceEmptyButton: 'Adicionar um prefácio',
    conversationPreviewEndCta: 'Encomendar agora',
    conversationPreviewEndBodyPaused: 'Valide as suas alterações. A versão digital chega-lhe por e-mail logo a seguir, para a verificar.',
    conversationPreviewEndCtaPaused: 'Validar as minhas alterações',
    conversationDemoAlert: 'Agora vai poder descobrir as primeiras páginas do seu livro.<br></br>Após realizar a encomenda, receberá a versão completa para rever antes da impressão.',
    conversationDemoEndAlert: 'Poderá descobrir o resto das suas mensagens após confirmar a sua compra.',
    conversationPreviewEndTitle: 'O resto espera por si',
    conversationPreviewEndBody: 'O resto das mensagens espera por si. Encomende para ver o livro na íntegra.',
    conversationPreviewDemoBadge: 'MonLivreSMS',
    conversationPreviewPrefaceEmptyTitle: 'O seu prefácio (opcional)',
    conversationPreviewPrefaceOptionalBadge: 'Opcional',
    conversationPreviewPrefaceEmptyText: 'Algumas palavras para abrir o livro. Pode saltar este passo e voltar quando quiser.',
    conversationPreviewPrefaceEmptyButton: 'Escrever o meu prefácio',
    conversationPreviewPrefaceEditButton: 'Editar prefácio',

    conversationDisclaimerSubtitle: 'Escolha o seu formato para aceder à nossa oficina de personalização.',
    conversationDisclaimerTitle: `{count} {count, plural,
      =0 {mensagem}
      =1 {mensagem}
      other {mensagens}
    }: uma história que merece ser lida`,
    conversationDisclaimerSavings: 'Poupa {value}',
    conversationDisclaimerEBookIncluded: 'Edição Ebook incluída',
    conversationDisclaimerGenerating: 'A gerar o seu livro...',

    conversationDisclaimerPlanSingleTitle: 'O Volume 1',
    conversationDisclaimerPlanSingleDescription: 'O Essencial',
    conversationDisclaimerPlanSingleButtonText: 'Criar o meu livro',
    conversationDisclaimerPlanSingleFeaturePages: 'O livro da sua escolha (400 páginas) entregue',
    conversationDisclaimerPlanSingleFeatureQuality: '',
    conversationDisclaimerPlanSingleFeatureEvolutive: 'Evolutivo: complete a coleção mais tarde',
    conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Papel Premium',
    conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Impressão em Papel Premium',
    conversationDisclaimerPlanSingleFeaturePdfIncluded: 'Versão PDF incluída (Valor: {price})',
    conversationDisclaimerPlanSingleFeatureWorkshop: 'Personalização completa de oferta',
    conversationDisclaimerPlanSingleFeatureMedia: 'Fotos, Vídeos e Áudios incluídos',

    conversationDisclaimerPlanCollectionTitle: 'A Coleção Completa',
    conversationDisclaimerPlanCollectionDescription: 'A Integral',
    conversationDisclaimerPlanCollectionButtonText: 'Guardar toda a nossa história',
    conversationDisclaimerPlanCollectionBadge: 'OFERTA PACK -{percentage}%',
    conversationDisclaimerPlanCollectionFeatureBox: 'Os seus {count} livros impressos e entregues',
    conversationDisclaimerPlanCollectionFeatureDiscount: 'Tarifa Coleção -{percentage}% (-{amount} incluídos)',
    conversationDisclaimerPlanCollectionFeatureDigital: 'Edição digital de oferta',
    conversationDisclaimerPlanCollectionFeatureWorkshop: 'Personalização completa de oferta',
    conversationDisclaimerPlanCollectionFeatureMedia: 'Fotos, Vídeos e Áudios incluídos',

    conversationDisclaimerPlanEbookTitle: 'A Edição Ebook',
    conversationDisclaimerPlanEbookDescription: 'O Formato Digital',
    conversationDisclaimerPlanEbookButtonText: 'Guardar em PDF',
    conversationDisclaimerPlanEbookFeaturePdf: 'PDF Alta Definição imediato',
    conversationDisclaimerPlanEbookFeatureShare: 'Fácil de partilhar',
    conversationDisclaimerPlanEbookFeatureMessages: 'A totalidade das suas {count} mensagens',
    conversationDisclaimerPlanEbookFeatureMedia: 'Fotos, Vídeos e Áudios incluídos',

    conversationDisclaimerReassuranceGuaranteeTitle: 'Garantia de Satisfação',
    conversationDisclaimerReassuranceGuaranteeDescription: 'Reembolso garantido a pedido até à validação final.',
    conversationDisclaimerReassuranceCustomTitle: 'Personalização Livre',
    conversationDisclaimerReassuranceCustomDescription: 'Modifique a sua capa e as mensagens após o pagamento',
    conversationDisclaimerReassuranceSecureTitle: 'Pagamento 100% Seguro',
    conversationDisclaimerReassuranceSecureDescription: 'Cartão bancário, Apple Pay, Google Pay',
    conversationDisclaimerReassuranceDeliveryTitle: 'Entrega Rápida',
    conversationDisclaimerReassuranceDeliveryDescription: 'Entrega na sua morada em 5 dias úteis',

    conversationDisclaimerReviewSuffix: 'em +{count} livros impressos',

    conversationDowloadUnableAlert: 'Já não pode descarregar os livros desta conversa... Contacte-nos para resolver o problema.',
    conversationDownloadDeadlineInfo: 'Pode descarregar os seus ficheiros até {date}',
    conversationDownloadLink: 'Descarregar o meu livro N°{index}',
    conversationDownloadFileCoverLink: 'Descarregar a capa {name}',
    conversationDownloadFileSourceLink: 'Descarregar o ficheiro de origem {name}',
    conversationDownloadPdfButton: 'Descarregar o E-book',
    conversationDownloadPdfWaitingMessage: 'Aguarde 5 minutos para voltar a descarregar',
    conversationEditStart: 'Editar o livro',
    conversationEditSuccess: 'A conversa foi atualizada!',
    'conversationFormatLabelA4-1': 'Crónicas das suas memórias',
    'conversationFormatLabelA4-2': '(álbum A4)',
    'conversationFormatLabelA5-1': 'O pequeno tesouro',
    'conversationFormatLabelA5-2': '(formato A5)',
    conversationGeneratedSuccess: 'Muitos parabéns! <br></br> A sua conversa foi gerada com sucesso!',
        conversationGenerationAlert: 'Estamos a compor o seu livro…',
        conversationGenerationAlert2: 'Fique connosco, demora apenas um momento.',
        conversationGenerationFailed: 'A composição do seu livro foi interrompida.',
        conversationGenerationFailedHint: 'As suas mensagens estão bem guardadas. Tente novamente e, se voltar a acontecer, escreva-nos: analisamos a situação consigo.',
        conversationGenerationRetry: 'Tentar novamente',
    conversationHelpBooksText: 'Mude entre os seus livros para modificar a informação específica de cada um',
    conversationHelpBooksTitle: 'Seleção do livro',
    conversationHelpCoverColorText: 'Pode mudar a cor de fundo da capa clicando no círculo.',
    conversationHelpCoverColorTitle: 'Cor da capa',
    conversationHelpCoverImageText: 'Pode arrastar e soltar qualquer imagem neste espaço para adicioná-la à sua capa.',
    conversationHelpCoverImageTitle: 'Imagem de capa',
    conversationHelpCoverTitleText: 'Clique no título para o modificar! Tem 2 linhas disponíveis: Título e Subtítulo.',
    conversationHelpCoverTitleTitle: 'Título da capa',
    conversationHelpDatePreviewText: 'Selecione a data de início da sua história.',
    conversationHelpDatePreviewTitle: 'Data',
    conversationHelpDateSelectorText: 'Ao alterar a data, as suas primeiras e últimas mensagens serão mostradas aqui!',
    conversationHelpDateSelectorTitle: 'Pré-visualização da mensagem',
    conversationHelpParticipantColorText: 'Pode mudar a cor dos balões de cada participante para lhes dar um toque único.',
    conversationHelpParticipantColorTitle: 'Cor dos participantes',
    conversationHelpParticipantNameText: 'Modifique o nome do participante como mais gostar!',
    conversationHelpParticipantNameTitle: 'Nome do participante',
    conversationHelpParticipantPositionText: 'Escolha se prefere mostrar as mensagens deste participante à esquerda ou à direita.',
    conversationHelpParticipantPositionTitle: 'Posição do participante',
	conversationHelpMessagesToolsTitle: 'Ferramentas',
	conversationHelpMessagesToolsText: 'Toque num cartão para pesquisar, filtrar por médias ou datas, ou ocultar mensagens.',
	conversationHelpMessagesSearchTitle: 'Pesquisa',
	conversationHelpMessagesSearchText: 'Escreva uma palavra ou um nome para encontrar uma mensagem rapidamente.',
	conversationHelpMessagesMediasTitle: 'Médias',
	conversationHelpMessagesMediasText: 'Filtre as mensagens que contêm fotos, vídeos, áudios ou links.',
	conversationHelpMessagesDatesTitle: 'Datas',
	conversationHelpMessagesDatesText: 'Fique só com as mensagens entre duas datas para se concentrar numa parte da conversa.',
	conversationHelpMessagesHidePeriodTitle: 'Ocultar um período',
	conversationHelpMessagesHidePeriodText: 'Escolha duas datas para ocultar (ou voltar a mostrar) todo um período de uma vez.',
	conversationHelpMessagesHiddenTitle: 'Visualização',
	conversationHelpMessagesHiddenText: 'Mostre todas as mensagens, só as visíveis ou só as ocultas.',
	conversationHelpMessagesListTitle: 'Editar uma mensagem',
	conversationHelpMessagesListText: 'Em cada balão: selecionar, ocultar, editar o texto ou inserir uma nova.',
	conversationHelpMessagesFooterTitle: 'Voltar à pré-visualização',
	conversationHelpMessagesFooterText: 'Quando estiver pronto, volte à pré-visualização para ver o seu livro atualizado.',
    conversationHelpPreviewBookCoverText: 'Dê-lhe uma capa única. Clique para a personalizar.',
    conversationHelpPreviewBookCoverTitle: 'Capa do livro',
    conversationHelpPreviewBookPreviewText: 'Pré-visualize um volume específico clicando aqui!',
    conversationHelpPreviewBookPreviewTitle: 'Pré-visualização do livro',
    conversationHelpPreviewBookSelectorText: 'Escolha os volumes que deseja imprimir.',
    conversationHelpPreviewBookSelectorTitle: 'Seletor de livros',
    conversationHelpPreviewBookSplitText: 'Ao marcar esta caixa, todos os seus livros terão o mesmo número de páginas para uma coleção uniforme.',
    conversationHelpPreviewBookSplitTitle: 'Páginas do livro',
        conversationHelpPreviewCopyText: 'Encomende vários exemplares: para si ou para oferecer. Desconto a partir do 2.º exemplar.',
        conversationHelpPreviewCopyTitle: 'Oferecer um exemplar',
        conversationHelpPreviewFormatText: 'Livro em papel ou eBook digital: escolha o que lhe faz mais sentido.',
        conversationHelpPreviewFormatTitle: 'Formato',
        conversationHelpPreviewRenderText: 'Aqui está o seu livro. Personalize a capa diretamente, depois percorra as páginas.',
        conversationHelpPreviewRenderTitle: 'O seu livro',
	conversationHelpPreviewMessagesText: 'Toque neste cartão para editar o conteúdo das mensagens.',
	conversationHelpPreviewMessagesTitle: 'Mensagens',
	conversationHelpPreviewDatesText: 'Toque neste cartão para escolher as datas de início e fim do seu livro.',
	conversationHelpPreviewDatesTitle: 'Datas',
	conversationHelpPreviewParticipantsText: 'Toque neste cartão para alterar os nomes e o aspeto dos participantes.',
	conversationHelpPreviewParticipantsTitle: 'Participantes',
	conversationHelpPreviewCoverTitleText: 'Clique no título ou no subtítulo para os editar.',
	conversationHelpPreviewCoverTitleTitle: 'Título e subtítulo',
	conversationHelpPreviewVolumesTitle: 'Vários volumes',
	conversationHelpPreviewVolumesText: 'A sua conversa ocupa vários livros. Toque num número para mudar de volume e personalizar cada capa.',
	conversationHelpPreviewCoverImageText: 'Toque na zona da foto para adicionar ou alterar a imagem da capa.',
	conversationHelpPreviewCoverImageTitle: 'Foto',
	conversationHelpPreviewCoverColorText: 'Toque numa pastilha para mudar a cor de fundo da capa.',
	conversationHelpPreviewCoverColorTitle: 'Cor',
        conversationHelpPreviewValidText: 'Quando estiver tudo pronto, confirme. O eBook chega por e-mail, o livro em casa.',
        conversationHelpPreviewValidTitle: 'Vamos lá!',

    conversationHighlightStartDateTitle: 'A primeira mensagem',
    conversationHighlightStartDateDescription: 'Nesse dia saiu a primeira mensagem. O resto nasceu daí.',
    conversationHighlightDurationTitle: 'Juntos desde',
    conversationHighlightDurationDescription: 'Todos estes dias juntos, desde essa primeira mensagem.',
    conversationHighlightMessagesCountTitle: 'Mensagens',
    conversationHighlightMessagesCountDescription: 'Todas estas mensagens, trocadas desde {date}.',
    conversationHighlightImagesCountTitle: 'Fotografias',
    conversationHighlightImagesCountDescription: 'Estas fotografias, guardadas da nossa conversa.',
    conversationHighlightMediasCountTitle: 'Vídeos e áudios',
    conversationHighlightMediasCountDescription: 'Para voltar a ouvir uma voz e rever esse momento.',
    conversationHighlightSpecialDayMessagesCountTitle: 'Num só dia',
    conversationHighlightSpecialDayMessagesCountDescription: 'O nosso recorde: todas estas mensagens num só dia.',
    conversationHighlightSpecialDayTitle: 'Esse dia',
    conversationHighlightSpecialDayDescription: 'O dia em que mais nos escrevemos.',
    conversationHighlightCharsCountReferenceDiffTitle: 'Romeu e Julieta',
    conversationHighlightCharsCountReferenceDiffDescription: 'O texto de Romeu e Julieta, tantas vezes.',
    conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} vezes',
    conversationHighlightTypingDurationTitle: 'Escrita',
    conversationHighlightTypingDurationDescription: 'Tantas horas só para nos escrevermos.',
    conversationHighlightUnitDays: '{count, plural, one {dia} other {dias}}',
    conversationHighlightUnitMessages: '{count, plural, one {mensagem} other {mensagens}}',
    conversationHighlightUnitHours: '{count, plural, one {hora} other {horas}}',
    conversationHighlightUnitTimes: 'vezes',

    conversationHighlightBadge: 'Em poucos números',
    conversationHighlightStoryKicker: 'A sua história',
    conversationHighlightsMomentsCount: '{count, plural, one {# imagem para descarregar} other {# imagens para descarregar}}',
    conversationHighlightShareFormat: 'Formato story',
    conversationHighlightsCardFooter: 'Algumas histórias merecem um livro',
    conversationHighlightShareButton: 'Descarregar',
    conversationHighlightShareButtonAlt: 'Ver as estatísticas da conversa',
    conversationHighlightSubtitle: 'Os números do que se disseram.',
    conversationHighlightTitle1: 'As suas mensagens',
    conversationHighlightTitle2: 'em alguns números',
    conversationHighlightOpenStoryButton: 'Abrir esta story',
    conversationHighlightsAtGlanceEyebrow: 'Num relance',
    conversationHighlightsAtGlanceTitle: 'A dimensão da sua história',
    conversationHighlightsNoAiNote: 'Estas estatísticas são calculadas automaticamente, sem IA.',
    conversationHighlightsKpiMessages: 'mensagens',
    conversationHighlightsKpiWords: 'palavras escritas',
    conversationHighlightsKpiActiveDays: 'dias ativos',
    conversationHighlightsKpiStreak: 'dias seguidos',
    conversationHighlightsRhythmEyebrow: 'O seu ritmo',
    conversationHighlightsRhythmTitle: 'Quando as suas mensagens ganham vida',
    conversationHighlightsTopHour: 'A sua hora',
    conversationHighlightsTopWeekday: 'O seu dia',
    conversationHighlightsNightMessages: 'Mensagens à noite',
    conversationHighlightsChartMonths: 'Todos os meses, da primeira à última mensagem',
    conversationHighlightsChartYears: 'Todos os anos, da primeira à última mensagem',
    conversationHighlightsLessThanOneMinute: 'menos de 1 min',
    conversationHighlightsSpanLessThanMonth: 'Menos de um mês',
    conversationHighlightsSpanYears: '{count, plural, one {# ano} other {# anos}}',
    conversationHighlightsSpanMonths: '{count, plural, one {# mês} other {# meses}}',
    conversationHighlightsSpanYearsMonths: '{years, plural, one {# ano} other {# anos}} e {months, plural, one {# mês} other {# meses}}',
    conversationHighlightsSpanLabel: 'Da primeira à última mensagem',
    conversationHighlightsBusiestDayLabel: 'Dia mais falador',
    conversationHighlightsPhotosLabel: 'Fotos',
    conversationHighlightsMediasLabel: 'Vídeos e notas de voz',
    conversationHighlightsBookPagesLabel: 'O seu livro',
    conversationHighlightsBookPagesPrefix: 'cerca de',
    conversationHighlightsBookPagesUnit: '{count, plural, one {página} other {páginas}}',
    conversationHighlightsBookPagesNote: 'Estimativa a partir das mensagens e das fotos.',
    conversationHighlightsWritingHours: 'Cerca de {count, plural, one {# hora a escreverem-se} other {# horas a escreverem-se}}.',
    conversationHighlightsRomeo: 'Tanto texto como {count} vezes Romeu e Julieta.',
    conversationHighlightsDayClockPeak: 'Quase sempre entre as {start} h e as {end} h',
    conversationHighlightsLessThanOnePercent: '< 1 %',
    conversationHighlightsWritesLonger: '{name} escreve as mensagens mais longas.',
    conversationHighlightsStartsMore: '{name} abre mais vezes a conversa.',
    conversationHighlightsWordsPerMessage: '{count} palavras / mensagem',
    conversationHighlightsStartsShare: '{percent} % dos inícios',
    conversationHighlightsMedianReply: 'Tempo mediano de resposta',
    conversationHighlightsBalanceEyebrow: 'O seu equilíbrio',
    conversationHighlightsBalanceTitle: 'Cada um tem a sua forma de estar presente',
    conversationHighlightsWordsShort: 'palavras',
    conversationHighlightsStartsShort: 'inícios',
    conversationHighlightsBalanceNote: 'Uma percentagem descreve um ritmo, nunca a importância de uma pessoa.',
    conversationHighlightsRecordsEyebrow: 'Os seus recordes',
    conversationHighlightsRecordsTitle: 'Os momentos que se destacam',
    conversationHighlightsLongestSession: 'Conversa mais longa',
    conversationHighlightsIntenseQuarter: 'Os 15 minutos mais intensos',
    conversationHighlightsQuestions: 'Mensagens ternas',
    conversationHighlightsSignsOfInterest: 'corações, beijos ou «amo-te»',
    conversationHighlightsLaughs: 'Mensagens com risos',
    conversationHighlightsSharedSmiles: 'sorrisos partilhados',
    conversationHighlightsFavoriteEmojis: 'Os seus emojis favoritos',
    conversationHighlightsStoriesEyebrow: 'Para guardar',
    conversationHighlightsStoriesTitle: 'Os seus cartões de recordações',
    conversationHighlightsStoriesText: 'Abra um cartão e descarregue-o em formato story.',
    conversationHighlightsDeepEyebrow: 'E depois dos números?',
    conversationHighlightsDeepTitle: 'Gostaria de aprofundar a leitura da sua história?',
    conversationHighlightsDeepText: 'Diga-nos se gostaria que um dia fôssemos mais longe. Por enquanto, nada mais será analisado.',
    conversationHighlightsDeepThanks: 'Obrigado, o seu interesse foi registado',
    conversationHighlightsDeepButton: 'Sim, teria interesse',
    conversationHighlightsDeepNotice: 'Avisamos assim que estiver previsto.',
    conversationHighlightsDeepNoticeClose: 'De acordo',
    conversationHighlightsPrintBook: 'Quero imprimir o meu livro',
    conversationHighlightsPrintNow: 'Imprimo agora',

    conversationImagesCount: `{count} {count, plural,
      =0 {foto}
      =1 {foto}
      other {fotos}
    }`,

    conversationImportFileNotSupportedError: 'O seu ficheiro não é válido! Por favor, selecione um ficheiro comprimido válido (.zip)',
    conversationImportFileSummary: 'O seu nome é {name} e tem {count} conversas neste arquivo.',
    conversationImportFileTooBigError: 'O seu ficheiro é demasiado pesado! (mais de 4GB). Por favor, contacte-nos para resolver este problema.',
    conversationImportProviderNext: 'Transferir a minha conversa',
    conversationImportTutorialGoNext: 'Ver o próximo passo',
    conversationImportTutorialStep: 'Passo n°{step}',
    conversationImportDetailToggle: 'Ver o guia detalhado com capturas de ecrã',
    conversationImportDetailCardTitle: 'Primeira vez?',
    conversationImportDetailCardSubtitle: 'Guia ilustrado passo a passo ({count} passos com capturas de ecrã)',
    conversationImportDetailCardAction: 'Abrir o guia',
    conversationImportDetailTitle: 'Guia detalhado passo a passo',
    conversationImportDetailStepOf: 'Passo {current} de {total}',
    conversationImportDetailPrev: 'Anterior',
    conversationImportDetailNext: 'Seguinte',
    conversationImportDetailClose: 'Fechar',
    conversationImportSelectionSummary: `Conversa selecionada: {name} (contém {count} {count, plural,
        =0 {mensagem}
        =1 {mensagem}
        other {mensagens}
      })`,
    conversationImportSelectionSummary2: 'Conversa selecionada: {name}',
    conversationImportSelectionText: 'Escreva o nome do seu amigo...',
    conversationImportSelectionTitle: 'Selecione a conversa',
    conversationImportStepCreation: 'Criação da conversa',
    conversationImportStepExtraction: 'A recuperar os dados',
    conversationImportStepFinal: 'A finalizar os últimos detalhes...',
    conversationImportStepImages: 'A guardar as suas imagens',
    conversationImportStepMessages: 'A guardar as suas mensagens',
    conversationImportSuccess: 'Parabéns! <br></br>A sua conversa foi importada com sucesso!',
    conversationImportValidationWaiting: 'Validação em curso...',
    conversationMediaAudioOpusWarning: 'Se não conseguir reproduzir este ficheiro de áudio, utilize outro navegador compatível (como o Google Chrome)',
    conversationMediasCount: `{count} {count, plural,
      =0 {ficheiro multimédia}
      =1 {ficheiro multimédia}
      other {ficheiros multimédia}
    }`,
    conversationMerge: 'Unir as conversas',
    conversationMergeInfo: 'Selecione as conversas que deseja unir e depois clique no botão situado debaixo da lista:',
    conversationMergeRequestSuccess: 'As conversas serão unidas em breve! Receberá um e-mail quando a fusão estiver concluída.',
    conversationMergeHintEyebrow: 'Bom saber',
    conversationMergeHintTitle: 'Agrupar numa só conversa',
    conversationMergeHintSingle: 'Vários fios de conversa? Importe cada conversa com + e depois una-as numa só conversa.',
    conversationMergeHintReady: 'Pode unir as suas conversas numa única conversa cronológica.',
    conversationMessages: 'Mensagens',
    conversationMessagesCount: `{count} {count, plural,
      =0 {mensagem}
      =1 {mensagem}
      other {mensagens}
    }`,
    conversationMessagesCount2: `{count, plural,
      =0 {mensagem}
      =1 {mensagem}
      other {mensagens}
    }`,
    conversationMessagesImagesCount: `{count} {count, plural,
      =0 {imagem}
      =1 {imagem}
      other {imagens}
    }`,
    conversationMessagesImagesCount2: `{count, plural,
      =0 {imagem}
      =1 {imagem}
      other {imagens}
    }`,
    conversationMessagesLoadingAlert: 'A recuperar a magia das suas mensagens...',
    conversationMessagesMediasCount: `{count} {count, plural,
      =0 {ficheiro multimédia}
      =1 {ficheiro multimédia}
      other {ficheiros multimédia}
    }`,
    conversationMessagesMediasCount2: `{count, plural,
      =0 {ficheiro multimédia}
      =1 {ficheiro multimédia}
      other {ficheiros multimédia}
    }`,
    conversationNoData: 'Ainda não importou nenhuma conversa!',
    conversationOptionWithImagesHelp1: 'Atualmente, os seus livros serão impressos COM as suas imagens ou fotos',
    conversationOptionWithImagesHelp2: 'Atualmente, os seus livros serão impressos SEM as suas imagens ou fotos',
    conversationOptionWithImagesHelp3: 'Dependendo da quantidade de fotos, a transferência da conversa poderá ficar mais lenta. Por favor, permaneça nesta página durante o carregamento, pode demorar até 10 minutos. Se continuar a ter dificuldades, envie-nos o seu ficheiro através de www.fromsmash.com para o endereço hello@monlivresms.com indicando o nome do contacto ou do grupo, e encontraremos uma solução.',
    conversationOptionWithImagesLabel: 'Deseja incluir as imagens da conversa?',
    conversationOptionWithMediaHelp: 'Poderá redescobrir os seus vídeos, áudios e GIFs graças aos códigos QR impressos no seu livro. Oferecemos o armazenamento seguro dos seus dados durante 10 anos.',
    conversationOptionWithMediasLabel: 'Deseja incluir os vídeos, áudios e GIFs da conversa?',
    conversationOrder: 'Encomenda',
    conversationOrderButton: 'Encomendar agora',
    conversationOrderButtonWithPrice: 'Encomendar · {price}',
    conversationOrderButtonWithPriceVolumes: 'Encomendar os meus {count} livros · {price}',
    conversationOrderDiscountLabel: '¡-{discount}% de desconto nesta conversa ao pedir {threshold} exemplares ou mais!',
    conversationOrderQuantity: 'Número de exemplares',
    conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {volume}
			other {volumes}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: {discount} % de desconto incluído}
		}`,
    conversationOrderSummary2: `A sua encomenda inclui {bookCount} {bookCount, plural,
          =0 {livro}
          =1 {livro}
          other {livros}
        } e {pdfCount} {pdfCount, plural,
          =0 {eBook}
          =1 {eBook}
          other {eBooks}
        } {freeCount, plural,
          =0 {}
          =1 {+1 eBook grátis}
          other {+{freeCount} eBooks grátis}
        } por {pdfTotal}`,
        conversationOrderSummaryBestof: '1 livro Best Of · {bestofTotal}',
        conversationOrderSummaryPdf: '1 eBook completo · {pdfTotal}',
    conversationParticipantColorHelp: 'Clique aqui para alterar a cor da bolha',
    conversationParticipantNameHelp: 'Clique aqui para editar o nome do participante',
    conversationParticipantPositionHelp: 'Clique para modificar a posição do participante (à direita ou à esquerda)',
    conversationParticipants: 'Participantes',
    conversationParticipantsEditTitle: 'Edição dos participantes',
    conversationPauseButton: 'Pausar a minha encomenda',
    conversationPauseConfirmText: 'A geração dos seus livros será pausada. Pode retomá-la a qualquer momento.',
    conversationPreviewBookNumber: `{index}{index, plural,
          =0 {}
          =1 {º}
          other {º}
      } volume`,
    conversationPreviewBestofHelpButton: 'Como funciona a seleção?',
    conversationPreviewBestofHelpText: 'A nossa fórmula analisa cada momento da sua conversa: a densidade das trocas, a qualidade do diálogo (uma verdadeira troca ou um monólogo?), a riqueza do conteúdo (fotos, texto, emojis). As primeiras e últimas mensagens são sempre preservadas. Apenas os momentos que realmente importaram entram no livro. As suas mensagens ficam privadas: a nossa fórmula nunca lê o conteúdo, apenas a estrutura das suas trocas.',
    conversationPreviewBookSelection: 'Seleção dos volumes',
    conversationPreviewBooksSelectAllBooks: 'Selecionar todos os livros físicos',
    conversationPreviewBooksSelectAllEBooks: 'Selecionar todos os eBooks',
    conversationPreviewBooksUnselectAll: 'Desmarcar tudo',
        conversationPreviewBrowserWarning: 'O seu navegador pode abrandar a visualização. Para uma experiência ideal, recomendamos o Google Chrome.',
    conversationPreviewFormatSelection: 'Seleção do formato',
    conversationPreviewPagesDivideEquallyLabel: 'Deseja dividir as páginas de forma equitativa entre os volumes?',
    conversationPreviewPagesSetMaxBookPagesLabel: 'Prefere que os seus livros tenham um máximo de {max} páginas?',
        conversationPreviewTitle: 'A sua história, em livro.',
        conversationPreviewSubtitle: 'Personalize capa, nomes, datas e mensagens antes de escolher a sua edição.',
        conversationPreviewHeroTitle: 'As suas palavras, encadernadas para sempre.',
        conversationPreviewBookCaption: 'Vire as páginas para descobrir o seu livro.',
        conversationPreviewCustomizeEyebrow: 'Ao seu gosto',
        conversationPreviewEditionEyebrow: 'A sua edição',
        conversationPreviewPricePerVolume: '{price}/volume',
    conversationPreviewCollectionPriceNote: '{count} volumes · {price}/volume',
    conversationPreviewCollectionUntilLabel: 'Quais volumes',
    conversationPreviewCollectionUntilAll: 'Do primeiro ao último volume',
    conversationPreviewCollectionUntilOpen: 'Escolher',
    conversationPreviewCollectionUntilClose: 'Fechar',
    conversationPreviewCollectionUntilPartial: '{count, plural, one {O primeiro volume} other {Os primeiros {count} volumes}}',
    conversationPreviewCollectionUntilSuffix: '{count, plural, one {O último volume} other {Os últimos {count} volumes}}',
    conversationPreviewCollectionUntilSingle: 'O volume {number}',
    conversationPreviewCollectionUntilWindow: 'Do volume {from} ao volume {to}',
    conversationPreviewCollectionUntilPeriod: 'De {start} a {end}',
    conversationPreviewCollectionUntilHint: 'Os outros volumes ficam na conversa, para outra encomenda.',
    conversationPreviewCollectionUntilAriaStart: 'Primeiro volume a imprimir',
    conversationPreviewCollectionUntilAriaEnd: 'Último volume a imprimir',
    conversationPreviewTypeBookTaglinePartial: '{count, plural, one {O primeiro volume da sua conversa.} other {Os primeiros {count} volumes da sua conversa.}}',
    conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {O último volume da sua conversa.} other {Os últimos {count} volumes da sua conversa.}}',
    conversationPreviewTypeBookTaglineWindowSingle: 'O volume {number} da sua conversa.',
    conversationPreviewTypeBookTaglineWindow: 'Os volumes {from} a {to} da sua conversa.',
    conversationPreviewStickyCollectionVolumes: 'Coleção · {count} volumes',
        conversationPreviewSocialProofCount: '{count}+ avaliações',
        conversationPreviewSocialProofAria: 'Avaliado com {rating} em 5 no Trustpilot, com mais de {count} avaliações',
        conversationPreviewCustomizeTitle: 'Personalizar o meu livro',
        conversationPreviewCustomizeHint: 'Toque num cartão para editar.',
        conversationPreviewCardsHintTitle: 'Nomes, datas, mensagens',
        conversationPreviewCardsHintText: 'Aqui altera os nomes, o período e as mensagens.',
        conversationPreviewCustomizeTopics: 'Capa · nomes · datas · mensagens',
        conversationPreviewEditionTitle: 'Escolher a edição',
        conversationPreviewEditionHint: 'Compare as opções e escolha a que mais lhe convém.',
        conversationPreviewPausedEyebrow: 'Encomenda em pausa',
        conversationPreviewPausedTitle: 'As suas alterações estão prontas?',
        conversationPreviewPausedHint: 'A sua encomenda está em pausa. Edite o livro e confirme para retomar a produção.',
        conversationPreviewPausedScrollHint: 'Validar as minhas alterações',
        conversationPreviewMissingMediasBanner: 'Faltam alguns ficheiros multimédia (fotos, ficheiros) da sua conversa ou não foi possível recuperá-los. Verifique as suas mensagens antes de validar.',
        conversationPreviewMissingMediasCta: 'Completar os média',
        bookMissingPhotoLabel: 'Foto indisponível',
        conversationMissingMediasBadge: 'Média em falta',
        conversationMissingMediasCta: 'Completar os média',
        conversationResumeWithoutMediasButton: 'Continuar sem estas fotos',
        conversationResumeMissingMediasConfirmText: 'Ainda faltam algumas fotos. O seu livro seguirá para impressão sem elas. Complete os média se puder.',
        orderMissingMediasAlert: 'Faltam fotos numa conversa desta encomenda. Complete-as para a produção poder retomar.',
        missingMediasRecoveryAddPhoto: 'Adicionar uma foto',
        missingMediasRecoveryArchiveCta: 'Largar o ficheiro de exportação',
        missingMediasRecoveryArchiveError: 'Não foi possível ler este ficheiro. Verifique se é a exportação da sua mensagens.',
        missingMediasRecoveryArchiveHelp: 'Envie novamente a exportação {provider} (zip). Só as fotos em falta serão adicionadas: as mensagens e alterações ficam iguais.',
        missingMediasRecoveryArchiveTitle: 'Completar com uma nova exportação',
        missingMediasRecoveryArchiveWorking: 'A procurar as fotos em falta no ficheiro…',
        missingMediasRecoveryContact: 'Escrever-nos',
        missingMediasRecoveryEmpty: 'Nenhum média em falta detetado de momento.',
        missingMediasRecoveryError: 'Ocorreu um erro. Tente novamente ou contacte-nos.',
        missingMediasRecoveryFirstDate: 'Primeiro média em falta: {date}.',
        missingMediasRecoveryIgnore: 'Ignorar',
        missingMediasRecoveryIntro: '{count, plural, one {Falta # foto} other {Faltam # fotos}} no seu livro. Pode voltar a enviar a exportação ou tratar cada média abaixo.',
        missingMediasRecoveryListTitle: 'Tratar média a média',
        missingMediasRecoveryNoMatch: 'Não foi encontrado nenhum ficheiro correspondente aos média em falta.',
        missingMediasRecoveryRecommended: 'Recomendado',
        missingMediasRecoveryRescan: 'Verificar de novo',
        missingMediasRecoveryResolved: 'Todos os média em falta foram tratados. O seu livro volta à produção.',
        missingMediasRecoverySuccessEyebrow: 'Tudo certo',
        missingMediasRecoverySuccessTitle: 'Bravo, as suas fotos estão completas',
        missingMediasRecoverySuccessText: 'Todos os média em falta foram tratados. O seu livro volta à produção.',
        missingMediasRecoverySuccessCta: 'Voltar à pré-visualização',
        conversationMissingMediasFixedSuccess: 'Bravo: todos os média em falta estão completos. O seu livro volta à produção.',
        conversationMissingMediasFixedHint: 'Não precisa de fazer mais nada: a produção retoma automaticamente.',
        missingMediasRecoverySmsStepAndroid: 'No Android: reabra a app MonLivreSMS e reenvie a conversa.',
        missingMediasRecoverySmsStepBackup: 'Faça uma nova cópia de segurança local não encriptada (Mac/PC) e volte a executar o nosso software para reenviar os média desta conversa.',
        missingMediasRecoverySmsStepIcloud: 'No iPhone: abra a conversa em Mensagens, toque no contacto, desça e descarregue as fotos do iCloud.',
        missingMediasRecoverySmsTitle: 'Transferência SMS / iPhone',
        missingMediasRecoveryTitle: 'Média em falta ({count})',
        conversationPreviewEditionMetaLabel: 'Detalhes da edição',
        conversationPreviewBestofLearnMore: 'Como funciona a seleção Best-Of',
        conversationPreviewBestofHint: 'Pré-visualização ilustrativa do Best Of: a seleção das suas melhores mensagens é feita após a encomenda, na geração do PDF.',
        conversationPreviewBestofHintDismiss: 'Fechar',
        conversationPreviewBestofHintLearnMore: 'Saber mais',
        conversationPreviewBestofPriceNote: 'Seleção após a encomenda',
        conversationPreviewTypeBestofTaglineCompare: 'Alternativa mais leve: os seus melhores momentos em 1 volume.',
        conversationPreviewMetaEbook: 'eBook oferecido',
        conversationPreviewMetaVolume: '{count} volume',
        conversationPreviewMetaVolumes: '{count} volumes',
        conversationPreviewMetaPages: '{pages} páginas',
        conversationPreviewMetaMessages: '{count} mensagens',
        conversationPreviewMetaBestofPages: '~400 páginas',
        conversationPreviewMetaBestofSelection: 'Seleção inteligente',
        conversationPreviewMetaPdfInstant: 'PDF imediato',
        conversationPreviewMetaPdfCredit: 'Crédito para o livro',
        conversationPreviewPdfPriceNote: 'Deduzido se passar ao livro',
        conversationPreviewPdfLearnMore: 'Como funciona?',
        conversationPreviewPdfHelpText: 'Paga {ebookPrice} e recebe o seu PDF. Se mais tarde encomendar o livro impresso a {bookPrice}, esses {ebookPrice} são descontados: ficam {remainingPrice}. O crédito fica na sua conta.',
        conversationPreviewReassurancePdfCredit: 'Estes {price} são deduzidos se passar ao livro',
        conversationPreviewStickyPdfCredit: 'Crédito de {price} se passar ao livro',
        conversationPreviewEbookCreditBanner: 'Tem {amount} de crédito nesta conversa. Será deduzido automaticamente se encomendar o livro impresso.',
        conversationPreviewEbookCreditOrderHint: '{credit} de crédito deduzidos · preço de catálogo {fullPrice}',
        conversationPreviewStickyEbookCredit: '{credit} de crédito aplicados',
        paymentMethodEbookCreditHint: 'Crédito ebook para o livro impresso',
        cartTotalsEbookCredit: 'Crédito ebook',
        cartTotalsCredit: 'Crédito',
        conversationOrderButtonEbook: 'Receber o meu PDF',
        conversationOrderButtonEbookWithPrice: 'Receber o meu PDF · {price}',
        conversationPreviewTypeBookTaglineSingle: 'A sua história completa, página a página.',
        conversationPreviewTypeBookTaglineMulti: 'A sua conversa completa em {count} livros impressos.',
        conversationPreviewHeroHeading: 'Pré-visualização do livro',
        conversationPreviewHelpTourButton: 'Mostrar ajuda da página',
        conversationPreviewCardLabelCover: 'Capa',
        conversationPreviewCardLabelParticipants: 'Participantes',
        conversationPreviewCardLabelDates: 'Datas',
        conversationPreviewCardLabelMessages: 'Mensagens',
	conversationPreviewZoneDone: 'Já explorado',
	conversationPreviewZoneHintCover: 'Cor, foto, título, prefácio',
	conversationPreviewZoneHintParticipants: 'Nomes e cores dos balões',
	conversationPreviewZoneHintDates: 'Período abrangido pelo livro',
	conversationPreviewZoneHintMessages: 'Ocultar ou corrigir mensagens',
        conversationHelpPreviewCustomizeTitle: 'Nomes, datas e mensagens',
        conversationHelpPreviewCustomizeText: 'Toque num cartão para editar nomes, datas ou mensagens.',
        conversationBookNavPrev: 'Página anterior',
        conversationBookNavNext: 'Página seguinte',
        conversationBookBackToCover: 'Voltar à capa',
        conversationPreviewTypeBookPagesHint: ' · {pages} páginas',
        conversationPreviewTypeBookMessagesHint: ' · {count} mensagens',
        conversationOrderTotal: 'Total',
        conversationPreviewTypeBestofDescription: '400 páginas, os seus melhores momentos. eBook oferecido.',
        conversationPreviewTypeBestofTitle: 'Best Of',
        conversationPreviewTypeBookDescription: '{count} volume · História completa. eBook oferecido.',
        conversationPreviewTypeBookDescriptionWithPrice: '{count} volumes · {unitBreakdown} · Coleção integral. eBook oferecido.',
        conversationPreviewReassuranceShipping: 'Envio gratuito em todo o mundo',
        conversationPreviewExpressDeliveryLead: 'Entrega expressa {where} a partir de',
        conversationPreviewExpressDeliveryDate: '{date}',
        conversationPreviewTypeBookTitle: 'Coleção completa',
        conversationPreviewTypeHighlight: 'Recomendado',
        conversationPreviewTypePdfDescription: 'Guarde a sua conversa em PDF. Este valor conta para o livro, se o quiser mais tarde.',
        conversationPreviewTypePdfTitle: 'Digital',
        conversationPreviewTypeSelectionTitle: 'Escolha o seu formato',
    conversationProgress: 'Progresso',
    conversationProviderButton: 'Aceder às definições',
    conversationProviderType: 'Tipo',
    conversationRemoveButton: 'Eliminar a conversa',
    conversationRemoveConfirmText: 'Ao eliminar a sua conversa, os seus ficheiros multimédia serão apagados dos nossos servidores e não poderão ser recuperados. Tem a certeza?',
    conversationRemoveConfirmTitle: 'Eliminar a conversa',
    conversationRemoveFlagConfirmMessage: 'Deseja remover esta marcação da conversa?',
    conversationRemoveSuccess: 'Conversa eliminada com sucesso!',
    conversationRestartProcess: 'Reiniciar',
    conversationResumeButton: 'Validar e imprimir',
    conversationResumeConfirmText: 'A sua conversa será marcada como "verificada" e passará em breve para a fase de geração e impressão.',
    conversationValidateModificationsButton: 'Validar as minhas alterações',
    conversationValidateModificationsConfirmTitle: 'Validar as suas alterações?',
    conversationValidateModificationsConfirmBook: 'O seu livro volta à produção com as suas alterações.',
    conversationValidateModificationsConfirmEbook: 'O seu eBook será regenerado com as suas alterações e reenviado por email.',
    conversationValidateModificationsConfirmMissingMedias: 'Faltam alguns ficheiros multimédia da sua conversa. Verifique-os antes de validar: o seu livro entrará em produção com as alterações atuais.',
    conversationValidateModificationsSuccessBook: 'As suas alterações foram guardadas. O seu livro volta à produção.',
    conversationValidateModificationsSuccessEbook: 'As suas alterações foram guardadas. O seu eBook regenerado será enviado por email.',
    conversationValidateModificationsBackToList: 'Voltar às minhas conversas',
    conversationSelectThread: 'Selecionar uma conversa',
    conversationShareCancelButton: 'Agora não',
    conversationShareConfirmButton: 'Ver os meus destaques',
    conversationShareConfirmTitle: 'Veja o que encontrámos...',
    conversationShareConfirmText: 'A sua conversa esconde números que apetece partilhar. Passámo-los para imagens.',
    conversationStatusConfigured: 'Pendente de geração',
    conversationStatusDone: 'Terminado',
    conversationStatusOngeneration: 'Geração em curso',
    conversationStatusOnproduction: 'Em produção',
    conversationStatusOnvalidation: 'Pendente de impressão',
    conversationStatusPending: 'Em espera',
    conversationTypeAndroidDownloadAlt: 'Ou copie e cole o link no seu navegador preferido',
    conversationTypeAndroidDownloadButton: 'Descarregue a aplicação',
    conversationTypeAndroidIntroText1: 'Para imprimir o seu Livro SMS a partir de um telemóvel Android, é necessário utilizar o seu smartphone (Samsung, Xiaomi, Pixel, etc.).',
    conversationTypeAndroidIntroText2: 'Instale a aplicação MonLivreSMS no seu telemóvel Android clicando no seguinte link (a app não está disponível no Google Play):',
    conversationTypeAndroidIntroText3: 'Escolha o coautor do seu livro SMS de recordações, bem como as datas de início e fim da vossa história.',
    conversationTypeAndroidIntroText4: 'Escolha os nomes dos protagonistas da sua história, escreva a sua dedicatória e personalize a sua capa.',
    conversationTypeAndroidIntroText5: 'Para finalizar a criação do seu livro, crie uma conta e complete a sua compra através do nosso servidor de pagamento seguro.',
    conversationTypeInstagramFileText1: 'O Instagram enviar-lhe-á um email para que possa descarregar o ficheiro.',
    conversationTypeInstagramFileText2: 'Descarregue-o para o seu dispositivo.',
    conversationTypeInstagramFileText3: 'Clique no botão abaixo e selecione o arquivo nas suas transferências sem o abrir, deixando-o no formato .zip (exemplo: *oseunome*_*data*.zip). Apenas a conversa que escolher será enviada para os nossos serviços de impressão.',
    conversationTypeInstagramProviderText1: 'Recupere uma cópia dos seus dados do Instagram acedendo às definições gerais da sua conta.',
    conversationTypeInstagramProviderText2: 'Introduza o e-mail associado à sua conta de Instagram e escolha o formato JSON.',
    conversationTypeInstagramProviderText3: 'Em seguida, introduza a sua palavra-passe e clique em <strong>Pedir transferência</strong> para iniciar a geração da sua cópia de segurança no Instagram.',
    conversationTypeIosIntroText1: 'Ligue o seu iPhone ao seu COMPUTADOR e faça uma cópia de segurança no iTunes sem encriptação. (selecione "Este computador", DESMARQUE "Encriptar cópia de segurança local" e clique em "Fazer cópia de segurança agora").',
    conversationTypeIosIntroText2: 'Descarregue o software MonLivreSMS clicando no link correspondente ao sistema operativo do seu computador:',
    conversationTypeIosIntroText3: '<strong>ATENÇÃO, se o software não detetar nenhuma cópia de segurança:</strong><br></br> - Para MAC:<br></br>Vá a Definições do Sistema > Privacidade e Segurança > Acesso Total ao Disco e adicione a aplicação MonLivreSMS desbloqueando o cadeado em baixo à esquerda.<br></br> - Para PC:<br></br>Para a sua segurança, a Apple impede a leitura da sua cópia de segurança sem a sua autorização.',
    conversationTypeMessengerFileText1: 'O Facebook enviar-lhe-á um email para descarregar o arquivo das suas conversas.',
    conversationTypeMessengerFileText2: 'Descarregue-o para o seu dispositivo.',
    conversationTypeMessengerFileText3: 'Clique no botão abaixo e selecione o arquivo nas suas transferências deixando-o no formato .zip (exemplo: facebook-*oseunome*.zip). Apenas a conversa que escolher será processada.',
    conversationTypeMessengerProviderText1: 'Recupere uma cópia dos seus dados do Facebook acedendo às definições da sua conta.',
    conversationTypeMessengerProviderText2: 'Clique em "Descarregar as suas informações".',
    conversationTypeMessengerProviderText3: `Em seguida, defina as seguintes opções:<br></br>
              <strong>Intervalo de datas</strong>: (o que preferir)<br></br>
              <strong>Formato</strong>: JSON<br></br>
              <strong>Qualidade dos ficheiros multimédia</strong>: Baixa (é suficiente para a impressão e muito mais rápido de transferir)<br></br>
              <strong>As suas informações</strong>: Selecione apenas "Mensagens" (desmarque o resto).`,
    'conversationTypeMessengerProviderText4': 'Atenção: Certifique-se de selecionar o formato de dados em JSON (e não em HTML)!',
    'conversationTypeSnapchatProviderText1.1': 'Abra a aplicação Snapchat no seu dispositivo.',
    'conversationTypeSnapchatProviderText1.2': 'Toque no seu avatar (o Bitmoji) no canto superior esquerdo para aceder ao seu perfil.',
    'conversationTypeSnapchatProviderText1.3': 'Toque no ícone da engrenagem no canto superior direito para abrir as Definições.',
    'conversationTypeSnapchatProviderText2.1': 'Deslize para baixo até à secção "Controlos de privacidade".',
    'conversationTypeSnapchatProviderText2.2': 'Selecione "Os meus dados".',
    'conversationTypeSnapchatProviderText3.1': 'É possível que lhe peçam para iniciar sessão para verificar a sua identidade.',
    'conversationTypeSnapchatProviderText4.1': 'Na página "Os meus dados", encontrará uma lista com os dados que pode descarregar, incluindo as suas mensagens.',
    'conversationTypeSnapchatProviderText4.2': 'Clique em "Enviar Pedido" na parte inferior da página.',
    'conversationTypeSnapchatProviderText5.1': 'Uma vez enviado o seu pedido, o Snapchat preparará a transferência dos seus dados.',
    'conversationTypeSnapchatProviderText5.2': 'Isto pode demorar algum tempo, geralmente desde algumas horas até um dia.',
    'conversationTypeSnapchatProviderText5.3': 'Receberá um email do Snapchat com um link para descarregar os seus dados quando o ficheiro estiver pronto.',
    'conversationTypeSnapchatProviderText6.1': 'Clique no link do email para aceder à página de transferência.',
    'conversationTypeSnapchatProviderText6.2': 'Descarregue o ficheiro ZIP que contém os seus dados.',
    'conversationTypeSnapchatProviderText7.1': 'Uma vez descarregado o ficheiro ZIP, não o abra.',
    'conversationTypeSnapchatProviderText7.2': 'Arraste o ficheiro ZIP completo, tal como está, para a secção indicada no nosso site.',
    'conversationTypeSnapchatProviderText7.3': 'Em seguida poderá escolher a conversa que prefere para criar o seu livro.',
    conversationTypeSnapchatProviderTitle1: '1. Aceda às Definições do Snapchat:',
    conversationTypeSnapchatProviderTitle2: '2. Pedir os seus Dados:',
    conversationTypeSnapchatProviderTitle3: '3. Autenticação:',
    conversationTypeSnapchatProviderTitle4: '4. Transferência dos seus Dados:',
    conversationTypeSnapchatProviderTitle5: '5. Aguardar pelo Email:',
    conversationTypeSnapchatProviderTitle6: '6. Descarregar o Ficheiro:',
    conversationTypeSnapchatProviderTitle7: '7. Carregamento no MonLivreSMS:',
    'conversationTypeTelegramProviderText1.1': 'Instale a aplicação Telegram para computador no seu PC ou Mac em https://desktop.telegram.org/.',
    'conversationTypeTelegramProviderText1.2': 'Abra a aplicação Telegram no seu computador.',
    'conversationTypeTelegramProviderText2.1': 'Na aplicação, abra a conversa que deseja transformar em livro clicando no nome do seu contacto.',
    'conversationTypeTelegramProviderText3.1': 'Clique nos três pontos no canto superior direito da conversa.',
    'conversationTypeTelegramProviderText3.2': 'Escolha "Exportar histórico da conversa".',
    'conversationTypeTelegramProviderText4.1': 'Na janela de definições, selecione todos os tipos de ficheiros que deseja incluir (fotos, vídeos, mensagens de voz, etc.).',
    'conversationTypeTelegramProviderText4.2': 'Ajuste o limite de tamanho para o máximo permitido para a exportação.',
    'conversationTypeTelegramProviderText4.3': 'Clique em "Exportar" na parte inferior da janela.',
    'conversationTypeTelegramProviderText5.1': 'Localize a pasta com os dados exportados e comprima-a num ficheiro ZIP (Clique com o botão direito > Enviar para > Pasta comprimida (zipada)).',
    'conversationTypeTelegramProviderText6.1': 'Carregue o ficheiro ZIP completo no nosso site.',
    conversationTypeTelegramProviderTitle1: '1. Instalar o Telegram para Computador:',
    conversationTypeTelegramProviderTitle2: '2. Seleção da Conversa:',
    conversationTypeTelegramProviderTitle3: '3. Exportar o Histórico da Conversa:',
    conversationTypeTelegramProviderTitle4: '4. Definições de Exportação da Conversa:',
    conversationTypeTelegramProviderTitle5: '5. Comprimir num Ficheiro ZIP:',
    conversationTypeTelegramProviderTitle6: '6. Carregar o ficheiro no MonLivreSMS:',
    conversationTypeTitle: 'Criar um livro a partir da conversa com {name}',
    conversationTypeWhatsappFileText1: 'Recuperar a sua conversa do WhatsApp',
    conversationTypeWhatsappFileText2: 'Clique em "Anexar um ficheiro"',
    conversationTypeWhatsappFileText3: 'Carregue a sua conversa',
    conversationTypeWhatsappFileText4: 'Se o ficheiro não estiver no formato ".zip", comprima-o primeiro.',
    conversationTypeWhatsappFileText5: 'Se apenas desejar o texto da sua conversa (sem fotos), carregue unicamente o ficheiro .txt',
    conversationTypeWhatsappProviderText1: 'Exportar uma cópia da sua conversa do WhatsApp',
    conversationTypeWhatsappProviderText2: '<strong>A partir de um Android:</strong><br></br>Abra a aplicação do WhatsApp<br></br>Entre na conversa desejada<br></br>Toque em "Opções" (os três pontos no canto superior direito)',
    conversationTypeWhatsappProviderText3: '<strong>A partir de iOS (iPhone):</strong><br></br>Abra a aplicação do WhatsApp<br></br>Entre na conversa desejada<br></br>Toque no nome do contacto ou do grupo na parte superior<br></br>Deslize até ao fundo e selecione "Exportar conversa"',
    conversations: 'Conversas',
    conversationsMy: 'As minhas conversas',
    conversationsLuxEyebrow: 'As suas histórias',
    conversationsLuxHint: 'Reencontre as suas conversas e transforme-as num belo livro.',
    ordersLuxEyebrow: 'O seu atelier',
    ordersLuxHint: 'Encontre os seus livros e siga a sua viagem, do atelier até sua casa.',
    ordersLuxDetailTitle: 'O seu livro',
    ordersLuxDetailHint: 'Siga o seu livro, do atelier até à sua porta.',
    ordersLuxViewFollow: 'Seguir o meu livro',
    ordersLuxEmptyTitle: 'A sua primeira história espera por si.',
    ordersLuxEmptyHint: 'Transforme uma conversa num livro que vai querer abrir vezes sem conta.',
    ordersLuxStepReceived: 'Recebida',
    ordersLuxStepAtelier: 'Atelier',
    ordersLuxStepPrint: 'Impressão',
    ordersLuxStepShipped: 'A caminho',
    ordersLuxStepHome: 'Consigo',
    ordersLuxStoryPendingpayment: 'A sua encomenda espera o pagamento para entrar no atelier.',
    ordersLuxStoryPending: 'Recebemos a sua encomenda. O atelier já está a tratar dela.',
    ordersLuxStoryOnpreparation: 'O seu livro ganha forma. Cada página é preparada com cuidado.',
    ordersLuxStoryOnfabrication: 'O seu livro está a ser impresso. Em breve sai do atelier.',
    ordersLuxStoryShipped: 'O seu livro está a caminho. Viaja até sua casa.',
    ordersLuxStoryComplete: 'O seu livro chegou. Só espera pelas suas mãos.',
    ordersLuxStoryCanceled: 'Esta encomenda foi anulada. As suas memórias ficam em segurança connosco.',
    userProfileLuxEyebrow: 'O seu espaço',
    userProfileLuxHint: 'Gira os seus dados, métodos de acesso e preferências.',
    userProfileValueEmpty: 'Não indicado',
    userProfileNotLinked: 'Não associado',
    userProfileNewsletterOn: 'Já recebe as nossas novidades e ofertas.',
    userProfilePasswordOn: 'Definida',
    addressesLuxEyebrow: 'O seu espaço',
    addressesLuxHint: 'Encontre os seus endereços de entrega e faturação.',
    addressesLuxEditHint: 'Este endereço pode servir para entrega ou faturação.',
    conversationsNewApp: 'Novas conversas na aplicação',
    conversationsOldApp: 'Conversas antigas na aplicação',
    dashboardTitle: 'Painel de controlo',
    date: 'Data',
    dateActivated: 'Data de ativação',
    dateCreated: 'Data de criação',
    dateLastCguAccept: 'Data da última aceitação dos Termos e Condições',
    dateLastEdit: 'Data da última modificação',
    dateLastLogin: 'Data da última ligação',
    dateSelect: 'Selecionar uma data',
    dateSelectPlaceholder: 'Clique aqui para selecionar uma data...',
    days: 'Dia(s)',
    daysCount: `{count} {count, plural,
        =0 {dia}
        =1 {dia}
        other {dias}
    }`,
    delete: 'Eliminar',
    deleteRequestError: 'Erro ao eliminar!',
    deleteRequestSuccess: 'Eliminado com sucesso!',
    description: 'Descrição',
    detailsInformation: 'Detalhes',
    domain: 'Domínio',
    download: 'Descarregar',
    edit: 'Modificar',
    editViewAdvanced: 'Edição avançada',
    editViewSimplified: 'Edição simplificada',
    elementNoItems: 'Nenhum elemento',
    elementsCount: `{count} {count, plural,
              =0 {elemento}
              =1 {elemento}
              other {elementos}
          }`,
    example: 'Exemplo',
    examples: 'Exemplos',
    file: 'Ficheiro',
    fileDeleteError: 'Impossível eliminar este ficheiro',
    fileDeleteSuccess: 'Ficheiro eliminado!',
    fileSelected: 'Ficheiro selecionado: {file}',
    fileSwitch: 'Mudar de ficheiro',
    fileUploadError: 'Impossível carregar este ficheiro!',
    fileUploadProcessStartOnSave: 'O carregamento do ficheiro começará ao guardar.',
    fileUploadRestrictionTypeError: 'Formato de ficheiro não válido! Permitidos: {types}',
    fileUploadSuccess: 'Ficheiro carregado com sucesso!',
    files: 'Ficheiros',
    filtersTitle: 'Filtros',
    finish: 'Terminar',
    flags: 'Bandeiras',
    free: 'Grátis',
    generalInformation: 'Informação geral',
    help: 'Ajuda',
    hours: 'Horas',
    hoursCount: `{count} {count, plural,
        =0 {hora}
        =1 {hora}
        other {horas}
    }`,
    imageDeleteError: 'Impossível eliminar esta imagem!',
    imageDeleteSuccess: 'Imagem eliminada!',
    imageUploadError: 'Impossível carregar esta imagem',
    imageUploadRestrictionSize: 'A imagem deve ter um tamanho máximo de {format}',
    imageUploadRestrictionType: 'A imagem deve estar no formato {types}',
    imageUploadRestrictionTypeError: 'Formato de imagem não aceite! Permitidos: {types}',
    import: 'Importar',
    importModelDownloadButton: 'Descarregar o modelo',
    importRequestError: 'Ocorreu um erro durante a importação!',
    importRequestSomeFailAlert: 'Um ou mais elementos não puderam ser importados!',
    importRequestSuccess: 'Dados importados com sucesso!',
    importerFileButton: 'Importar os dados',
    importerFileHelp: 'Pode gerar um ficheiro CSV utilizando o seu programa de folhas de cálculo (Excel, OpenOffice, ...)',
    importerFileInfo: 'Selecionar um ficheiro CSV (Valores separados por vírgulas)',
    importerNoItemsAlert: 'Não há elementos para importar',
    importerTitle: 'Importação de dados',
    information: 'Informação',
    informationsDetails: 'Detalhes',
    informationsGeneral: 'Informação geral',
    invoicePrint: 'Imprimir a fatura',
    invoicesPrint: 'Imprimir as faturas',
    isActive: 'Ativo?',
    isPublic: 'É público?',
    isUnlimited: 'Ilimitado?',
    label: 'Nome/Etiqueta',
    language: 'Idioma',
    languageAR: 'Árabe',
    languageBN: 'Bengali',
    languageDE: 'Alemão',
    languageEN: 'Inglês',
    languageES: 'Espanhol',
    languageFR: 'Francês',
    languageHI: 'Hindi',
    languageIT: 'Italiano',
    languageJA: 'Japonês',
    languagePT: 'Português',
    languageRU: 'Russo',
    languageZH: 'Chinês',
    learnMoreButton: 'Saber mais',
    limitLabel: 'Tipo de limite',
    limitTextForm1: 'deve ter um',
    listTitle: 'Lista',
    loading: 'A carregar...',
    logo: 'Logótipo',
    minutes: 'Minuto(s)',
    name: 'Nome',
    next: 'Seguinte',
    no: 'Não',
    of: 'de',
    options: 'Opções',
    order: 'Encomenda',
    orderAdd: 'Adicionar uma encomenda',
    orderAddTitle: 'Criar uma encomenda',
    orderAddressPrivacyInfo: ' O seu endereço não será público! Apenas os outros participantes desta encomenda o poderão ver.',
    orderAddressShippingValid: 'Confirmar a morada de entrega',
    orderBilling: 'Faturação',
    orderConfirmationPaymentError: 'Ocorreu um erro... Por favor, contacte-nos!',
    orderConfirmationPaymentWaiting: 'Por favor, aguarde... Estamos a processar o seu pagamento para confirmar a sua encomenda.',
    orderConfirmationPendingText: 'A sua encomenda está a aguardar pagamento para poder ser concluída! Clique no link abaixo para finalizar a sua compra efetuando o pagamento.',
    orderConfirmationPendingText2: 'ATENÇÃO: Se pagar com cartão de crédito, a validação do pagamento poderá demorar alguns minutos. Por favor, aguarde enquanto realizamos as verificações de segurança.',
    orderConfirmationPendingTitle: 'Encomenda a aguardar pagamento!',
    orderConfirmationSocialText: 'Siga-nos nas suas redes sociais favoritas para não perder as nossas novidades, novos produtos e promoções exclusivas...',
    orderConfirmationSocialTitle: 'Vamos manter o contacto!',
    orderConfirmationText: ' A sua encomenda foi registada corretamente e passará para preparação. Receberá um email assim que for enviada.',
    orderConfirmationTitle: 'Encomenda recebida!',
    orderContent: 'Conteúdo da encomenda',
    orderDetails: 'Detalhes',
    orderId: 'Identificador',
    orderInfoCommentAlertTitle: 'Mensagem importante',
    orderInvoice: 'Fatura',
    orderInvoicePrintButton: 'Imprimir a fatura',
    orderItemsEmpty: 'Não há nenhum artigo na sua encomenda',
    orderItemViewBook: 'Ver o meu livro',
    orderItemsTotal: 'Total de artigos:',
    orderMassStatusConfirmMessage: 'Atualizar o estado de {count} encomenda(s)?',
    orderNoItems: 'Ainda não realizou nenhuma encomenda!',
    orderNoteCustomer: 'Nota do cliente',
    orderPaymentChooseMethodLabel: 'Escolha um método de pagamento',
    orderPaymentFinishTitle: 'Finalizar o seu pagamento',
    orderPaymentValidButton: 'Confirmar o pagamento',
    orderPayments: 'Pagamentos',
    orderProcessInvitationText: 'Convide os seus amigos a preencher a caixa',
    orderProcessInvitationTextBefore1: 'Directos.eu é um serviço de compra em grupo entre particulares que lhe permite comprar produtos diretamente aos fabricantes. Irá poupar tanto no preço dos produtos COMO nos custos de envio!',
    orderProcessInvitationTextBefore2: 'Não se preocupe! Temos a solução:',
    orderProductAdd: 'Adicionar um produto ',
    orderRefunds: 'Reembolsos',
    orderShipping: 'Envio',
    orderShippingAdd: 'Adicionar o envio',
    orderShippingFee: 'Custos de envio',
    orderShippingRemoveConfirmMessage: 'Tem a certeza de que deseja remover este envio da encomenda?',
    orderShippingTrackingTitle: 'Acompanhe a sua encomenda',
    orderShippingTrackingButton: 'Seguir a minha encomenda',
    orderShippingTrackingHint: 'O seguimento pode demorar algumas horas a aparecer junto do transportador.',
    orderShippings: 'Envios',
    orderStatus: 'Estado',
    orderStatusCanceled: 'Cancelada',
    orderStatusComplete: 'Concluída',
    orderStatusOnpreparation: 'Em preparação',
    orderStatusOnprogress: 'Em curso',
    orderStatusPending: 'Em espera',
    orderStatusPendingpayment: 'Pendente de pagamento',
    orderStatusShipped: 'Enviada',
    orderSubtotalDiscount: 'Desconto',
    orderSubtotalExclTax: 'Subtotal (sem IVA)',
    orderSubtotalInclTax: 'Subtotal (IVA incl.)',
    orderTax: 'IVA',
    orderThanks: 'Obrigado pela sua encomenda',
    attributionPaidLine: 'O pagamento está feito',
    attributionSkip: 'Ver a minha encomenda',
    attributionSourceTitle: 'O que lhe deu vontade de ter este livro?',
    attributionSourceLead: 'A sua encomenda já está feita. Uma resposta diz-nos o que o cativou.',
    attributionSearchTitle: 'Antes de procurar, já conhecia a MonLivreSMS?',
    attributionSearchLead: 'Um nome que já tinha ouvido, ou algo novo.',
    attributionOccasionTitle: 'Para que ocasião é este livro?',
    attributionOccasionLead: 'A ocasião em que está a pensar.',
    attributionOtherPlaceholder: 'Umas palavras, se quiser',
    attributionOtherContinue: 'Continuar',
    attributionSaveError: 'Não foi possível guardar esta resposta. Tente outra vez.',
    attributionOpt_bouche_a_oreille: 'Alguém próximo falou-me disto',
    attributionOpt_vu_objet: 'Vi o livro em casa de alguém',
    attributionOpt_receveur_devenu_client: 'Ofereceram-me um, agora é a minha vez',
    attributionOpt_recherche: 'À procura no Google',
    attributionOpt_instagram: 'Instagram',
    attributionOpt_tiktok: 'TikTok',
    attributionOpt_facebook: 'Facebook',
    attributionOpt_pinterest: 'Pinterest',
    attributionOpt_qvema: 'Qui veut être mon associé',
    attributionOpt_medias: 'Um artigo, um programa ou um podcast',
    attributionOpt_client_existant: 'Já tinha encomendado aqui',
    attributionOpt_autre: 'Outra coisa',
    attributionOpt_decouverte_pure: 'Mais um acaso',
    attributionOpt_pre_bao: 'Alguém próximo tinha-me falado',
    attributionOpt_pre_tv: 'Tinha-o visto na televisão',
    attributionOpt_pre_social: 'Tinha-o visto nas redes',
    attributionOpt_pre_inconnu: 'Já não sei',
    attributionOpt_anniv_couple: 'O aniversário de quando nos conhecemos',
    attributionOpt_noel: 'Natal',
    attributionOpt_saint_valentin: 'O Dia de São Valentim',
    attributionOpt_anniversaire: 'Um aniversário',
    attributionOpt_deuil: 'As mensagens de alguém que perdi',
    attributionOpt_naissance: 'Um nascimento',
    attributionOpt_distance: 'Alguém que parte, ou que vive longe',
    attributionOpt_pour_soi: 'Para mim, não para oferecer',
    attributionOpt_autre_occasion: 'Outro momento',
    bookIntentTitle: 'Este livro é para...',
    bookIntentLead: 'Uma resposta, e começamos.',
    bookIntentSkip: 'Agora não',
    bookIntentOpt_anniv_couple: 'O aniversário de quando nos conhecemos',
    bookIntentOpt_anniversaire: 'O aniversário de alguém',
    bookIntentOpt_noel: 'O Natal',
    bookIntentOpt_saint_valentin: 'O Dia de São Valentim',
    bookIntentOpt_souvenir: 'Alguém que já não está',
    bookIntentOpt_plus_tard: 'Mais tarde',
    bookIntentOpt_autre: 'Outra coisa',
    bookIntentDate_anniv_couple: 'Qual é a data?',
    bookIntentDateLead_anniv_couple: 'O dia em que se conheceram, ou o dia que celebram a dois.',
    bookIntentDate_anniversaire: 'Em que dia é o aniversário?',
    bookIntentDateLead_anniversaire: 'O aniversário da pessoa a quem o oferece.',
    bookIntentDate_plus_tard: 'Por volta de que data?',
    bookIntentDateLead_plus_tard: 'O dia que tem em mente.',
    bookIntentDateDefer: 'Indico a data mais tarde',
    bookIntentDateBack: 'Voltar',
    bookIntentDateContinue: 'Continuar',
    bookIntentSaveError: 'Não foi possível guardar a resposta. Tente de novo.',
    inboxPromptTitle: 'Para o seu livro',
    inboxPromptSignup: 'Acabámos de lhe enviar um e-mail, « {subject} ». É o começo do seu livro, não um anúncio. O {provider} às vezes põe-no de lado. Marque-o como « {mark} ». Com este gesto, o que se segue chega-lhe bem, com o que precisa para o fazer mesmo bem.',
    inboxPromptTransfer: 'Acabámos de lhe enviar um e-mail, « {subject} ». É a ligação para a sua conversa, não um anúncio. O {provider} às vezes põe-no de lado. Marque-o como « {mark} ». Com este gesto, fica com tudo à mão para fazer o livro que quer.',
    inboxPromptMarkGmail: 'Não é spam',
    inboxPromptMarkYahoo: 'Não é spam',
    inboxPromptButton: 'Valido no {provider}',
    inboxPromptClose: 'Fechar',
    inboxPromptConfirm: 'Acabámos de lhe enviar um e-mail, « {subject} ». Abre a sua conta. O {provider} às vezes põe-no de lado. Marque-o como « {mark} ». Com este gesto, o que se segue chega-lhe.',
    emailConfirmPageTitle: 'Confirme o seu endereço',
    emailConfirmTitle: 'Veja o seu e-mail',
    emailConfirmLead: 'Acabámos de lhe enviar um e-mail para abrir a sua conta. O botão lá dentro confirma o seu endereço.',
    emailConfirmResend: 'Enviar o e-mail outra vez',
    emailConfirmResent: 'O e-mail voltou a sair.',
    emailConfirmExpired: 'Esta ligação expirou. Peça uma nova a partir da sua conta.',
    emailConfirmInvalid: 'Esta ligação não corresponde a nenhuma conta.',
    emailConfirmWorking: 'A abrir a conta…',
    orderTotal: 'TOTAL',
    orderTotalTTC: 'Total (IVA incl.)',
    orderTotalTax: 'I.V.A. {rate}%',
    orderTotalToPay: 'Montante total a pagar: {total}€',
    orderTotals: 'Totais',
    orderUserRegisterAlert: 'Deve facultar-nos o seu email para que possamos contactá-lo caso haja algum problema com a sua encomenda.',
    orderView: 'Ver a encomenda',
    orderWeight: 'Peso',
    orderitemAddProductTitle: 'Modificar os dados do artigo',
    orders: 'Encomendas',
    ordersContactTitle: 'Contactar sobre uma encomenda',
    ordersMy: 'As minhas encomendas',
    ordersMyViewButton: 'Ver as minhas encomendas',
    packingInformation: 'Informação de embalamento',
    parcelGroupInfo: ' Agrupar o envio por número de pacotes',
    parcelGroupLabel: 'Grupo de pacotes',
    parcelGroupWeightInfo: 'Kg por pacote',
    parcelGroupWeightLabel: 'Agrupar o envio por peso',
    paymentCardInputLabel: 'Por favor, introduza os dados do seu cartão para confirmar a sua encomenda.',
    paymentMethodCreditbalanceDescription1: 'Descontado automaticamente do total',
    paymentMethodCreditbalanceDescription2: 'Resta a pagar',
    paymentMethodCreditbalancePay: 'Confirmar com o meu crédito',
    paymentMethodCreditbalanceTitle: 'Crédito já aplicado',
    paymentFailError: 'O seu pagamento falhou! Por favor, tente de novo.',
    paymentMethod: 'Método de pagamento',
    paymentMethodBancontactLabel: 'Bancontact',
    paymentMethodBankcheckLabel: 'Cheque bancário',
    paymentMethodBanktransferLabel: 'Transferência bancária',
    paymentMethodCardLabel: 'Cartão bancário',
    paymentMethodCreditcardLabel: 'Cartão bancário',
    paymentMethodCreditDescription1: 'Este montante será descontado automaticamente do montante pendente do seu carrinho.',
    paymentMethodGiropayLabel: 'Giropay',
    paymentMethodIdealLabel: 'iDEAL',
    paymentMethodPhoneLabel: 'Telefone',
    paymentMethodCreditPay: 'Pagar com os meus créditos',
    paymentMethodCreditTitle: 'Já pagou uma parte da sua encomenda:',
    paymentValidButton: 'Confirmar o meu pagamento',
    previous: 'Anterior',
    priceInformation: 'Informação sobre preços',
    priceRoundAlertTooltip: 'Este preço pode sofrer um ligeiro arredondamento devido à conversão de divisas.',
    printButton: 'Imprimir',
    process: 'Processo',
    productAnnexes: 'Anexos',
    productAnnexesNewProductError: 'Por favor, guarde o seu novo produto antes de lhe adicionar anexos!',
    productAttributes: 'Atributos',
    productConversationTypeMissingAlert: 'Não há nenhum produto associado ao tipo selecionado. Por favor, contacte-nos para resolver esta questão!',
    productCostHT: 'Custo (sem IVA)',
    productDescription: 'Descrição',
    productEdit: 'Modificar o produto',
    productImages: 'Imagens',
    productImagesNewProductError: 'Por favor, guarde o seu novo produto antes de lhe adicionar imagens!',
    productIsActive: 'Ativo?',
    productName: ' Nome',
    productPictureDelete: 'Eliminar a imagem',
    productPriceHT: 'Preço (sem IVA)',
    productPriceTTC: 'Preço (IVA incl.)',
    productReference: 'Referência',
    productSlug: 'Slug',
    productSpecialPriceQuantityDiscountInfo: 'Poupe {percent}% na sua compra ao adicionar {quantity} cópias!',
    productTaxCalculate: 'Calcular',
    productTaxRate: 'Taxa de IVA',
    productTaxRateFormHelp: 'Para um IVA de 23%, introduza 0.23',
    productUseForConversationBook: 'Disponível para livros em papel?',
    productUseForConversationEBook: 'Disponível para eBooks (digital)?',
    productUseForCredit: 'Utilizar para os créditos de utilizador?',
    products: 'Produtos',
    productsView: 'Ver os produtos',
    quantity: 'Quantidade',
    refresh: 'Atualizar',
    refundCreateTitle: 'Criar um reembolso',
    refundCreateConfirmMessage: 'Confirma a criação deste reembolso?',
    remove: 'Eliminar',
    retry: 'Tentar novamente',
    save: 'Guardar',
    saveBeforeAlert: 'Por favor, guarde as alterações primeiro...',
    saveRequestError: 'Erro ao guardar!',
    saveRequestSuccess: 'Guardado com sucesso!',
    saving: 'A guardar...',
    searchFor: 'Pesquisar',
    seconds: 'Segundo(s)',
    select: 'Selecionar',
    selectAll: 'Selecionar tudo',
    selectFile: 'Selecionar um ficheiro',
    selectImage: 'Selecione uma imagem',
    selectOptions: 'Selecionar uma opção',
    selectUnAll: 'Deselecionar tudo',
    seoTitle: 'Imprimir os seus SMS e conversas do WhatsApp num livro',
    shippingAddressEdit: 'Modificar a morada de entrega',
    shippingAddressMissingError: 'Não introduziu nenhuma morada de entrega.',
    shippingCalculation: 'Cálculo',
    shippingCalculationInfo: 'Se o cálculo entrar em ciclo, é preferível utilizar o limite máximo inclusivo.',
    shippingCarrier: 'Transportadora',
    shippingChronopostPickupError: 'Não conseguimos carregar os Pontos Pick-up! Por favor, reveja o país e o código postal antes de voltar a tentar.',
    shippingChronopostPickupNoResult: 'Não encontrámos nenhum ponto de recolha próximo. Por favor, pesquise com outra morada ou código postal.',
    shippingChronopostPickupOpeningHours: 'Horários de funcionamento',
    shippingChronopostPickupOpeningHoursView: 'Ver os horários',
    shippingChronopostPickupViewList: 'Ver em formato de lista',
    shippingChronopostPickupViewMap: 'Ver no mapa',
	shippingPickupError: 'Não foi possível abrir o seletor de pontos de recolha. Tente novamente mais tarde.',
	shippingPickupChange: 'Alterar ponto de recolha',
	shippingPickupChoose: 'Escolher um ponto de recolha',
    shippingCountrySelect: 'País de envio',
    shippingDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar este método de envio?',
    shippingDeliveryEstimationDate1: 'Data de entrega estimada: {date}',
    shippingDeliveryEstimationDate2: 'Data de entrega estimada: entre {date1} e {date2}',
    shippingDeliveryEstimationText: 'Esta é apenas uma estimativa dos custos de envio. Poderá escolher o seu ponto de entrega exato no passo seguinte.',
    shippingSurchargeCorsica: 'Esta tarifa inclui um suplemento Córsega de {price}.',
    shippingSurchargeOverseas: 'Esta tarifa inclui um suplemento de {price} para territórios ultramarinos.',
    shippingSurchargeRemote: 'Esta tarifa inclui um suplemento de {price} para zonas de difícil acesso.',
    shippingDeliveryTime: 'Prazo de entrega (em dias)',
    shippingDeliveryTimeInfo: 'Entrega em {days} dias úteis',
    shippingDescription: 'Descrição',
    shippingExcludeDepartmentInfo: 'Separe os códigos postais a excluir com uma vírgula (,). Pode usar "*" como caráter universal.',
    shippingExcludeDepartmentLabel: 'Excluir códigos postales',
    shippingExtraFeeCalculation: 'Cálculo dos custos de envio adicionais',
    shippingExtraFeeLabel: 'Etiqueta de custos de envio adicionais',
    shippingExtraFees: 'Custos adicionais',
    shippingFeeCalculatorTitle: 'Calcule os seus custos de envio',
    shippingFeeFreeDelivery: 'Envio gratuito!',
    shippingFeeNotFoundError: '',
    shippingFeeWithBookResult: 'Faça a sua encomenda agora e receba o seu eBook instantaneamente, e os seus livros impressos em {countryName} entre {deliveryDateFrom} e {deliveryDateTo}.',
    shippingFeeWithoutBookResult: 'Faça a sua encomenda agora e receba o seu eBook instantaneamente no seu email.',
    shippingFreeStep: 'Limiar para envio gratuito',
    shippingFreeTreshold: 'Valor para envio gratuito',
    shippingFreeInfo: 'Envio gratuito a partir de {value}',
    shippingIdentifier: 'Identificador de envio',
    shippingIsPriceTTC: 'O preço do envio inclui o IVA?',
    shippingLabelGenerateButton: 'Gerar a etiqueta',
    shippingLabelGenerateButton2: 'Voltar a gerar a etiqueta',
    packingCheckTitle: 'Os livros desta encomenda',
    packingCheckHint: 'Mostre um livro de cada vez, com a contracapa para a câmara. Quando a contagem avançar, pouse-o fora da imagem e passe ao seguinte.',
    packingCheckProgress: '{seen} / {expected}',
    packingCheckForeign: 'Este livro é da encomenda {code}. Retire-o da caixa.',
    packingCheckReady: 'Está certo. São os livros desta encomenda. Pode imprimir a etiqueta.',
    packingCheckOverflow: 'Foram lidos livros a mais. Comece de novo.',
    packingCheckRestart: 'Começar de novo',
    packingCheckCameraStart: 'Abrir a câmara',
    packingCheckCameraDenied: 'A câmara está bloqueada. Autorize-a ou leia o QR com o leitor.',
    packingCheckLocked: 'Leia todos os livros antes de imprimir a etiqueta.',
    packingCheckWedgeLabel: 'Ou leia o QR com o leitor',
    packingCheckLoading: 'A carregar os livros desta encomenda.',
    prepBooksCardTitle: 'Livros',
    prepBooksCount: '{count, plural, one {# livro} other {# livros}}',
    prepBooksPageEyebrow: 'Preparação',
    prepBooksPageTitle: 'Encomenda {code}',
    prepBooksPageHint: 'Os livros que seguem nesta caixa.',
    prepModeClient: 'Vista do cliente',
    prepModePreparation: 'Vista de preparação',
    shippingLegacyChronopostPaused: 'Esta encomenda ainda está no Chronopost anterior. Mude o método de envio para uma oferta Sendcloud em Editar e depois crie a etiqueta.',
    shippingMethodCalculating: 'A calcular as opções de envio...',
    shippingMethodConditions: 'Condições de envio',
    shippingMethodMissingAlert: 'Não encontrámos nenhuma transportadora disponível para o seu carrinho. Por favor, modifique a morada ou escolha outra transportadora.',
    shippingMethodNotAvailable: 'Não existem opções de entrega disponíveis para a sua morada...',
    shippingRatesError: 'O cálculo dos portes de envio foi interrompido. Tente novamente dentro de instantes e, se voltar a acontecer, escreva-nos: analisamos a situação consigo.',
    shippingMethodPricing: 'Tarifa',
    shippingMethodPricingSystem: 'Sistema de tarifação',
    shippingMethodSearch: 'A procurar opções de envio...',
    shippingMethodSelectTitle: 'Selecione o seu método de envio',
    shippingGroupRelay: 'Ponto de recolha',
    shippingGroupHome: 'Ao domicílio',
    shippingTierClassic: 'Entrega standard',
    shippingTierExpress: 'Entrega express',
    shippingTierClassicDesc: 'Prazo standard',
    shippingTierExpressDesc: 'A opção mais rápida',
    shippingTierPriceRelayFree: 'Grátis em ponto de recolha',
    shippingTierPriceRelayFrom: 'A partir de {price} em ponto de recolha',
    shippingTierPriceHomeFrom: '{price} ao domicílio',
    shippingChangeTier: 'Alterar velocidade de entrega',
    shippingTierModeTitle: 'Escolha o modo de entrega',
    shippingStepOf: 'Passo {current} de {total}',
    shippingStepSpeedTitle: 'Quando deseja receber a sua encomenda?',
    shippingStepModeTitle: 'Onde deseja receber a sua encomenda?',
    shippingMethodTrackingInfo: 'Informação de seguimento',
    shippingMethods: 'Métodos de envio',
    shippingOrder: 'Ordem de envio',
    shippingProvider: 'Fornecedor logístico',
    shippingStep: 'Passo',
    shippingStepInfo: 'Este passo DEVE ser o parâmetro da esquerda! O parâmetro superior é o código postal por defeito.',
    shippingStepLimitInfo: 'A condição da esquerda é o mínimo/máximo?',
    shippingTaxRate: 'Taxa de IVA do envio',
    shippingTitle: 'Entrega',
    shippingTrackingNumber: 'Número de seguimento',
    shippingTrackingParcelUrl: 'URL de seguimento da encomenda',
    status: 'Estado',
    stepTitle: 'Passo {step}',
    submit: 'Enviar',
    suborderitemAddProductTitle: 'Adicionar um produto',
    switchLanguage: 'Mudar de idioma',
    tableMassActions: 'Ações em lote',
    tableRefreshSuccessAlert: 'Sincronizado corretamente!',
    tableRefreshSuccessError: 'Erro de sincronização!',
    tableSelection: `{count} {count, plural,
			  =0 {selecionado}
			  =1 {selecionado}
			  other {selecionados}
		  }`,
    tag: 'Etiqueta',
    tagFillPlaceholder: 'Introduza uma palavra-chave...',
    tags: 'Etiquetas',
    taskDescription: 'Descrição',
    taskEditTitle: 'Modificar a tarefa',
    taskPriority: 'Prioridade',
    taxRate: 'IVA',
    the: 'o',
    time: 'Hora',
    timezone: 'Fuso horário',
    title: 'Título',
    toleranceLabel: 'Tolerância',
    total: 'Total',
    type: 'Tipo',
    unit: 'Unidade',
    user: 'Utilizador',
    userAccountCreditsTitle: 'O meu saldo de créditos',
    userAccountDataProtection: 'Proteção de dados',
    userAccountDataProtectionText1: 'Levamos muito a sério a proteção dos seus dados pessoais. Por isso, comprometemo-nos a mantê-los seguros e apenas os conservamos durante o tempo estritamente necessário para lhe prestarmos o nosso serviço.',
    userAccountDataProtectionText2: 'Apenas lhe pedimos a informação estritamente necessária. Jamais partilharemos os seus dados com terceiros nem os utilizaremos com fins comerciais sem o seu consentimento explícito.',
    userAccountDataProtectionText3: 'Se deseja descarregar os seus dados ou exercer o seu direito ao esquecimento, por favor contacte-nos em {email}.',
    userAccountDelete: 'Eliminar a minha conta',
    userAccountDeleteActiveSuborder: 'Não pode eliminar a sua conta enquanto tiver encomendas em curso!',
    userAccountDeleteBlockText: 'Não pode eliminar a sua conta neste momento!',
    userAccountDeleteButton: 'Eliminar a minha conta definitivamente',
    userAccountDeleteConfirmMessage: 'Tem a certeza absoluta de que deseja eliminar a sua conta para sempre?',
    userAccountDeleteConfirmTitle: 'Eliminar a minha conta',
    userAccountDeleteError: 'Não foi possível eliminar a sua conta!',
    userAccountDeleteSuccess: 'A sua conta foi eliminada! Esperamos voltar a vê-lo em breve!',
    userAccountDeleteText: 'Ao eliminar a sua conta, perderá o acesso a todo o seu histórico e aos seus livros guardados. Apagaremos todos os seus dados pessoais dos nossos servidores de forma segura. Esta ação é irreversível!',
    userAccountEdit: 'Modificar os meus dados',
    userAccountEditSuccess: 'Perfil atualizado corretamente',
    userAccountExistError: 'Não existe nenhuma conta associada a este e-mail!',
    userAccountExistTitle: 'Já tem uma conta connosco?',
    userAccountGeneral: 'Geral',
    userAccountHistory: 'Histórico',
    userAccountInfo: 'Os seus dados estão protegidos e permanecerão estritamente confidenciais.',
    userAccountInfoMyTitle: 'Os meus dados pessoais',
    userAccountMy: 'A minha conta',
    userAccountPersonnalInformation: 'A minha informação pessoal',
    userAccountPreferencesInformation: 'As minhas preferências',
    userAccountResetError: 'Erro ao tentar repor a conta!',
    userAccountResetSuccess: 'Conta reposta com sucesso!',
    userActivityOnLine: 'Online',
    userAdd: 'Adicionar um utilizador',
    userAddNew: 'Adicionar um novo utilizador',
    userBridgeError: 'O início de sessão a partir da aplicação falhou. Tente novamente.',
    userBridgeInvalid: 'Esta ligação de início de sessão já não é válida. Recomece a partir da aplicação.',
    userBridgePending: 'A iniciar sessão…',
    userBridgeSuccess: 'Sessão iniciada! Já pode voltar à aplicação.',
    userChangePasswordSuccess: 'Palavra-passe atualizada!',
    userConfirmationCode: 'Código de confirmação recebido por email',
    userConfirmationCodeCheckButton: 'Já tenho o código para repor a minha palavra-passe',
    userConfirmationCodeError: 'Por favor, introduza o código de confirmação que lhe enviámos por email!',
    userConnectionInfo: 'Inicie sessão para confirmar a sua encomenda e guardar o seu livro!',
    userCredits: 'Créditos',
        userCreditsBalancePositive: 'Tem {amount} de crédito disponível: aplicado automaticamente no passo seguinte.',
    userCreditsPrepaymentInviteTitle: 'Pagamento antecipado do seu livro',
    userDeleteConfirmTitle: 'Eliminar o utilizador',
    userDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar este utilizador?',
    userDeleteConfirmation: 'O utilizador {user} foi eliminado!',
    userEdit: 'Modificar {user}',
    userEdit2: 'Modificar o utilizador',
    userEditPassword: 'Mudar a minha palavra-passe',
    userEmail: 'Endereço de e-mail',
    userEmailError: 'O endereço de e-mail não é válido!',
    userEmailFillInfo: 'Introduza o seu email',
    userEmailFormInfo: 'Escreva o seu email para continuar',
    userEmailFormInfo2: 'Utilizaremos o seu email para criar a sua conta de forma segura e enviar-lhe o seguimento da sua encomenda.',
    userLoginCodeTitle: 'Já tem uma conta',
    userLoginCodeIntro: 'Acabámos de enviar um código de 6 dígitos para {email}. Introduza-o aqui para continuar.',
    userLoginCodeLabel: 'Código recebido por email',
    userLoginCodeSubmit: 'Confirmar',
    userLoginCodeInvalid: 'Este código não corresponde. Verifique o último email que recebeu.',
    userLoginCodeExpired: 'Este código já não é válido. Peça um novo logo abaixo.',
    userLoginCodeError: 'Ups, algo correu mal. Tente novamente dentro de instantes.',
    userLoginCodeLinkHint: 'O mesmo email também contém um link de acesso.',
    userLoginCodeResend: 'Enviar um novo código',
    userLoginCodeResendIn: 'Enviar um novo código dentro de {seconds} s',
    userLoginCodeResent: 'Enviado novamente. Verifique também a pasta de spam.',
    userLoginCodeChangeEmail: 'Usar outro email',
    userLoginCodeCartSuccess: 'Sessão iniciada. Já pode finalizar a sua encomenda.',
    userEnvironmentTestNoTest: 'Este utilizador não realizou nenhum teste de ambiente!',
    userFillPlaceholder: 'Introduza o nome de um utilizador...',
    userFirstName: 'Nome',
    userForgotPassword: 'Esqueceu-se da sua palavra-passe?',
    userForgotPasswordRetryDateError: 'Ainda não pode solicitar um novo código. Por favor, reveja a sua caixa de entrada (e a pasta de spam) para o encontrar.',
    userFormInfo: 'Complete o seu perfil',
    userGenderLabel: 'Género',
    userIsActive: 'Ativo?',
    userLastName: 'Apelido',
    userLogin: 'Iniciar sessão',
    userLoginAction: 'Entrar',
    userLoginEmailSelected: 'A iniciar sessão com o email: {email}',
    userLoginError: 'Dados incorretos! Por favor, tente de novo...',
    userLoginFirstButton: 'É a sua primeira vez aqui?',
    userLoginFirstText: 'Reveja a sua caixa de entrada: enviámos-lhe uma palavra-passe temporária. Utilize-a para o seu primeiro início de sessão. Poderá mudá-la facilmente a partir do seu perfil.',
    userLoginBenefit1: 'O seu livro de fotos SMS em poucos cliques',
    userLoginBenefit2: 'Entrega rápida ao domicílio',
    userLoginBenefit3: 'Pagamento 100% seguro',
    userLoginIntro: 'Por favor, identifique-se para aceder aos seus livros e ao seu espaço pessoal.',
    userLoginWelcomeSubtitle: 'Transforme os seus SMS num belo livro de fotos impresso.',
    userLoginWelcomeTitle: 'Bem-vindo!',
    userLoginNoConnexion: 'Sem ligação',
    userLoginTitle: 'Iniciar sessão',
    userLogout: 'Terminar sessão',
    userName: 'Nome',
    userNewPassword: 'Nova palavra-passe',
    userNewsletterSubscribeButton: 'Subscrever a newsletter',
    userNewsletterText1: 'Receba ideias de presentes, descontos exclusivos e as nossas últimas novidades diretamente no seu email.',
    userOldPassword: 'A sua palavra-passe atual',
    userOptions: 'Opções de utilizador',
    userPassword: 'Palavra-passe',
    userPasswordConfirmation: 'Confirme a sua palavra-passe',
    userPasswordConfirmationError: 'As palavras-passe não coincidem! Volte a tentar.',
    userPasswordConfirmationRestriction: 'Ambas as palavras-passe devem ser exatamente iguais.',
    userPasswordEdit: 'Modificar a minha palavra-passe',
    userPasswordSet: 'Definir uma palavra-passe',
    userPasswordSetSuccess: 'Palavra-passe guardada.',
    userSocialConnectionsTitle: 'Ligações',
    userSocialContinueApple: 'Continuar com a Apple',
    userSocialContinueGoogle: 'Continuar com o Google',
    userSocialDivider: 'ou',
    userSocialError: 'O início de sessão falhou. Tente novamente.',
    userSocialErrorNoEmail: 'A sua conta Apple não forneceu um email. Utilize outro método.',
    userSocialErrorUnavailable: 'Esta ligação ainda não está disponível.',
    userSocialLinkApple: 'Associar a Apple',
    userSocialLinkGoogle: 'Associar o Google',
    userSocialLinkSuccess: 'Conta associada.',
    userSocialLinked: 'Associado',
    userSocialUnlinkApple: 'Desassociar a Apple',
    userSocialUnlinkConfirm: 'Desassociar esta ligação da sua conta?',
    userSocialUnlinkGoogle: 'Desassociar o Google',
    userSocialUnlinkLastError: 'Adicione uma palavra-passe antes de desassociar a sua última ligação.',
    userSocialUnlinkSuccess: 'Conta desassociada.',
    userPasswordError: 'Por favor, introduza uma palavra-passe correta!',
    userPasswordResetText: 'Introduza a sua nova palavra-passe. Confirme-a e clique no botão abaixo para guardá-la.',
    userPasswordRestriction: 'A sua palavra-passe deve ter pelo menos 6 carateres e conter 1 número e 1 caráter especial (@&!()$*€%) por segurança!',
    userPasswordRestrictionAlt: 'A sua palavra-passe deve ter pelo menos 6 carateres!',
    userPasswordTemporaryCheckButton: 'Já recebi a minha palavra-passe temporária',
    userPhone: 'Telemóvel',
    userPhoneError: 'O número de telemóvel não é válido!',
    userProfileMy: 'O meu perfil',
    userReInitPassword: 'Repor a minha palavra-passe',
    userRecoverFromOldAppCheckButton: 'Recebi o email para recuperar a minha palavra-passe',
    userRecoverFromOldAppText: 'Acabámos de migrar a sua conta para a nossa nova plataforma! Reveja o seu email para recuperar a sua palavra-passe e ativar o seu novo espaço pessoal.',
    userRegister: 'Criar a minha conta',
    userRegisterError: 'Não foi possível criar a sua conta! Por favor, reveja o seu email e tente de novo...',
    userRegisterSuccess: 'Parabéns! Criámos a sua conta de forma segura. Acaba de receber um email com a sua palavra-passe temporária!',
    userRegisterSuccessEmailNotice: 'Acabámos de lhe enviar um email de confirmação para {email}.',
    userRegisterSuccessEyebrow: 'Bem-vindo',
    userRegisterSuccessPageTitle: 'Bem-vindo!',
    userRegisterSuccessSourcesHint: 'Escolha a aplicação onde estão as suas mensagens.',
    userRegisterSuccessSourcesTitle: 'Por onde começamos?',
    userRegisterSuccessStep1Desc: 'Aí encontrará o resumo do seu registo.',
    userRegisterSuccessStep1Title: 'Verifique a sua caixa de entrada',
    userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS ou Android: escolha a sua fonte.',
    userRegisterSuccessStep2Title: 'Importe as suas mensagens',
    userRegisterSuccessStep3Desc: 'Capa, cores, fotos: personalize cada detalhe.',
    userRegisterSuccessStep3Title: 'Crie o seu livro',
    userRegisterSuccessStepsEyebrow: 'O seu percurso',
    userRegisterSuccessText: 'A sua conta está pronta. Em poucos passos, transforme as suas mensagens num livro para guardar.',
    userRegisterSuccessTitle: 'A sua história começa aqui',
    userRegisterSuccessTitleNamed: 'Bem-vindo, {firstName}!',
    userResetPasswordAccountButton: 'Repor a palavra-passe da conta',
    userResetPasswordAskSuccess: 'Reveja a sua caixa de entrada! Enviámos-lhe um link para criar a sua nova palavra-passe.',
    userResetPasswordButton: 'Repor a minha palavra-passe',
    userResetPasswordError: 'Não foi possível repor a sua palavra-passe! Por favor, tente mais tarde...',
    userResetPasswordInfo: 'Vai receber um link seguro no seu email para repor a sua palavra-passe.',
    userResetPasswordInfo2: 'Crie a sua nova palavra-passe preenchendo os campos abaixo:',
    userResetPasswordSuccess: 'A sua palavra-passe foi atualizada com sucesso!',
    userRole: 'Função',
    userRoleAdmin: 'Administrador',
    userRoleCustomer: 'Cliente',
    userSearchLabel: 'Escreva um email ou o nome de um utilizador',
    userSendNewAccountEmail: 'Enviar email de "Nova conta" a este utilizador',
    userSendNewAccountEmailSuccess: 'O utilizador foi notificado!',
    userSwitch: 'Mudar de utilizador',
    userValidForgotPasswordError: 'Não foi possível enviar-lhe o código de recuperação!',
    userValidForgotPasswordSuccess: 'Reveja o seu email! Utilize o código de confirmação que lhe enviámos para criar a sua nova palavra-passe.',
    users: 'Utilizadores',
    usersList: 'Lista de utilizadores',
    valid: 'Validar',
    view: 'Ver',
    voucher: 'Cupão de desconto',
    voucherApplyButton: 'Aplicar desconto',
    voucherApplyComplete: 'Não pode acumular mais cupões de desconto nesta encomenda!',
    voucherApplyFormLabel: 'Código promocional',
    voucherApplyValidError: 'Ups! Este cupão não é válido para a sua encomenda atual.',
    voucherCode: 'Código',
    voucherCodePlaceholder: 'Escreva aqui o seu código promocional',
    voucherDeleteConfirmMessage: 'Tem a certeza de que deseja eliminar este voucher?',
    voucherEdit: 'Modificar o cupão',
    voucherIsAuto: 'Automático?',
    voucherIsCumulative: 'É acumulável?',
    voucherIsPublic: 'É público?',
    voucherNotExistsError: 'Este código de desconto não existe ou expirou!',
    voucherPriority: 'Prioridade',
    voucherProductOffer: 'Oferecidos',
    voucherRemoveAllButton: 'Eliminar todos os descontos',
    vouchers: 'Cupões de desconto',
    weight: 'Peso',
    yes: 'Sim',
    you: 'Eu',
    yourself: 'si mesmo',
    userNewsletterTitle: 'Newsletter',
    userNewsletterSubscribeText: 'Enviar-lhe-emos as nossas novidades, promoções exclusivas e os nossos livros favoritos.',
    userNewsletterUnSubscribeButton: 'Cancelar subscrição da newsletter',
    'userOrdersView': 'Ver as encomendas deste utilizador',
    'userCanCustomizeMessages': 'Pode personalizar as mensagens?',
    'userLogAsUser': 'Iniciar sessão como este utilizador',
    'shippingMethodProviderData': 'Informação da empresa de transporte',
    'productUseForCustomization': 'Utilizar para a personalização?',
    'conversationBookFormat': 'Formato do livro',
    'conversationMessageSelect': 'Selecionar esta mensagem',
    'conversationMessagesEditTitle': 'A oficina: Personalize as suas mensagens',
    'conversationMessageSelectorDateFrom': 'Selecionar as mensagens enviadas depois de',
    'conversationMessageSelectorDateTo': 'Selecionar as mensagens enviadas antes de',
    'conversationTextSearch': 'Procurar uma palavra na conversa',
    'conversationOnlyMedias': 'Mostrar apenas as fotos/vídeos',
    'conversationMessagesSelectVisible': 'Selecionar esta página',
    'conversationMessagesSelectAllFiltered': 'Selecionar tudo ({count, number})',
    'unselect': 'Desmarcar',
    'conversationMessagesEditHideSelected': 'Ocultar as mensagens selecionadas do livro',
    'conversationMessagesEditShowSelected': 'Voltar a mostrar as mensagens selecionadas',
    'conversationMessagesEditTooManySelected': 'Selecionou demasiadas mensagens de uma só vez!',
    'conversationNoMessages': 'Nenhuma mensagem',
    'conversationMessageEdit': 'Editar o texto da mensagem',
    'conversationMessageAdd': 'Adicionar uma mensagem',
    'conversationMessageInsert': 'Inserir uma mensagem aqui',
    'conversationMessageEditSelect': 'Selecionar esta mensagem',
    'conversationMessageEditUnselect': 'Desmarcar esta mensagem',
    'conversationMessageSetUnVisibleButton': 'Ocultar esta mensagem do livro impresso',
    'conversationMessageHiddenAlert': 'Esta mensagem foi ocultada e não aparecerá no seu livro impresso.',
    'conversationMessageSetVisibleButton': 'Voltar a mostrar a mensagem',
    'conversationMessagesEditEnableButton': 'Ativar a personalização de mensagens',
    'conversationMessagesEditEnableButton2': 'Desbloquear a personalização por {price}',
    'conversationMessagesEditDisableAlert': 'Para poder modificar, ocultar ou editar o conteúdo exato das suas mensagens, necessita de ativar esta opção premium (pagamento único).',
    'conversationMessageDateHint': 'Altere a data e a hora para colocar esta mensagem onde quiser na conversa.',
    'conversationMessageSender': 'Remetente',
    'conversationMessageSenderPlaceholder': 'Escolher remetente',
    'conversationMessageSenderRequiredHint': 'Escolha quem envia esta mensagem para poder guardar.',
    'conversationMessageAnnotation': 'Anotação',
    'conversationMessageAnnotationNoMedia': 'Uma anotação não pode incluir foto, vídeo ou áudio.',
    'conversationMessageText': 'Texto',
    'conversationMessageTextPlaceholder': 'Escreva o seu texto',
    'conversationMessageAttachments': 'Ficheiros anexos (Fotos/Vídeos)',
    'conversationMessageMediaLabel': 'Foto, vídeo ou áudio',
    'conversationMessageMediaDragDrop': 'Arraste uma foto, um vídeo ou um áudio para aqui',
    'conversationMessageMediaTapSelect': 'Toque para escolher uma foto, um vídeo ou um áudio',
    'conversationMessageMediaOpenFinder': 'Escolher um ficheiro',
    'conversationMessageMediaPickSenderFirst': 'Escolha primeiro um remetente para adicionar uma foto, um vídeo ou um áudio.',
    'conversationMessageHiddenLabel': 'Ocultar esta mensagem do livro?',
    'conversationGenerate': 'Gerar as maquetas dos livros',
    'conversationVerify': 'Forçar a verificação',
    'conversationLaunchButton': 'Enviar para a gráfica',
    'conversationViewButton': 'Ver a minha conversa',
    'reset': 'Repor',
    'cms': 'CMS',
    'cmsLinkColor': 'Cor do botão',
    'cmsLinkNeedObfuscate': 'Necessita de ofuscação?',
    'cmsImageUseForMobile': 'Utilizado para a versão mobile?',
    'contentEditPage': 'Editar a página',
    'cmsRedirectionAdd': 'Adicionar um redirecionamento',
    'cmsContentEdit': 'Modificar o conteúdo',
    'cmsPageIsActive': 'Página ativa?',
    'cmsContentTypeLabel': 'Tipo de conteúdo',
    'cmsContentModelLabel': 'Modelo de design',
    'cmsContentTitle': 'Título da página',
    'cmsContentSlug': 'Slug (URL)',
    'cmsPanelIsTemplate': 'Incluído no modelo global?',
    'cmsPageSeoTitle': 'Título SEO (Google)',
    'cmsPageSeoDescription': 'Meta Descrição SEO',
    'cmsPageSeoKeywords': 'Palavras-chave SEO',
    'cmsPageSeoHideOnSitemap': 'Ocultar dos motores de busca (Sitemap)',
    'cmsPageSeoUseCustomTitleSuffix': 'Utilizar um sufixo de título personalizado',
    'cmsPageSeoTitleSuffix': 'Sufixo do título',
    'affiliation': 'Programa de afiliados',
    'affiliationInvoiceTotalAdminTitle': 'Total a pagar (IVA incl.)',

    conversationImportLuxEyebrow: 'A sua história',
    conversationImportLuxTagline: 'Um presente único, pensado por si: que mais ninguém poderá oferecer.',
    conversationImportLuxPrivacy: 'As suas mensagens permanecem confidenciais: só a conversa escolhida é utilizada.',
    conversationImportProgressExport: 'Exportar',
    conversationImportProgressUpload: 'Carregar',
    conversationImportProgressCustomize: 'Personalizar',
    conversationImportUploadSuccess: 'Arquivo recebido: escolha a conversa no passo seguinte',
    conversationImportUploadSuccessSingle: 'Ficheiro recebido: continue para personalizar o seu livro',
    conversationImportContinueSingle: 'Continuar',
    conversationImportSelectionTitleSingle: 'A sua conversa',
    conversationImportSelectionHintSingle: 'Uma conversa encontrada no seu ficheiro.',
    conversationImportSelectionHintMultiple: 'Escolha a conversa para o seu livro: use a pesquisa para filtrar a lista.',
    conversationImportSelectionListCount: '{shown} de {total} conversas',
    conversationImportSelectionNoMatch: 'Nenhuma conversa corresponde à sua pesquisa.',
    conversationImportStepPickThread: 'Escolher conversa',
    conversationImportStepMedia: 'Opções de fotos',
    conversationImportStepTerms: 'Aceitar condições',
    conversationImportExtrasLockedHint: 'Escolha uma conversa acima para desbloquear estas opções.',
    conversationImportPickThreadBeforeTerms: 'Ainda precisa de escolher uma conversa acima antes de continuar.',
    conversationImportChangeThread: 'Mudar conversa',
    conversationImportSelectionConfirmedHint: 'Perfeito: já pode personalizar o seu livro abaixo.',

    conversationImportOptionsTitle: 'Fotos e memórias',
    conversationImportOptionsHint: 'Tudo está selecionado por defeito: desmarque apenas o que não quer incluir.',
    conversationImportOptionsImagesLabel: 'Fotos e imagens',
    conversationImportOptionsImagesDesc: 'As fotos da sua conversa serão impressas no livro.',
    conversationImportOptionsMediasLabel: 'Vídeos, áudio e GIFs',
    conversationImportOptionsMediasDesc: 'Acessíveis via códigos QR impressos no livro (armazenamento de 10 anos incluído).',
    conversationImportOptionsTransferNote: 'A transferência pode demorar alguns minutos consoante o número de fotos: fica nesta página.',
    conversationImportOptionsNoMedia: 'O seu ficheiro não contém fotos nem media: o livro incluirá apenas as mensagens.',
    conversationImportAgreementRead: 'Consulta as condições gerais de venda',
    conversationImportCreateBook: 'Criar o meu livro',
    conversationImportSelectToContinue: 'Seleciona uma conversa para continuar.',
    conversationImportAcceptTermsToContinue: 'Marque a caixa das condições gerais para continuar.',
    conversationImportTransferEyebrow: 'Quase lá',
    conversationImportTransferTitle: 'Estamos a preparar o seu livro',
    conversationImportTransferSubtitle: 'Só um momento: a sua história está a ganhar forma.',
    conversationImportTransferStay: 'Fica nesta página até o transferência estar concluída.',
    conversationImportStepMedias: 'Transferência de vídeos e áudio',
    conversationImportTransferStatMessages: 'Mensagens',
    conversationImportTransferStatPhotos: 'Fotos',
    conversationImportTransferStatMedias: 'Vídeos e áudio',
    conversationImportTransferEyebrow: 'Quase lá',
    conversationImportTransferTitle: 'Estamos a preparar o seu livro',
    conversationImportTransferSubtitle: 'Um momento: a sua história está a ganhar forma.',
    conversationImportTransferStay: 'Fica nesta página até a transferência terminar.',
    conversationImportResumeTitle: 'Uma transferência anterior foi interrompida.',
    conversationImportResumeTextFile: 'Seleciona novamente o mesmo ficheiro ({name}) para retomar de onde parou.',
    conversationImportResumeText: 'Seleciona novamente o mesmo ficheiro para retomar de onde parou.',
    conversationImportResumeButton: 'Retomar a transferência',
    conversationImportResumeDiscard: 'Recomeçar',
    conversationImportDuplicateTitle: 'Esta conversa já está na sua conta',
    conversationImportDuplicateEyebrow: 'Conversa idêntica',
    conversationImportDuplicateLead: 'Encontrámos uma conversa idêntica. Podes abrir a existente para evitar uma transferência em duplicado.',
    conversationImportDuplicateQuestion: 'O que quer fazer?',
    conversationImportDuplicateUseExisting: 'Usar a conversa existente',
    conversationImportDuplicateImportAnyway: 'Importar novamente',
    conversationImportDropHint: 'Carregue o seu ficheiro .zip aqui, ou',
    conversationImportDropFormats: '.zip completo recomendado: não o abra (fotos e media incluídos)',
    conversationImportJsonOnlyHint: 'Apenas ficheiro .json: fotos e media não serão incluídos. Para um livro ilustrado, carregue o .zip completo sem o abrir. Se o navegador já extraiu o arquivo, comprima a pasta « messages » em .zip.',

    conversationInstagramImportIntro: 'Exporte as suas mensagens do Instagram em 3 passos:',
    conversationInstagramImportDemoTitle: 'Exporte as suas mensagens Instagram',
    conversationInstagramImportDemoExportMeta: 'Exportar para dispositivo · JSON',
    conversationInstagramImportDemoDownloadsAvailable: 'Transferências disponíveis',
    conversationInstagramImportDemoStartExport: 'Iniciar exportação',
    conversationInstagramImportDemoCustomizeMessages: 'Só mensagens',
    conversationInstagramImportDemoCustomize: 'Personalizar informações',
    conversationInstagramImportDemoConfirmTitle: 'Confirmar exportação',
    conversationInstagramImportDemoSave: 'Guardar',
    conversationInstagramImportDemoMessagesTip: 'Opcional mas mais rápido: apagar tudo, depois só Mensagens.',
    conversationInstagramImportDemoDataPayments: 'Pagamentos',
    conversationInstagramImportDemoDataComments: 'Comentários',
    conversationInstagramImportDemoClearAll: 'Apagar tudo',
    conversationInstagramImportDemoActivitySection: 'A sua atividade no Instagram',
    conversationInstagramImportDemoPickSpecific: 'Escolher informações específicas para exportar',
    conversationInstagramImportDemoExportExternal: 'Exportar para serviço externo',
    conversationInstagramImportDemoExportDevice: 'Exportar para o meu dispositivo',
    conversationInstagramImportDemoChooseDestination: 'Escolha onde exportar',
    conversationInstagramImportDemoProfileAccount: 'A sua conta · Instagram',
    conversationInstagramImportDemoProfileName: 'O nome da sua conta',
    conversationInstagramImportDemoAccountShort: 'A sua conta',
    conversationInstagramImportDemoProfiles: 'Perfis',
    conversationInstagramImportDemoChooseProfile: 'Escolha um perfil',
    conversationInstagramImportDemoPastActivity: 'Atividade passada',
    conversationInstagramImportDemoCurrentActivity: 'Atividade em curso',
    conversationInstagramImportDemoCreateExport: 'Criar exportação',
    conversationInstagramImportDemoExportIntro: 'Crie uma cópia das suas informações para transferir para o dispositivo.',
    conversationInstagramImportDemoExportTitle: 'Exportar as suas informações',
    conversationInstagramImportDemoCaptionStart: 'Toque em Iniciar exportação',
    conversationInstagramImportDemoCaptionDevice: 'Toque em Exportar para o meu dispositivo',
    conversationInstagramImportDemoCaptionProfile: 'Escolha o seu perfil Instagram',
    conversationInstagramImportDemoCaptionCreate: 'Toque em Criar exportação',
    conversationInstagramImportDemoCaptionMessages: 'Dica: Apagar tudo, depois só Mensagens (mais rápido)',
    conversationInstagramImportDemoCaptionJson: 'Escolha formato JSON, depois Guardar',
    conversationInstagramImportDemoCaptionDrop: 'Transfira o .zip quando estiver pronto e carregue-o abaixo',
    conversationInstagramImportDemoPlatform: 'Instagram',
    conversationInstagramImportDemoDataMessages: 'Mensagens',
    conversationInstagramImportDemoFormat: 'Formato',
    conversationInstagramImportDemoMediaQuality: 'Qualidade multimédia',
    conversationInstagramImportDemoQualityLow: 'Baixa',
    conversationInstagramImportDemoJsonNotice: 'JSON obrigatório para o livro. HTML não funciona.',
    conversationInstagramImportDemoReadyHint: 'Deposite o .zip completo abaixo sem o abrir. Escolherá a conversa depois.',
    conversationInstagramImportCta: 'Abrir as definições do Instagram',
    conversationInstagramImportStep1: 'Toque em <b>Criar exportação</b>, escolha o perfil <b>Instagram</b>, depois <b>Exportar para o meu dispositivo</b>.',
    conversationInstagramImportStep2: 'Dica para ir mais depressa: <b>Apagar tudo</b>, marque apenas <b>Mensagens</b>. Escolha formato <b>JSON</b> e qualidade <b>Baixa</b>.',
    conversationInstagramImportStep3: 'Toque em <b>Iniciar exportação</b>, aguarde o email (10 min a 24 h), transfira o <b>.zip</b> e carregue-o abaixo <b>sem o abrir</b>: escolherá a conversa <b>depois</b>.',
    conversationInstagramImportAlert: 'Formato <b>JSON</b> obrigatório (não HTML). Dica: exportar só <b>Mensagens</b> é mais rápido, mas não é obrigatório.',
    conversationInstagramImportDetailTitle: 'Exportação Instagram: guia detalhado',
    conversationInstagramImportDetailIntro: 'Siga cada passo com as capturas abaixo. O botão acima abre diretamente a página de exportação.',
    conversationInstagramImportDetailSkipApp: 'Já abri a página com o botão: avançar para o passo 5',
    conversationInstagramImportDetailStep1: 'Abra a aplicação <b>Instagram</b> e aceda às <b>Definições</b> através dos três pontos no canto superior direito.',
    conversationInstagramImportDetailStep2: 'Selecione <b>Centro de contas</b>.',
    conversationInstagramImportDetailStep3: 'Toque em <b>As suas informações e permissões</b>.',
    conversationInstagramImportDetailStep4: 'Escolha <b>Exportar as suas informações</b>.',
    conversationInstagramImportDetailStep5: 'Vá a <b>Descarregar ou transferir informações</b>. Se usou o botão acima, já está nesta página.',
    conversationInstagramImportDetailStep6: 'Selecione <b>Instagram</b>. Este passo pode não aparecer em algumas contas.',
    conversationInstagramImportDetailStep7: 'Escolha <b>Algumas das suas informações</b>.',
    conversationInstagramImportDetailStep8: 'Deslize até <b>Mensagens</b>, selecione e toque em <b>Seguinte</b>.',
    conversationInstagramImportDetailStep9: 'Toque em <b>Transferir para o dispositivo</b>.',
    conversationInstagramImportDetailStep10: 'Escolha o período desejado, o formato <b>JSON</b> e uma qualidade multimédia <b>baixa</b> para uma transferência mais rápida.',
    conversationInstagramImportDetailStep11: 'O seu arquivo estará pronto em <b>10 minutos a 24 horas</b>. Receberá um e-mail quando estiver disponível: também pode encontrá-lo na página do Centro de contas.',
    conversationInstagramImportDetailStep12: 'Transfira o ficheiro <b>.zip</b> completo para o seu dispositivo e carregue-o abaixo <b>sem o abrir</b>. Apenas a conversa que escolher depois será usada para o seu livro.',

    conversationKakaotalkImportIntro: 'Tudo começa no telemóvel. Está no iPhone ou no Android?',
    conversationKakaotalkImportPlatformIphone: 'iPhone',
    conversationKakaotalkImportPlatformAndroid: 'Android',
    conversationKakaotalkImportIphoneStep1: 'No seu iPhone, abra o <b>KakaoTalk</b> e a conversa que quer no livro.',
    conversationKakaotalkImportIphoneStep2: 'Toque no <b>menu</b> (☰) no canto superior direito e depois no ícone de <b>definições</b> no fim do painel.',
    conversationKakaotalkImportIphoneStep3: 'Toque em <b>Exportar a conversa</b> e escolha <b>Enviar apenas as mensagens de texto</b>.',
    conversationKakaotalkImportIphoneStep4: 'Guarde o ficheiro <b>.txt</b> (Ficheiros, email, AirDrop) e largue-o abaixo <b>sem o editar</b>.',
    conversationKakaotalkImportAndroidStep1: 'No seu telemóvel, abra o <b>KakaoTalk</b> e a conversa que quer no livro.',
    conversationKakaotalkImportAndroidStep2: 'Toque no <b>menu</b> (☰) no canto superior direito e depois no ícone de <b>definições</b> no fim do painel.',
    conversationKakaotalkImportAndroidStep3: 'Toque em <b>Exportar a conversa</b> e escolha <b>Enviar apenas o texto</b>.',
    conversationKakaotalkImportAndroidStep4: 'Guarde o ficheiro <b>.txt</b> (Ficheiros, Google Drive, email) e largue-o abaixo <b>sem o editar</b>.',
    conversationKakaotalkImportAlert: 'Uma conversa por exportação. A outra opção também guarda as suas fotos, mas o KakaoTalk não as liga às mensagens: escolha apenas o texto, as fotos aparecem como uma simples palavra.',
    conversationKakaotalkImportDesktopNote: 'No computador (Windows ou Mac): abra o menu da conversa e depois <b>Guardar a conversa</b>. O ficheiro <b>.txt</b> obtido também funciona aqui.',
    conversationLineImportIntro: 'Tudo começa no telemóvel. Está no iPhone ou no Android?',
    conversationLineImportPlatformIphone: 'iPhone',
    conversationLineImportPlatformAndroid: 'Android',
    conversationLineImportIphoneStep1: 'No seu iPhone, abra o <b>LINE</b> e a conversa que quer no livro.',
    conversationLineImportIphoneStep2: 'No topo do chat, toque no <b>menu</b> (☰) → <b>Definições</b>.',
    conversationLineImportIphoneStep3: 'Toque em <b>Exportar histórico do chat</b> e escolha como enviar o ficheiro (Ficheiros, email, AirDrop).',
    conversationLineImportIphoneStep4: 'Guarde o ficheiro <b>.txt</b> e largue-o abaixo <b>sem o editar</b>.',
    conversationLineImportAndroidStep1: 'No seu telemóvel, abra o <b>LINE</b> e a conversa que quer no livro.',
    conversationLineImportAndroidStep2: 'No topo do chat, toque no <b>menu</b> (☰) → <b>Definições</b>.',
    conversationLineImportAndroidStep3: 'Toque em <b>Exportar histórico do chat</b> e escolha como enviar o ficheiro (Ficheiros, Google Drive, email).',
    conversationLineImportAndroidStep4: 'Guarde o ficheiro <b>.txt</b> e largue-o abaixo <b>sem o editar</b>.',
    conversationLineImportAlert: 'Uma conversa por exportação. Só são guardadas as mensagens atualmente visíveis no chat e o LINE não exporta fotos nem stickers como imagens.',
    conversationLineImportDesktopNote: 'No computador (Windows ou Mac): abre <b>Chats</b>, faz duplo clique na conversa e usa o <b>menu</b> no topo → <b>Guardar chat</b>. Esta exportação não existe no LINE para Chrome.',

    conversationLinkedinImportIntro: '3 passos para exportar as suas conversas LinkedIn:',
    conversationLinkedinImportCta: 'Abrir a página de exportação do LinkedIn',
    conversationLinkedinImportStep1: 'Num <b>navegador web</b> (computador ou telemóvel), abra a página acima. Caso contrário: <b>Eu</b> → <b>Definições e privacidade</b> → <b>Privacidade dos dados</b> → <b>Obter uma cópia dos seus dados</b>.',
    conversationLinkedinImportStep2: 'Peça um arquivo que inclua as suas <b>Mensagens</b>: marque o ficheiro <b>Mensagens</b>, ou escolha o arquivo completo, e clique em <b>Pedir arquivo</b>.',
    conversationLinkedinImportStep3: 'Descarregue o <b>.zip</b> a partir do email do LinkedIn (10 min a 24 h) e largue-o abaixo <b>sem o abrir</b>: escolherá a conversa <b>depois</b> do envio.',
    conversationLinkedinImportAlert: 'Esta exportação não existe na app móvel do LinkedIn: usa um navegador. O arquivo tem de conter o ficheiro <b>messages.csv</b> (o LinkedIn não exporta fotos nem anexos).',

    conversationSnapchatImportIntro: '3 passos para exportar as suas conversas Snapchat:',
    conversationSnapchatImportCta: 'Abrir Os meus dados Snapchat',
    conversationSnapchatImportStep1: 'Na app: avatar → definições (engrenagem) → <b>Privacidade</b> → <b>Os meus dados</b>. Também pode usar a ligação acima.',
    conversationSnapchatImportStep2: 'Inicie sessão se necessário, depois toque em <b>Enviar um pedido</b> no final: o Snapchat enviar-lhe-á um email quando o arquivo estiver pronto (algumas horas a 1 dia).',
    conversationSnapchatImportStep3: 'Descarregue o <b>.zip</b> do email, depois carregue-o abaixo <b>sem o abrir</b>: escolherá a conversa <b>depois</b> do carregamento.',
    conversationSnapchatImportAlert: 'Arquivo <b>.zip</b> completo obrigatório: não o abra. As suas mensagens serão impressas no livro (a exportação Snapchat não inclui fotos imprimíveis).',
    conversationSnapchatPlaceholderMedia: '[Media]',
    conversationSnapchatPlaceholderNote: '[Nota de voz]',
    conversationSnapchatPlaceholderSticker: '[Sticker]',
    conversationSnapchatPlaceholderSnap: '[Snap]',
    conversationSnapchatPlaceholderAudio: '[Áudio]',
    conversationSnapchatStatusParticipantAdded: 'Um membro foi adicionado ao grupo',
    conversationSnapchatStatusNameChanged: 'O nome do grupo mudou',
    conversationSnapchatStatusConversationCreated: 'Conversa criada',
    conversationSnapchatStatusGeneric: 'Notificação Snapchat',
    conversationSnapchatImportPartialContent: '{withText} mensagens com texto em {total}. O Snapchat não exporta o conteúdo das mensagens não guardadas.',
    conversationSnapchatImportDetailTitle: 'Exportação Snapchat: guia detalhado',
    conversationSnapchatImportDetailIntro: 'Siga cada passo com as capturas abaixo. Também pode usar o botão acima para abrir Os meus dados diretamente e começar no passo 4.',
    conversationSnapchatImportDetailSkipApp: 'Já abri a página com o botão: avançar para o passo 4',
    conversationSnapchatImportDetailStep1: 'Abra o <b>Snapchat</b> e toque na sua foto de perfil.',
    conversationSnapchatImportDetailStep2: 'Toque no ícone da <b>engrenagem</b> para abrir as definições.',
    conversationSnapchatImportDetailStep3: 'Deslize até <b>Ações da conta</b> e toque em <b>Os meus dados</b>. Também pode usar o botão acima.',
    conversationSnapchatImportDetailStep4: 'Marque <b>Histórico de conversas</b>, escolha os formatos <b>JSON</b> e <b>HTML</b>, depois toque em <b>Seguinte</b>.',
    conversationSnapchatImportDetailStep5: 'Escolha o período desejado, confirme o seu e-mail e toque em <b>Enviar</b>.',
    conversationSnapchatImportDetailStep6: 'O Snapchat enviar-lhe-á um e-mail quando a exportação estiver pronta: pode demorar algumas horas a vários dias.',
    conversationSnapchatImportDetailStep7: 'Quando receber o e-mail, clique na ligação para aceder aos seus dados.',
    conversationSnapchatImportDetailStep8: 'No Snapchat, toque em <b>Ver exportação</b>, depois em <b>Transferir</b>.',
    conversationSnapchatImportDetailStep9: 'Transfira o ficheiro <b>.zip</b> completo para o seu dispositivo e carregue-o abaixo <b>sem o abrir</b>. Apenas a conversa que escolher depois será usada para o seu livro.',

    conversationTelegramImportIntro: '4 passos para exportar uma conversa Telegram:',
    conversationTelegramImportCta: 'Descarregar Telegram Desktop',
    conversationTelegramImportStep1: 'No PC, instale o <b>Telegram Desktop</b>. No Mac, não use a aplicação « Telegram » da App Store: descarregue o <b>Telegram Desktop</b> pela ligação acima (na App Store chama-se Telegram Lite). Depois abra a conversa que quer transformar em livro.',
    conversationTelegramImportStep2: 'Clica nos <b>três pontos</b> no canto superior direito → <b>Exportar histórico do chat</b>.',
    conversationTelegramImportStep3: 'Marque <b>fotos, vídeos e ficheiros</b>, escolha o formato <b>JSON</b> (o HTML também serve), depois clique em <b>Exportar</b> e espere que a transferência termine.',
    conversationTelegramImportStep4: 'Comprima a pasta exportada em <b>.zip</b> (clique direito → comprimir), depois carregue-a abaixo <b>sem a abrir</b>: confirmará as opções <b>depois</b> do carregamento.',
    conversationTelegramImportAlert: 'Uma conversa de cada vez. Inclui <b>media</b> na exportação para um livro ilustrado: carrega o <b>.zip</b> completo, tal como está.',
    conversationTelegramImportDetailTitle: 'Exportação Telegram: guia detalhado',
    conversationTelegramImportDetailIntro: 'Siga cada passo com as capturas abaixo. Use o botão acima para transferir o Telegram Desktop, ou avance para o passo 2 se já o tiver instalado.',
    conversationTelegramImportDetailSkipApp: 'Já tenho o Telegram Desktop: avançar para o passo 2',
    conversationTelegramImportDetailStep1: 'No PC, o <b>Telegram Desktop</b> é a aplicação certa. No Mac, descarregue o <b>Telegram Desktop</b> pela ligação acima: a app « Telegram » da App Store não exporta conversas. Na App Store, o programa certo chama-se <b>Telegram Lite</b>.',
    conversationTelegramImportDetailStep2: 'Abra a <b>conversa</b> que pretende transformar em livro.',
    conversationTelegramImportDetailStep3: 'Clique nos <b>três pontos</b> no canto superior direito, depois em <b>Exportar histórico do chat</b>.',
    conversationTelegramImportDetailStep4: 'Selecione <b>todos os tipos de ficheiro</b> (fotos, vídeos, mensagens de voz, etc.), defina o tamanho máximo para <b>1500 MB</b> e escolha o formato <b>JSON</b>. Se não aparecer a escolha de formato, o HTML também funciona.',
    conversationTelegramImportDetailStep5: 'Clique em <b>Exportar</b> no canto inferior direito para iniciar a exportação.',
    conversationTelegramImportDetailStep6: 'No telemóvel, toque em <b>Autorizar</b> se for pedido. Comprima a pasta exportada em <b>.zip</b> e carregue-a abaixo <b>sem a abrir</b>: confirmará as opções após o carregamento.',

    conversationImportDetectedPlatform: 'Estes passos são para {platform}. As outras opções continuam disponíveis.',
    conversationWhatsappImportIntro: 'Tudo começa no telemóvel. Está no iPhone ou no Android?',
    conversationWhatsappImportPlatformIphone: 'iPhone',
    conversationWhatsappImportPlatformAndroid: 'Android',
    conversationWhatsappImportIphoneStep1: 'Abra a conversa, toque no <b>nome no topo</b> e depois em <b>Exportar conversa</b>.',
    conversationWhatsappImportIphoneStep2: 'Escolha <b>Anexar ficheiros</b> para fotos no livro (ou <b>Sem ficheiros</b> só texto).',
    conversationWhatsappImportIphoneStep3: 'Guarde em <b>Ficheiros</b> e solte o <b>.zip</b> abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportIphoneStep4: '<b>Com media</b> para fotos no livro, <b>sem media</b> só mensagens: guarde o ficheiro no computador ou telemóvel e carregue-o abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportAndroidStep1: 'Abra a conversa, toque em <b>⋮</b> → <b>Mais</b> → <b>Exportar conversa</b>.',
    conversationWhatsappImportAndroidStep2: 'Escolha <b>Incluir media</b> para fotos no livro (ou <b>Sem media</b> só texto).',
    conversationWhatsappImportAndroidStep3: 'Guarde ou partilhe o ficheiro e carregue o <b>.zip</b> abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportAndroidStep4: 'Guarde o ficheiro (Ficheiros, Google Drive ou email), leve-o para o computador ou telemóvel e carregue-o abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportAlert: 'Uma conversa por exportação. Prefira <b>Anexar ficheiros</b> para um livro ilustrado. Fique nesta página até ao fim.',
    conversationWhatsappImportAlertAndroid: 'Uma conversa por exportação. Prefere <b>Incluir media</b>. Em alguns telemóveis só funciona o email: usa então <b>Sem media</b>. Fica nesta página até ao fim.',
    conversationWhatsappImportIphoneDetailTitle: 'Exportação WhatsApp no iPhone: guia detalhado',
    conversationWhatsappImportIphoneDetailIntro: 'Siga cada passo no seu iPhone com as capturas abaixo, depois transfira o ficheiro para o computador ou telemóvel antes de o carregar aqui.',
    conversationWhatsappImportIphoneDetailStep1: 'Abra o <b>WhatsApp</b> e a conversa que pretende transformar em livro.',
    conversationWhatsappImportIphoneDetailStep2: 'Toque no <b>nome do contacto</b> ou do grupo no topo do ecrã.',
    conversationWhatsappImportIphoneDetailStep3: 'Deslize até ao fundo da página até ver <b>Exportar conversa</b>.',
    conversationWhatsappImportIphoneDetailStep4: 'Toque em <b>Exportar conversa</b>.',
    conversationWhatsappImportIphoneDetailStep5: 'Escolha <b>Com media</b> para um livro ilustrado, ou <b>Sem media</b> apenas para mensagens.',
    conversationWhatsappImportIphoneDetailStep6: 'Guarde o ficheiro no computador ou telemóvel (ex. em Ficheiros), depois carregue-o abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportAndroidDetailTitle: 'Exportação WhatsApp no Android: guia detalhado',
    conversationWhatsappImportAndroidDetailIntro: 'Siga cada passo no seu Android com as capturas abaixo, depois transfira o ficheiro para o computador ou telemóvel antes de o carregar aqui.',
    conversationWhatsappImportAndroidDetailStep1: 'Abra o <b>WhatsApp</b> e a conversa a transformar em livro.',
    conversationWhatsappImportAndroidDetailStep2: 'Toque em <b>⋮</b> (canto superior direito) → <b>Mais</b> → <b>Exportar conversa</b>.',
    conversationWhatsappImportAndroidDetailStep3: 'Escolha <b>Incluir media</b> para incluir fotos, ou <b>Sem media</b> só para mensagens.',
    conversationWhatsappImportAndroidDetailStep4: 'Guarde o ficheiro (Ficheiros, Google Drive ou email), leve-o para o computador ou telemóvel e carregue-o abaixo <b>sem o abrir</b>.',
    conversationWhatsappImportDemoTitle: 'Exporte a sua conversa WhatsApp',
    conversationWhatsappImportDemoIndividual: 'Conversa individual',
    conversationWhatsappImportDemoGroup: 'Conversa de grupo',
    conversationWhatsappImportDemoCaptionOpen: 'Abra a conversa no WhatsApp',
    conversationWhatsappImportDemoCaptionTapName: 'Toque no nome no topo',
    conversationWhatsappImportDemoCaptionExport: 'Desça e toque em Exportar conversa',
    conversationWhatsappImportDemoCaptionMedia: 'Escolha Anexar ficheiros para fotos no livro',
    conversationWhatsappImportDemoCaptionSave: 'Guarde em Ficheiros e solte abaixo',
    conversationWhatsappImportDemoExportLabel: 'Exportar conversa',
    conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
    conversationWhatsappImportDemoAttachMedia: 'Anexar ficheiros',
    conversationWhatsappImportDemoWithoutMedia: 'Sem ficheiros',
    conversationWhatsappImportDemoSaveFiles: 'Guardar em Ficheiros',
    conversationWhatsappImportDemoA11y: 'Guia animado: abra a conversa, toque no nome, exporte, escolha Anexar ficheiros e guarde em Ficheiros.',
    conversationWhatsappImportDemoCaptionExportGroup: 'Abra o menu ⋯ e toque em Exportar conversa',
    conversationWhatsappImportDemoContactName: 'Léa',
    conversationWhatsappImportDemoContactMom: 'Mãe',
    conversationWhatsappImportDemoGroupName: 'Fim de semana',
    conversationWhatsappImportDemoGroupWork: 'Work: design',
    conversationWhatsappImportDemoChats: 'Conversas',
    conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
    conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
    conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
    conversationWhatsappImportDemoSeeAll: 'See all ›',
    conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
    conversationWhatsappImportDemoAddList: 'Add to a list',
    conversationWhatsappImportDemoClearChat: 'Limpar conversa',
    conversationWhatsappImportDemoBlock: 'Block',
    conversationWhatsappImportDemoParticipants: '{count} participants',
    conversationWhatsappImportDemoAudio: 'Audio',
    conversationWhatsappImportDemoVideo: 'Video',
    conversationWhatsappImportDemoAdd: 'Add',
    conversationWhatsappImportDemoSearch: 'Search',
    conversationWhatsappImportDemoMemberYou: 'You',
    conversationWhatsappImportDemoMemberAlex: 'Alex',
    conversationWhatsappImportDemoMemberCamille: 'Camille',
    conversationWhatsappImportDemoEditGroup: 'Edit group info',
    conversationWhatsappImportDemoEditDescription: 'Edit description',
    conversationWhatsappImportAndroidDemoIncludeMedia: 'Incluir media',
    conversationWhatsappImportAndroidDemoWithoutMedia: 'Sem media',
    conversationWhatsappImportAndroidDemoMediaNotice: 'Incluir media para um livro ilustrado. Sem media é mais leve.',
    conversationWhatsappImportAndroidDemoClear: 'Limpar conversa',
    conversationWhatsappImportAndroidDemoExport: 'Exportar conversa',
    conversationWhatsappImportAndroidDemoReport: 'Denunciar',
    conversationWhatsappImportAndroidDemoMore: 'Mais',
    conversationWhatsappImportAndroidDemoWallpaper: 'Papel de parede',
    conversationWhatsappImportAndroidDemoMute: 'Silenciar notificações',
    conversationWhatsappImportAndroidDemoOnline: 'online',
    conversationWhatsappImportAndroidDemoCaptionSave: 'Guarde ou partilhe o ficheiro e carregue-o abaixo',
    conversationWhatsappImportAndroidDemoCaptionMedia: 'Escolha Incluir media para fotos no livro',
    conversationWhatsappImportAndroidDemoCaptionExport: 'Toque em Mais, depois Exportar conversa',
    conversationWhatsappImportAndroidDemoCaptionMenu: 'Toque no menu no canto superior direito',
    conversationWhatsappImportAndroidDemoCaptionOpen: 'Abra a conversa no WhatsApp',
    conversationWhatsappImportAndroidDemoTitle: 'Exporte a sua conversa WhatsApp no Android',
    conversationWhatsappImportAndroidDemoShareHint: 'Depois carregue o .zip abaixo sem o abrir.',
    conversationWhatsappImportAndroidDemoFiles: 'Ficheiros',
    conversationWhatsappImportAndroidDemoShareVia: 'Enviar para…',

    conversationMessengerImportIntro: 'Comece por <b>Depois de 2023</b>: conversas encriptadas, no Messenger.com. Passe a <b>Antes de 2023</b> se a sua não estiver lá.',
    conversationMessengerImportContext: 'Uma conversa começada antes de 2023 pode continuar depois de ativar a encriptação. O Messenger divide-a então em dois arquivos. Importe os dois e una-os na sua lista de conversas.',
    conversationMessengerImportPlatformClassic: 'Antes de 2023',
    conversationMessengerImportPlatformEncrypted: 'Depois de 2023',
    conversationMessengerImportClassicCta: 'Abrir a Meta para exportar',
    conversationMessengerClassicImportDemoReadyHint: 'Deposite o .zip completo abaixo sem o abrir. Escolherá a conversa depois.',
    conversationMessengerClassicImportDemoExportMeta: 'Exportar para dispositivo · JSON',
    conversationMessengerClassicImportDemoDownloadsAvailable: 'Transferências disponíveis',
    conversationMessengerClassicImportDemoStartExport: 'Iniciar exportação',
    conversationMessengerClassicImportDemoQualityLow: 'Baixa',
    conversationMessengerClassicImportDemoMediaQuality: 'Qualidade multimédia',
    conversationMessengerClassicImportDemoCustomizeMessages: 'Só mensagens',
    conversationMessengerClassicImportDemoCustomize: 'Personalizar informações',
    conversationMessengerClassicImportDemoConfirmTitle: 'Confirmar exportação',
    conversationMessengerClassicImportDemoJsonNotice: 'JSON obrigatório para o livro. HTML não funciona.',
    conversationMessengerClassicImportDemoFormat: 'Formato',
    conversationMessengerClassicImportDemoSave: 'Guardar',
    conversationMessengerClassicImportDemoMessagesTip: 'Opcional mas mais rápido: apagar tudo, depois só Mensagens.',
    conversationMessengerClassicImportDemoDataMessages: 'Mensagens',
    conversationMessengerClassicImportDemoDataPayments: 'Pagamentos',
    conversationMessengerClassicImportDemoDataComments: 'Comentários',
    conversationMessengerClassicImportDemoClearAll: 'Apagar tudo',
    conversationMessengerClassicImportDemoPickSpecific: 'Escolher informações específicas para exportar',
    conversationMessengerClassicImportDemoExportExternal: 'Exportar para serviço externo',
    conversationMessengerClassicImportDemoExportDevice: 'Exportar para o meu dispositivo',
    conversationMessengerClassicImportDemoChooseDestination: 'Escolha onde exportar',
    conversationMessengerClassicImportDemoAccountShort: 'A sua conta',
    conversationMessengerClassicImportDemoProfileName: 'O nome da sua conta',
    conversationMessengerClassicImportDemoProfiles: 'Perfis',
    conversationMessengerClassicImportDemoChooseProfile: 'Escolha um perfil',
    conversationMessengerClassicImportDemoPastActivity: 'Atividade passada',
    conversationMessengerClassicImportDemoCurrentActivity: 'Atividade em curso',
    conversationMessengerClassicImportDemoCreateExport: 'Criar exportação',
    conversationMessengerClassicImportDemoExportIntro: 'Crie uma cópia das suas informações para transferir para o dispositivo.',
    conversationMessengerClassicImportDemoExportTitle: 'Exportar as suas informações',
    conversationMessengerClassicImportDemoCaptionDrop: 'Transfira o .zip quando estiver pronto e carregue-o abaixo',
    conversationMessengerClassicImportDemoCaptionStart: 'Toque em Iniciar exportação',
    conversationMessengerClassicImportDemoCaptionJson: 'Escolha formato JSON, depois Guardar',
    conversationMessengerClassicImportDemoCaptionMessages: 'Dica: Apagar tudo, depois só Mensagens (mais rápido)',
    conversationMessengerClassicImportDemoCaptionDevice: 'Toque em Exportar para o meu dispositivo',
    conversationMessengerClassicImportDemoCaptionCreate: 'Toque em Criar exportação',
    conversationMessengerClassicImportDemoActivitySection: 'A sua atividade no Facebook',
    conversationMessengerClassicImportDemoProfileAccount: 'A sua conta · Facebook',
    conversationMessengerClassicImportDemoPlatform: 'Facebook',
    conversationMessengerClassicImportDemoCaptionProfile: 'Escolha o seu perfil Facebook',
    conversationMessengerClassicImportDemoTitle: 'Exporte as conversas Messenger de antes de 2023',
    conversationMessengerEncryptedImportDemoTitle: 'Exporte as conversas Messenger de depois de 2023',
    conversationImportDemoBadgeMeta: 'Exemplo: faça isto na Meta, com o botão acima',
    conversationMessengerEncryptedImportDemoBadge: 'Exemplo: faça isto no Messenger.com, com o botão acima',
    conversationMessengerEncryptedImportDemoCaptionLogin: 'No computador, abra o Messenger.com e inicie sessão',
    conversationMessengerEncryptedImportDemoCaptionSettings: 'Clique na engrenagem no canto inferior esquerdo',
    conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Abra Privacidade e segurança',
    conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Escolha Conversas cifradas de ponta a ponta',
    conversationMessengerEncryptedImportDemoCaptionStorage: 'Abra Armazenamento de mensagens',
    conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Clique em Descarregar os dados do armazenamento de mensagens',
    conversationMessengerEncryptedImportDemoCaptionRange: 'Deixe Media marcado e escolha o período All time',
    conversationMessengerEncryptedImportDemoCaptionDrop: 'Clique em Descarregar o ficheiro e largue o .zip abaixo',
    conversationMessengerEncryptedImportDemoLandingTitle: 'Um espaço para conversas interessantes',
    conversationMessengerEncryptedImportDemoLandingText: 'O Messenger permite-lhe manter o contacto com as pessoas de quem gosta.',
    conversationMessengerEncryptedImportDemoContinueAs: 'Continuar como O seu nome',
    conversationMessengerEncryptedImportDemoSwitchAccount: 'Mudar de conta',
    conversationMessengerEncryptedImportDemoChats: 'Conversas',
    conversationMessengerEncryptedImportDemoSearch: 'Pesquisar no Messenger',
    conversationMessengerEncryptedImportDemoContactName: 'O seu contacto',
    conversationMessengerEncryptedImportDemoContactStatus: 'Ativo agora',
    conversationMessengerEncryptedImportDemoLockBadge: 'Cifrado de ponta a ponta',
    conversationMessengerEncryptedImportDemoMenuPreferences: 'Preferências',
    conversationMessengerEncryptedImportDemoMenuProfileName: 'Editar o nome do perfil',
    conversationMessengerEncryptedImportDemoMenuRestricted: 'Contas restritas',
    conversationMessengerEncryptedImportDemoMenuAccessibility: 'Acessibilidade',
    conversationMessengerEncryptedImportDemoMenuHelp: 'Ajuda',
    conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privacidade e segurança',
    conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Confirmações de leitura',
    conversationMessengerEncryptedImportDemoPrivacyReported: 'Conversas denunciadas',
    conversationMessengerEncryptedImportDemoPrivacyKeys: 'Verificar as chaves na conversa',
    conversationMessengerEncryptedImportDemoEncryptedTitle: 'Conversas cifradas de ponta a ponta',
    conversationMessengerEncryptedImportDemoEncryptedHint: 'Gerencie as definições das suas conversas cifradas de ponta a ponta',
    conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Alertas de segurança',
    conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Pré-visualizações',
    conversationMessengerEncryptedImportDemoStorageTitle: 'Armazenamento de mensagens',
    conversationMessengerEncryptedImportDemoStorageHint: 'Gerencie como guarda e acede ao histórico das suas conversas',
    conversationMessengerEncryptedImportDemoStorageIntro: 'As suas mensagens cifradas de ponta a ponta são guardadas de forma segura na sua cópia de segurança.',
    conversationMessengerEncryptedImportDemoStoragePin: 'Redefinir o código PIN',
    conversationMessengerEncryptedImportDemoStorageMethods: 'Gerir os métodos de segurança',
    conversationMessengerEncryptedImportDemoStorageRemember: 'Memorizar este navegador',
    conversationMessengerEncryptedImportDemoStorageDownload: 'Descarregar os dados do armazenamento de mensagens',
    conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Descarregue todas as suas mensagens e anexos cifrados de ponta a ponta.',
    conversationMessengerEncryptedImportDemoStorageAutoImport: 'Desativar as importações automáticas',
    conversationMessengerEncryptedImportDemoDownloadTitle: 'Descarregar os seus dados',
    conversationMessengerEncryptedImportDemoDownloadIntro: 'Pode descarregar a qualquer momento uma cópia de todas as suas mensagens e anexos cifrados de ponta a ponta.',
    conversationMessengerEncryptedImportDemoMediaTip: 'Deixe Media marcado, caso contrário o seu livro não terá nenhuma foto.',
    conversationMessengerEncryptedImportDemoFileNotice: 'A preparação do ficheiro pode levar alguns minutos.',
    conversationMessengerEncryptedImportDemoDownloadFile: 'Descarregar o ficheiro',
    conversationMessengerEncryptedImportDemoReadyHint: 'Largue o .zip completo abaixo sem o abrir. Escolherá a conversa depois.',
    conversationMessengerImportEncryptedCta: 'Abrir o Messenger.com para exportar',
    conversationMessengerImportClassicStep1: 'Toque em <b>Criar exportação</b>, escolha o perfil <b>Facebook</b>, depois <b>Exportar para o meu dispositivo</b>.',
    conversationMessengerImportClassicStep2: 'Dica para ir mais depressa: <b>Apagar tudo</b>, marque apenas <b>Mensagens</b>. Escolha formato <b>JSON</b> e qualidade <b>Baixa</b>.',
    conversationMessengerImportClassicStep3: 'Toque em <b>Iniciar exportação</b>, aguarde o email (10 min a 24 h), transfira o <b>.zip</b> e carregue-o abaixo <b>sem o abrir</b>: escolherá a conversa <b>depois</b>.',
    conversationMessengerImportClassicAlert: 'Conversa ausente? Mude para <b>Depois de 2023</b>. Formato <b>JSON</b> obrigatório (não HTML). Dica: exportar só <b>Mensagens</b> é mais rápido, mas não é obrigatório.',
    conversationMessengerImportEncryptedStep1: 'No computador, abra o <b>Messenger.com</b>, inicie sessão e clique na <b>engrenagem</b> no canto inferior esquerdo.',
    conversationMessengerImportEncryptedStep2: 'Vá a <b>Privacidade e segurança</b>, depois <b>Conversas cifradas de ponta a ponta</b>, depois <b>Armazenamento de mensagens</b>.',
    conversationMessengerImportEncryptedStep3: 'Clique em <b>Descarregar os dados do armazenamento de mensagens</b>. Deixe <b>Media</b> marcado e escolha o período <b>All time</b>.',
    conversationMessengerImportEncryptedStep4: 'Clique em <b>Descarregar o ficheiro</b> e largue o <b>.zip</b> abaixo <b>sem o abrir</b>: escolherá a conversa <b>depois</b> do envio.',
    conversationMessengerImportEncryptedAlert: 'Deixe <b>Media</b> marcado, caso contrário o seu livro não terá nenhuma foto. Conversa ausente? Mude para <b>Antes de 2023</b>.',
    conversationMessengerImportClassicDetailTitle: 'Exportação antes de 2023: guia detalhado',
    conversationMessengerImportClassicDetailIntro: 'Siga cada passo com as capturas abaixo. O botão acima abre diretamente a página de exportação.',
    conversationMessengerImportClassicDetailSkipApp: 'Já abri a página com o botão: avançar para o passo 5',
    conversationMessengerImportClassicDetailStep1: 'Abra a aplicação <b>Messenger</b> e aceda às <b>Definições</b> através dos três pontos.',
    conversationMessengerImportClassicDetailStep2: 'Toque no ícone da <b>engrenagem</b>.',
    conversationMessengerImportClassicDetailStep3: 'Selecione <b>Centro de contas</b>.',
    conversationMessengerImportClassicDetailStep4: 'Toque em <b>As suas informações e permissões</b>.',
    conversationMessengerImportClassicDetailStep5: 'Escolha <b>Transferir as suas informações</b>.',
    conversationMessengerImportClassicDetailStep6: 'Vá a <b>Descarregar ou transferir informações</b>. Se usou o botão acima, já está nesta página.',
    conversationMessengerImportClassicDetailStep7: 'Selecione <b>Facebook</b>. Este passo pode não aparecer em algumas contas.',
    conversationMessengerImportClassicDetailStep8: 'Escolha <b>Algumas das suas informações</b>.',
    conversationMessengerImportClassicDetailStep9: 'Marque apenas <b>Mensagens</b>, depois toque em <b>Seguinte</b>.',
    conversationMessengerImportClassicDetailStep10: 'Toque em <b>Transferir para o dispositivo</b>.',
    conversationMessengerImportClassicDetailStep11: 'Escolha o período desejado, o formato <b>JSON</b> e uma qualidade <b>baixa</b>. O seu arquivo estará pronto em <b>10 minutos a 24 horas</b>: receberá um e-mail.',
    conversationMessengerImportClassicDetailStep12: 'Transfira o ficheiro <b>.zip</b> completo para o seu dispositivo e carregue-o abaixo <b>sem o abrir</b>. Apenas a conversa que escolher depois será usada para o seu livro.',
    conversationMessengerImportEncryptedDetailTitle: 'Exportação depois de 2023: guia detalhado',
    conversationMessengerImportEncryptedDetailIntro: 'Siga cada passo com as capturas abaixo. Também pode usar o botão acima para abrir Messenger.com e começar no passo 2.',
    conversationMessengerImportEncryptedDetailSkipApp: 'Já estou no Messenger.com: avançar para o passo 2',
    conversationMessengerImportEncryptedDetailStep1: 'Num computador, abra <b>Messenger.com</b> e clique na sua foto de perfil no canto inferior esquerdo.',
    conversationMessengerImportEncryptedDetailStep2: 'Clique em <b>Privacidade e segurança</b>.',
    conversationMessengerImportEncryptedDetailStep3: 'Clique em <b>Conversas encriptadas de ponta a ponta</b>.',
    conversationMessengerImportEncryptedDetailStep4: 'Clique em <b>Armazenamento seguro</b>.',
    conversationMessengerImportEncryptedDetailStep5: 'Clique em <b>Transferir dados do armazenamento seguro</b>.',
    conversationMessengerImportEncryptedDetailStep6: 'Clique em <b>Transferir ficheiro</b>.',
    conversationMessengerImportEncryptedDetailStep7: 'Introduza a sua palavra-passe do Facebook e clique em <b>Confirmar</b>.',
    conversationMessengerImportEncryptedDetailStep8: 'Clique em <b>Transferir</b>. A preparação do ficheiro pode demorar alguns minutos.',
    conversationMessengerImportEncryptedDetailStep9: 'Transfira o ficheiro <b>.zip</b> completo para o seu computador e carregue-o abaixo <b>sem o abrir</b>. Apenas a conversa que escolher depois será usada para o seu livro.',
    conversationMessengerImportMissingTip: 'Conversa ausente da lista? Volte atrás e experimente a exportação <b>Depois de 2023</b>.',
    conversationMessengerImportEmptyTitle: 'Nenhuma conversa encontrada neste ficheiro',

    conversationSmsImportTagline: 'Sem ficheiro para carregar aqui: tudo passa pelo nosso software ou aplicação.',
    conversationSmsImportIntro: 'Sem envio de ficheiro nesta página. Tudo passa pelo nosso software (iPhone) ou aplicação (Android). Indique a sua configuração:',
    conversationSmsImportContext: 'A nossa app Android <b>não está na Google Play</b>: o acesso a SMS é restrito lá. Para a abrir, o Android e o Play Protect pedem uma confirmação.',
    conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
    conversationSmsImportPlatformIphonePc: 'iPhone + PC',
    conversationSmsImportPlatformAndroid: 'Android',
    conversationSmsImportMacCta: 'Descarregar software Mac',
    conversationSmsImportPcCta: 'Descarregar software PC',
    conversationSmsImportAndroidCta: 'Descarregar app Android',
    conversationSmsImportMacStep1: 'Descarregue o software Mac.',
    conversationSmsImportMacStep2: 'Instale-o e <b>deixe-se guiar</b>: o software indica-lhe os passos a seguir.',
    conversationSmsImportMacStep3: 'Escolha a <b>conversa</b> a enviar para a sua conta e permaneça no ecrã até ao fim da transferência.',
    conversationSmsImportMacStep4: 'Instale o software abaixo, conceda <b>acesso total ao disco</b> em Definições do sistema → Privacidade, depois escolha a conversa para enviar à sua conta.',
    conversationSmsImportMacHelp: 'Se o software não encontrar a cópia: Definições do sistema → Privacidade e segurança → <b>Acesso total ao disco</b> → adicione MonLivreSMS (desbloqueie o cadeado em baixo à esquerda).',
    conversationSmsImportMacAlert: 'Sem upload aqui: a transferência parte do software, que o guia no ecrã.',
    conversationSmsImportPcStep1: 'Descarregue o software PC.',
    conversationSmsImportPcHelp: 'No iTunes, confirme que <b>Encriptar cópia local</b> está desmarcado antes de clicar em <b>Cópia de segurança agora</b>. Guia visual acima.',
    conversationSmsImportHelpToggle: 'Precisa de ajuda mais detalhada?',
    conversationSmsImportPcStep2: 'Instale-o e <b>deixe-se guiar</b>: o software indica-lhe os passos a seguir.',
    conversationSmsImportPcStep3: 'Escolha a <b>conversa</b> a enviar para a sua conta e permaneça no ecrã até ao fim da transferência.',
    conversationSmsImportPcStep4: 'Instale o software abaixo, execute-o (autorize se o Windows avisar), depois escolha a conversa para enviar à sua conta.',
    conversationSmsImportPcAlert: 'Sem upload aqui: a transferência parte do software, que o guia no ecrã.',
    conversationSmsImportAndroidStep1: 'No Android, descarregue a nossa <b>app fora da loja</b> abaixo: o acesso a SMS não é permitido na Google Play.',
    conversationSmsImportAndroidStep2: 'Abra o ficheiro descarregado. Se o Android não permitir a instalação, toque em <b>Definições</b>, ative <b>Permitir desta fonte</b> e volte atrás.',
    conversationSmsImportAndroidStep3: 'Se o <b>Play Protect</b> aparecer, toque em <b>Mais detalhes</b> e depois em <b>Instalar mesmo assim</b>. Toque em seguida em <b>Instalar</b> e em <b>Abrir</b>.',
    conversationSmsImportAndroidStep4: 'Na app, aceite o acesso às <b>SMS</b> e aos <b>contactos</b>.',
    conversationSmsImportAndroidStep5: 'Escolha a <b>conversa</b> e confirme. Fique no ecrã até ao fim: as mensagens vão diretamente para a sua conta.',
    conversationSmsImportAndroidAlert: 'Sem ficheiro para largar aqui. Fique no ecrã de transferência na app para incluir todas as fotos.',
    conversationSmsImportFooter: 'Transferência concluída? Personalize o livro neste site: a app redireciona-o automaticamente.',
	conversationSmsImportAndroidDetailIntro: 'Siga cada passo no telemóvel Android. A app <b>não está no Google Play</b>. O Android e depois o Play Protect pedem uma confirmação antes de a abrir: é normal.',
	conversationSmsImportAndroidDetailSkipApp: 'Já transferi a aplicação: avançar para o passo 2',
	conversationSmsImportAndroidDetailStep1: 'Descarregue a nossa app de exportação SMS fora do Google Play (botão abaixo): o acesso SMS não é permitido na Play Store.',
	conversationSmsImportAndroidDetailStep2: 'Após o download, toque em <b>Abrir</b>.',
	conversationSmsImportAndroidDetailStep3: 'Toque em <b>Definições</b> para autorizar a instalação.',
	conversationSmsImportAndroidDetailStep4: 'Ative <b>Permitir desta fonte</b> e volte atrás para encontrar a instalação.',
	conversationSmsImportAndroidDetailStep5: 'Se o <b>Play Protect</b> aparecer, toque em <b>Mais detalhes</b> e depois em <b>Instalar mesmo assim</b>. Instale, abra a app e aceite o acesso às SMS e aos contactos.',
	conversationSmsImportAndroidDetailStep6: 'Selecione a <b>conversa</b> pretendida.',
	conversationSmsImportAndroidDetailStep7: 'Confirme e valide: permaneça no ecrã de transferência até ao fim para incluir todas as fotos. Será redirecionado automaticamente para personalizar o livro.',
	conversationSmsImportAndroidDetailTitle: 'Exportação SMS Android: guia detalhado',
	conversationSmsImportMacDetailIntro: 'Descarregue o software e deixe-se guiar no ecrã. As capturas abaixo ajudam sobretudo na instalação.',
	conversationSmsImportMacDetailSkipSoftware: 'Já transferi o programa: avançar para o passo 8',
	conversationSmsImportMacDetailStep1: 'Ligue o iPhone ao Mac com um cabo USB.',
	conversationSmsImportMacDetailStep10: 'Abra <b>Definições do sistema</b> → <b>Privacidade e segurança</b>.',
	conversationSmsImportMacDetailStep11: 'Deslize até ao fim e clique em <b>Abrir mesmo assim</b>.',
	conversationSmsImportMacDetailStep12: 'No aviso de segurança, clique em <b>Permitir</b>.',
	conversationSmsImportMacDetailStep13: 'Clique em <b>Abrir</b>.',
	conversationSmsImportMacDetailStep14: 'Clique em <b>Continuar</b>.',
	conversationSmsImportMacDetailStep15: 'Clique novamente em <b>Continuar</b>.',
	conversationSmsImportMacDetailStep16: 'Clique em <b>Instalar</b>.',
	conversationSmsImportMacDetailStep17: 'No aviso de segurança, clique novamente em <b>Permitir</b>.',
	conversationSmsImportMacDetailStep18: 'Clique em <b>Fechar</b> para sair do assistente.',
	conversationSmsImportMacDetailStep19: 'Abra <b>Finder</b> → <b>Aplicações</b> e execute <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Para fotos no livro: abra <b>Mensagens</b>, selecione a conversa e toque no <b>nome do contacto</b>.',
	conversationSmsImportMacDetailStep20: 'Clique no <b>menu Apple</b> no canto superior esquerdo → <b>Definições do sistema</b>.',
	conversationSmsImportMacDetailStep21: 'Abra <b>Privacidade e segurança</b> → <b>Acesso total ao disco</b>.',
	conversationSmsImportMacDetailStep22: 'Arraste o ícone MonLivreSMS para a lista (clique prolongado) e marque <b>Acesso total ao disco</b>.',
	conversationSmsImportMacDetailStep23: 'Clique em <b>Abrir</b> para confirmar.',
	conversationSmsImportMacDetailStep24: 'Clique novamente em <b>Abrir</b> se aparecer uma segunda confirmação.',
	conversationSmsImportMacDetailStep25: 'Escolha a <b>conversa</b> a exportar: textos e fotos serão enviados para a sua conta. Permaneça no ecrã de transferência até ao fim, com ligação estável.',
	conversationSmsImportMacDetailStep3: 'Deslize até ao fim da ficha do contacto.',
	conversationSmsImportMacDetailStep4: 'Toque em <b>Transferir</b> para importar todas as fotos iCloud para o iPhone.',
	conversationSmsImportMacDetailStep5: 'Abra o <b>Finder</b>, selecione o iPhone na barra lateral, desmarque <b>Encriptar cópia local</b> e active <b>Copiar todos os dados para este Mac</b>.',
	conversationSmsImportMacDetailStep6: 'Clique em <b>Copiar agora</b> e aguarde o fim da cópia.',
	conversationSmsImportMacDetailStep7: 'Descarregue o software MonLivreSMS para Mac (botão abaixo nesta página).',
	conversationSmsImportMacDetailStep8: 'Faça duplo clique na pasta <b>MonLivreSMS</b> descarregada.',
	conversationSmsImportMacDetailStep9: 'Clique em <b>OK</b> para iniciar a instalação.',
	conversationSmsImportMacDetailTitle: 'Exportação SMS iPhone + Mac: guia detalhado',
	conversationSmsImportPcDetailIntro: 'Descarregue o software e deixe-se guiar no ecrã. As capturas abaixo ajudam sobretudo na instalação.',
	conversationSmsImportPcDetailSkipSoftware: 'Já transferi o programa: avançar para o passo 3',
	conversationSmsImportPcDetailStep1: 'Ligue o iPhone ao PC com um cabo USB.',
	conversationSmsImportPcDetailStep2: 'Descarregue o software MonLivreSMS para PC (botão abaixo nesta página).',
	conversationSmsImportPcDetailStep3: 'Instale o <link>iTunes</link> se ainda não o tiver.',
	conversationSmsImportPcDetailStep4: 'Abra o iTunes.',
	conversationSmsImportPcDetailStep5: 'Inicie sessão com o seu <b>ID Apple</b> e valide no iPhone se solicitado.',
	conversationSmsImportPcDetailStep6: 'Quando o iPhone for reconhecido, clique em <b>Continuar</b>.',
	conversationSmsImportPcDetailStep7: 'Em <b>Resumo</b>, desmarque <b>Encriptar cópia local</b> e clique em <b>Copiar agora</b> (neste computador, não iCloud).',
	conversationSmsImportPcDetailStep8: 'Quando a cópia terminar, abra a pasta MonLivreSMS. Se o Windows mostrar um aviso, clique em <b>Mais informações</b> e depois <b>Executar mesmo assim</b>. Escolha a conversa para enviar para a sua conta.',
	conversationSmsImportPcDetailTitle: 'Exportação SMS iPhone + PC: guia detalhado',
    /* --- sync 2026-06-29 --- */
    autocompleteSearch: 'Escreva para pesquisar…',
    cmsAdminListHint: 'Editar páginas, painéis e traduções. As bandeiras indicam o estado de tradução por idioma.',
    cmsContentDuplicateSuccess: 'Conteúdo CMS duplicado!',
    cmsPageAdd: 'Adicionar uma página',
    code: 'Código',
    configAdminHint: 'Definições da aplicação, afiliações, processos em segundo plano e chaves de configuração.',
    console: 'Consola',
    conversationAdminListHint: 'Explorar, filtrar e gerir todas as conversas. Use os separadores de estado por etapa.',
    conversationBackToList: 'Voltar às minhas conversas',
    conversationCreationDate: 'Data de criação',
    conversationCustomImportUpload: 'Importar ficheiro gerado',
    conversationDownloadBackPreview: 'Voltar à pré-visualização',
    conversationDownloadEyebrow: 'O seu livro está pronto',
    conversationDownloadHint: 'Descarregue o PDF e guarde uma cópia digital da conversa.',
    conversationDownloadLoading: 'A preparar os ficheiros…',
    conversationFlags: 'Bandeiras',
    conversationHighlightShareImageButton: 'Enviar a imagem',
    conversationHighlightsEmpty: 'São precisas mais algumas mensagens para tirar os números.',
    conversationHighlightsLoading: 'A reunir os seus números.',
    conversationImages: 'Imagens',
    conversationMedias: 'Media',
    conversationMergeSelect: 'Selecionar esta conversa',
    conversationMergeUnselect: 'Desselecionar esta conversa',
    conversationOrders: 'Encomendas',
    conversationPreviewCoverEditButton: 'Editar capa',
    conversationPreviewCoverOpenLabel: 'Abrir o livro',
    conversationPreviewCustomizeClose: 'Fechar personalização',
    conversationPreviewCustomizeDone: 'Concluir personalização',
    conversationPreviewEditionBelowHint: 'Escolha a sua edição abaixo',
    conversationPreviewEditionScrollLabel: 'Ir à secção edição',
    conversationPrinterMode: 'Modo impressor',
    copiedToClipboard: 'Copiado!',
    country: 'País',
    dateStatus: 'Data de estado',
    dateValidation: 'Data de validação',
    dates: 'Datas',
    identifier: 'Identificador',
    loadMore: 'Carregar mais…',
    orderAdminListHint: 'Acompanhar e processar encomendas por estado. Filtrar por país, produto ou data de validação.',
    orderConfirmationGuestTitle: 'Mantenha-se informado',
    orderConfirmationHomeCta: 'Voltar ao início',
    orderConfirmationNextStepsTitle: 'E agora?',
    orderConfirmationOrderNumber: 'Encomenda n.º {code}',
    orderConfirmationPaymentWaitingHint: 'Isto demora normalmente apenas alguns segundos.',
    orderConfirmationStepEmail: 'Confirmação por email',
    orderConfirmationStepEmailDesc: 'Foi enviado um resumo para {email}',
    orderConfirmationStepEmailDescNoEmail: 'Receberá um resumo por email',
    orderConfirmationStepPreparation: 'Preparação do seu livro',
    orderConfirmationStepPreparationDesc: 'Imprimimos e encadernamos o seu livro com cuidado',
    orderConfirmationStepShipping: 'Expedição',
    orderConfirmationStepShippingDesc: 'Receberá um email assim que a encomenda for enviada',
    orderConfirmationSummaryTitle: 'A sua encomenda',
    orderConfirmationViewOrderCta: 'Acompanhar a minha encomenda',
    orderFlags: 'Bandeiras',
    orderMassExportInvoiceDetails: 'Exportar detalhe das faturas',
    orderMassSendEmail: 'Enviar email',
    orderMassUpdateStatus: 'Atualizar estado',
    orderNote: 'Nota',
    orderNoteAdmin: 'Nota interna (admin)',
    orderNoteAdminAdd: 'Adicionar uma nota',
    orderNoteAdminEmpty: 'Sem notas internas para esta encomenda.',
    orderNoteAdminPlaceholder: 'Nota interna visível apenas para a equipa (expedição, apoio…)',
    orderPaymentMethod: 'Método de pagamento',
    orderPublicAccess: 'Acesso público',
    orderSendStatusNotificationEmail: 'Enviar email de notificação',
    orderViewShort: 'Encomenda',
    ordersEditSuccess: 'Encomendas atualizadas!',
    product: 'Produto',
    productAdd: 'Adicionar um produto',
    productAdminListHint: 'Gerir catálogo, preços e disponibilidade da loja.',
    seoOrderViewTitle: 'Encomenda n.º {code}',
    shippingAdd: 'Adicionar um método',
    shippingAdminListHint: 'Configurar transportadoras, países e regras de preços para entregas.',
    shippingMethod: 'Método de envio',
    tableDownloadNoElementError: 'Nada para descarregar!',
    tablePageSize: 'Por página',
    taskAddTitle: 'Adicionar uma tarefa',
    taskAssignSelf: 'Atribuir a mim',
    taskCountdownDate: 'Data de lembrete',
    userAccountNote: 'Nota de conta de utilizador',
    userAdminListHint: 'Pesquisar contas, ver atividade e abrir perfil ou encomendas de um utilizador.',
    vatExempt: 'ISENTO DE IVA',
    voucherAdd: 'Adicionar um voucher',
    voucherAdminListHint: 'Criar e gerir códigos promo, condições e limites de utilização.',

	offerErrorRequired: 'Preencha os campos obrigatórios, por favor.',
	offerErrorEmail: 'Verifique o seu endereço de email.',
	offerErrorGiftEmail: 'Verifique o email da pessoa a quem o vai oferecer.',
	offerErrorGiftSameEmail: 'O email da pessoa que recebe o presente tem de ser diferente do seu.',
	offerErrorGeneric: 'Ups, algo correu mal. Tente novamente dentro de instantes.',
	offerStepWhoEyebrow: 'Vamos começar',
	offerStepWhoTitle: 'Quem vai criar o livro?',
	offerStepWhoHint: 'Compõe o livro, para si ou para oferecer. O cartão-presente é para quando a outra pessoa o cria.',
	offerWhoSelf: 'Vou criá-lo',
	offerWhoSelfHint: 'Para mim, ou para oferecer depois de impresso',
	offerWhoGift: 'Ofereço um cartão-presente',
	offerWhoGiftHint: 'A pessoa recebe um link e cria o livro',
	offerStepOccasionEyebrow: 'A ocasião',
	offerStepOccasionHint: 'O momento em que está a pensar.',
	offerStepGiftEyebrow: 'O seu presente',
	offerStepGiftTitle: 'A quem o vai oferecer?',
	offerStepGiftHint: 'Enviamos o presente por email, com um link para criar o livro. Nada para imprimir, nada para embrulhar.',
	offerGiftName: 'Nome da pessoa',
	offerGiftEmail: 'Email da pessoa',
	offerGiftEmailHelp: 'O presente chega a esta caixa de correio logo após o pagamento.',
	offerGiftFromName: 'O seu nome',
	offerGiftFromNameHelp: 'Para que a pessoa saiba de quem é o presente.',
	offerGiftMessage: 'Uma mensagem (opcional)',
	offerGiftMessagePlaceholder: 'Para que estas mensagens fiquem sempre perto de ti.',
	offerContinue: 'Continuar',
	offerStepMessengerEyebrow: 'As suas mensagens',
	offerStepMessengerTitleGift: 'Onde estão as mensagens do livro de {name}?',
	offerStepMessengerTitle: 'Onde estão as suas mensagens mais bonitas?',
	offerStepMessengerHint: 'Escolha uma. Poderá alterá-la mais tarde.',
	offerStepMessengerHintGift: 'A sua conversa com {name}, ou a de {name} com um ente querido. Dúvidas sobre a aplicação? {name} poderá escolher outra.',
	offerStepEmailEyebrow: 'Quase a terminar',
	offerStepEmailTitle: 'A sua conta',
	offerStepEmailHintGift: 'Google, Apple ou o seu e-mail. Enviamos uma confirmação e depois paga o cartão-presente.',
	offerStepEmailHint: 'Google, Apple ou o seu e-mail. Enviamos uma confirmação e depois importa a conversa.',
	offerStepEmailHintPay: 'Google, Apple ou o seu e-mail. Enviamos uma confirmação e depois paga o livro.',
	offerEmailLabel: 'Endereço de email',
	offerEmailPlaceholder: 'nome@exemplo.pt',
	offerEmailSubmit: 'Avançar para o pagamento',
	offerEmailSubmitAccount: 'Criar a minha conta',
	offerEmailPrivacy: 'Apenas o seu livro. Veja também a pasta de spam.',
	offerStepSentEyebrow: 'Olá de novo',
	offerStepSentTitle: 'Já tem uma conta',
	offerStepSentCodeHint: 'Acabámos de enviar um código de 6 dígitos para {email}. Introduza-o aqui: a sua encomenda está à sua espera, pronta a pagar. Veja também a pasta de spam.',
	offerStepSentCodeHintAccount: 'Acabámos de enviar um código de 6 dígitos para {email}. Introduza-o aqui para abrir a sua conta e começar o livro. Veja também a pasta de spam.',
	offerStepPayEyebrow: 'Último passo',
	offerStepPayTitleGift: 'O livro para {name}',
	offerStepPayTitle: 'O seu livro impresso',
	offerLoggedAs: 'Sessão iniciada como {email}',
	offerSwitchAccount: 'Não é a sua conta?',
	offerTrustReviews: 'Mais de {count} avaliações no Trustpilot',
	offerTrustGuarantee: 'Garantia de reembolso',
	offerTrustShipping: 'Envio gratuito',
	offerPageTitle: 'O seu livro de mensagens',
	offerBack: 'Voltar',
	offerItemName: 'Livro impresso para personalizar',
	offerPayBenefitBook: 'O seu livro impresso, paginado com as suas mensagens e fotos',
	offerPayBenefitBookGift: 'Um livro impresso a sério, com as mensagens e as fotos que escolher',
	offerPayBenefitMedia: 'Os áudios e os vídeos também, para reviver com os códigos QR impressos',
	offerPayBenefitCustom: 'Capa, foto, título, cores, prefácio: tudo se personaliza',
	offerPayBenefitPdf: 'O PDF oferecido com o livro',
	offerPayBenefitShipping: 'Envio gratuito',
	offerPayTotal: 'Total',
	offerPayNextGift: 'Logo após o pagamento, {name} recebe o seu presente por email.',
	offerPayNextSelf: 'Logo após o pagamento, importa a conversa. São poucos minutos.',
	offerPayDreamSelf: 'Aquelas mensagens que relê no telemóvel, em breve nas suas mãos. Para sempre.',
	offerPayDreamGift: 'No dia em que {name} o abrir, todas estas mensagens vão ganhar vida nas suas mãos.',
	offerPayButton: 'Pagar {price}',
	offerPaySecure: 'Pagamento seguro. Sem subscrição.',
	offerConfirmStepsTitle: 'Como funciona',
	offerConfirmGiftStep1: '{name} abre o email e clica no link',
	offerConfirmGiftStep2: '{name} importa a conversa em poucos minutos',
	offerConfirmGiftStep3: 'Imprimimos o livro e enviamo-lo',
	offerConfirmGiftTitle: 'Enviado para {name}!',
	offerConfirmGiftLead: '{name} acabou de receber o seu presente em {email}, com um link para criar o livro. Já está pago, com envio incluído.',
	offerConfirmViewOrder: 'Ver a minha encomenda',
	offerConfirmGiftNote: 'Não chegou? Peça à pessoa que verifique a pasta de spam, ou escreva-nos.',
	offerConfirmStep1: 'Exporte a sua conversa do {messenger}',
	offerConfirmStep1Generic: 'Exporte a sua conversa da sua aplicação de mensagens',
	offerConfirmStep2: 'Importe-a aqui: nós tratamos de toda a paginação',
	offerConfirmStep3: 'Valide o seu livro: imprimimo-lo e enviamo-lo para si',
	offerConfirmTitle: 'Está feito, o seu livro já está pago!',
	offerConfirmLead: 'Só falta uma coisa: importar a sua conversa do {messenger}. Acompanhamos cada passo e demora apenas alguns minutos.',
	offerConfirmLeadGeneric: 'Só falta uma coisa: importar a sua conversa. Acompanhamos cada passo e demora apenas alguns minutos.',
	offerConfirmCta: 'Importar a minha conversa do {messenger}',
	offerConfirmCtaGeneric: 'Importar a minha conversa',
	offerConfirmChangeMessenger: 'As minhas mensagens estão noutra aplicação',
	offerConfirmEmailNote: 'O seu recibo e o link de acesso foram enviados para {email}.',
	userMagicTitle: 'Iniciar sessão',
	userMagicWorking: 'A iniciar sessão…',
	userMagicExpired: 'Este link expirou. Peça um novo com um clique.',
	userMagicInvalid: 'Este link já não é válido. Peça um novo com um clique.',
	userMagicSent: 'Se existir uma conta com este endereço, um novo link está a caminho. Verifique também a pasta de spam.',
	userMagicEmailLabel: 'O seu endereço de email',
	userMagicSend: 'Receber um novo link',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Incluído',
	conversationPreviewCollectionPrepaidNote: '{count} volumes · {paid, plural, one {# já pago} other {# já pagos}}',
	conversationPreviewBookCreditBannerBestof: 'O seu livro já está pago: o Best Of está incluído. Prefere a coleção completa? Paga apenas a diferença.',
	conversationPreviewBookCreditBanner: 'O seu livro já está pago, com envio standard incluído. Personalize-o e depois conclua a sua encomenda.',
	conversationOrderButtonBookCreditRemaining: 'Concluir o meu livro · faltam {price}',
	conversationOrderButtonBookCreditIncluded: 'Concluir o meu livro · Incluído',
	conversationPreviewBookCreditOrderHint: '{credit} já pagos · preço de catálogo {fullPrice}',
	conversationOrderButtonBookCredit: 'Concluir o meu livro',
	conversationPreviewStickyBookCredit: 'Livro já pago',
	paymentMethodBookCreditHint: 'O seu livro já está pago',
	cartTotalsBookCredit: 'Livro já pago',
	paymentMethodBookcredit: 'Livro pago antecipadamente',
  },
};
